
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aQZ08", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $5izcQ = parcelRequire("5izcQ");


var $jmjWc = parcelRequire("jmjWc");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");


var $gz8ZY = parcelRequire("gz8ZY");


var $7EIq6 = parcelRequire("7EIq6");


var $gsXbX = parcelRequire("gsXbX");

const $dc1ea4817175b6dd$export$e961788b96f97626 = ()=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const onClick = (0, $42omo.useCallback)(()=>{
        setIsOpen(!isOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'globalCreateContentPopover',
                source: 'globalNavigation',
                attributes: {
                    selectedItemPageContext: match?.name,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: isNav4Enabled ? '4' : '3',
                    navdexPointType: (0, $56QzY.START),
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
    }, [
        setIsOpen,
        isOpen,
        createAnalyticsEvent,
        match,
        isOnEditRoute,
        isNav4Enabled
    ]);
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const popupContent = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader, {
            closePopup: ()=>setIsOpen(false),
            isCreateBlogEnabled: isCreateBlogEnabled,
            isCreateLiveDocEnabled: isCreateLiveDocEnabled,
            isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
            isCreateDatabaseEnabled: isCreateDatabaseEnabled,
            isCreateSmartLinkEnabled: isCreateSmartLinkEnabled
        }), [
        isCreateBlogEnabled,
        isCreateLiveDocEnabled,
        isCreateWhiteboardEnabled,
        isCreateDatabaseEnabled,
        isCreateSmartLinkEnabled
    ]);
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "space-types-changeboarding-target"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gsXbX.GlobalCreateContentButton), {
            onClick: onClick,
            triggerProps: triggerProps
        }))), [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: popupContent,
        trigger: popupTrigger,
        testId: "create-content-popover",
        shouldRenderToParent: true
    });
};

const $dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5t0g-",
    name: "GlobalCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("hkGNF"))).GlobalCreateContentPopoverMenu
});
module.exports["GlobalCreateContentPopover"] = $dc1ea4817175b6dd$export$e961788b96f97626;

});

parcelRegister("hkGNF", function(module, exports) {

let $c9e58126b212519a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c9e58126b212519a$var$load("6wr18"),
    $c9e58126b212519a$var$load("aDPqY"),
    $c9e58126b212519a$var$load("7EorR"),
    $c9e58126b212519a$var$load("ffEVr"),
    $c9e58126b212519a$var$load("5465r"),
    $c9e58126b212519a$var$load("fkY2m"),
    $c9e58126b212519a$var$load("30YPk"),
    $c9e58126b212519a$var$load("dwffN")
]).then(()=>parcelRequire('bvmt1'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("eTign", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $5RBJ9 = parcelRequire("5RBJ9");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $jmjWc = parcelRequire("jmjWc");


var $94z7g = parcelRequire("94z7g");


var $aQZ08 = parcelRequire("aQZ08");

const $65cf0976c45402f8$var$i18n = (0, $cgtv4.defineMessages)({
    gaSpotlightBody: {
        id: "create-blank-fabric-page.global-create.ga-spotlight-body",
        defaultMessage: "Create a whiteboard at any time using this button."
    },
    gaSpotlightCloseButton: {
        id: "create-blank-fabric-page.global-create.ga-spotlight-close",
        defaultMessage: "Okay"
    },
    spotlightBody: {
        id: "create-blank-fabric-page.global-create.spotlight-body",
        defaultMessage: "Create whiteboards from wherever you are in Confluence, whenever inspiration strikes."
    },
    spotlightCloseButton: {
        id: "create-blank-fabric-page.global-create.spotlight-close",
        defaultMessage: "Got it"
    }
});
const $65cf0976c45402f8$export$6965f847afddc834 = ({ isGA: isGA, isUniversalCreate: isUniversalCreate = false, spotlightEnabled: spotlightEnabled, onSpotlightClose: onSpotlightClose })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onClose = (0, $42omo.useCallback)(()=>{
        onSpotlightClose();
        if (isGA) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'closeWhiteboardGAOnboardingSpotlight',
                source: 'globalCreateSpotlight'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isGA,
        onSpotlightClose
    ]);
    (0, $42omo.useEffect)(()=>{
        if (spotlightEnabled && isGA) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'globalCreateWBSpotlightScreen',
                attributes: {
                    boardType: 'ga-onboarding'
                },
                source: 'globalNavigation'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isGA,
        spotlightEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "nav-create-whiteboard-onboarding"
    }, isUniversalCreate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94z7g.UniversalCreate), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aQZ08.GlobalCreateContentPopover), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, spotlightEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
        dialogWidth: 287,
        targetRadius: 3,
        actions: [
            {
                onClick: onClose,
                text: formatMessage(isGA ? $65cf0976c45402f8$var$i18n.gaSpotlightCloseButton : $65cf0976c45402f8$var$i18n.spotlightCloseButton)
            }
        ],
        target: "nav-create-whiteboard-onboarding",
        key: "nav-create-whiteboard-onboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), isGA ? $65cf0976c45402f8$var$i18n.gaSpotlightBody : $65cf0976c45402f8$var$i18n.spotlightBody))));
};

const $65cf0976c45402f8$export$57112b45afa4aad9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3ZtCp",
    name: "GlobalCreateContentPopoverSpotlightLoader",
    loader: async ()=>(await Promise.resolve(module.exports)).GlobalCreateContentPopoverSpotlight
});
module.exports["GlobalCreateContentPopoverSpotlight"] = $65cf0976c45402f8$export$6965f847afddc834;
module.exports["GlobalCreateContentPopoverSpotlightLoader"] = $65cf0976c45402f8$export$57112b45afa4aad9;

});

parcelRegister("94z7g", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");





var $ffCOo = parcelRequire("ffCOo");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $4jETc = parcelRequire("4jETc");

var $caUKj = parcelRequire("caUKj");


var $19BZl = parcelRequire("19BZl");


var $7K3dX = parcelRequire("7K3dX");

function $d27513c3e3d1447c$export$270a88864b52a4aa(items) {
    if (Array.isArray(items)) return items.every((item)=>{
        return typeof item === 'object' && item !== null && 'ati' in item;
    });
    return false;
}
function $d27513c3e3d1447c$export$badb391c957852f7(items) {
    const mixedItems = [];
    if ($d27513c3e3d1447c$export$270a88864b52a4aa(items)) mixedItems.push({
        items: items
    });
    else mixedItems.push(...items);
    return mixedItems;
}
function $d27513c3e3d1447c$export$5a8ab32aeea5694f(items, selectedItem) {
    for (const namedItem of items)for (const menuItem of namedItem.items){
        if (menuItem.ati.toString() === selectedItem.toString()) return menuItem;
    }
    return null;
}
function $d27513c3e3d1447c$export$1ed1ee46541b3e7a(sections, selectedItem) {
    for (const section of sections)// Only app-defined sections have items at definition time
    if (section.type === 'appDefinedSection') {
        for (const menuItem of section.items)// Check if item has ati property (both NativeMenuItem and CrossAppMenuItemV2 have it)
        if ('ati' in menuItem && menuItem.ati.toString() === selectedItem.toString()) {
            // For cross-app items, we need to return null as they don't have onClick/loadCreateContent
            // Only native items can be "selected" in the traditional sense
            if ('onClick' in menuItem || 'loadCreateContent' in menuItem) return menuItem;
        }
    }
    return null;
}
function $d27513c3e3d1447c$export$911e33c48adcec1b(mixedItems) {
    return mixedItems.flatMap((namedItem)=>namedItem.items).map((menuItem)=>menuItem.ati.toString());
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1Whri = parcelRequire("1Whri");


var $2SlZp = parcelRequire("2SlZp");





var $gdv5Z = parcelRequire("gdv5Z");

const $38e5614694cf6bb5$export$373682275c03fc63 = 'universal-create';
const $38e5614694cf6bb5$export$4fbca0e866deff63 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button-target`;
const $38e5614694cf6bb5$export$3f4cc858c0cb6e84 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button`;
const $38e5614694cf6bb5$export$85183a312807388d = 'navigation';
const $38e5614694cf6bb5$export$4e49778ae689b92a = 3;
const $38e5614694cf6bb5$export$c2ae99333adf8094 = 'universal-create';
const $38e5614694cf6bb5$export$4c7df19e787d8989 = [
    'ati:cloud:townsquare:team',
    'ati:cloud:townsquare:goal'
];
const $38e5614694cf6bb5$export$441df76988f6d01 = 344;








/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $keVvA = parcelRequire("keVvA");


var $i2kCO = parcelRequire("i2kCO");

function $503da3927b063db6$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $503da3927b063db6$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("4DBlL"));
        case 'da':
            return (parcelRequire("QiHJH"));
        case 'de':
            return (parcelRequire("5fKfY"));
        case 'en-GB':
            return (parcelRequire("bd60H"));
        case 'en-ZZ':
            return (parcelRequire("lhFMp"));
        case 'en':
            return Promise.resolve((parcelRequire("i2kCO")));
        case 'es':
            return (parcelRequire("lkfj4"));
        case 'fi':
            return (parcelRequire("7i5RS"));
        case 'fr':
            return (parcelRequire("k04cn"));
        case 'hu':
            return (parcelRequire("lkAKZ"));
        case 'it':
            return (parcelRequire("gGAak"));
        case 'ja':
            return (parcelRequire("4tZ4k"));
        case 'ko':
            return (parcelRequire("8pvft"));
        case 'nb':
            return (parcelRequire("hgimn"));
        case 'nl':
            return (parcelRequire("lSter"));
        case 'pl':
            return (parcelRequire("lqL92"));
        case 'pt':
            return (parcelRequire("4n76O"));
        case 'ru':
            return (parcelRequire("4tj0T"));
        case 'sv':
            return (parcelRequire("kxm5g"));
        case 'th':
            return (parcelRequire("gm7mX"));
        case 'tr':
            return (parcelRequire("kuMWv"));
        case 'uk':
            return (parcelRequire("c9eij"));
        case 'vi':
            return (parcelRequire("ejhdq"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("bazzC"));
        case 'zh':
            return (parcelRequire("jg5rQ"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $503da3927b063db6$export$12346a674644c156 = 'operational';
const $503da3927b063db6$export$515664faa1398f37 = 'navigation';
function $503da3927b063db6$var$Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $503da3927b063db6$var$fetchLanguageFile($503da3927b063db6$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $503da3927b063db6$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($503da3927b063db6$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $i2kCO.default),
        children: children
    });
}
const $503da3927b063db6$export$a5d940130f33be3f = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, $l998X.jsx)($503da3927b063db6$var$Provider, {
            children: /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                ...props
            })
        });


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $9VJDA = parcelRequire("9VJDA");


var $56M4r = parcelRequire("56M4r");


var $iZRoG = parcelRequire("iZRoG");

var $9kbAI = parcelRequire("9kbAI");

var $2KDGn = parcelRequire("2KDGn");

var $2bhek = parcelRequire("2bhek");







/* item-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");




const $d1f757cfbbc3d137$var$styles = null;
function $d1f757cfbbc3d137$export$2e2bcd8739ae039({ children: children, isMenuItem: isMenuItem = true }) {
    const wrappedItemRole = isMenuItem && (0, $dh538.fg)('platform_navx_universal_create_a11y_fix') ? 'listitem' : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: wrappedItemRole,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _u5f3u2gc _1bsb163w _1gxw12b0 _18tmu2gc _uckdu2gc _14ujn7od _1e3fazsu"
        ]),
        children: children
    });
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $iI2ST = parcelRequire("iI2ST");





const $867372c5edffcbdf$var$styles = {
    textStyle: "_k48p1wq8 _ect41gqc _syazazsu"
};
const $867372c5edffcbdf$export$e32d6f5365665749 = (0, $cgtv4.defineMessages)({
    showMore: {
        id: "platform.navigation-experiences.universal-create.show-more",
        defaultMessage: "More"
    },
    showLess: {
        id: "platform.navigation-experiences.universal-create.show-less",
        defaultMessage: "Less"
    }
});
function $867372c5edffcbdf$export$2e2bcd8739ae039({ onClick: onClick, heading: heading, showAll: showAll, foldable: foldable }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const text = showAll ? formatMessage($867372c5edffcbdf$export$e32d6f5365665749.showLess) : formatMessage($867372c5edffcbdf$export$e32d6f5365665749.showMore);
    const handleClick = (0, $42omo.useCallback)(()=>{
        setExpanded(true);
        onClick();
    }, [
        onClick
    ]); // Hide the button if showAll is true or if it has been clicked (expanded)
    if (foldable === 'enhanced' && (showAll || expanded)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d1f757cfbbc3d137$export$2e2bcd8739ae039), {
        isMenuItem: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iI2ST.ButtonMenuItem), {
            elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: "",
                color: "var(--ds-text-subtle, #505258)"
            }),
            onClick: handleClick,
            testId: "show-more-button",
            "aria-label": `Show ${text} ${heading ? ` ${heading}` : ''} options`,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $867372c5edffcbdf$var$styles.textStyle,
                children: text
            })
        })
    });
}


const $d690491b6d31182a$var$styles = {
    menuWrap: "_ca0qu2gc _n3tdu2gc",
    textStyle: "_k48p1wq8 _ect41gqc _syazazsu"
};
const $d690491b6d31182a$var$restProps = {
    className: 'custom-item-style'
};
const $d690491b6d31182a$export$398dd7520d5d04c0 = 4;
const $d690491b6d31182a$export$b8397b5d072e676a = 6;
function $d690491b6d31182a$export$e69afd517cd76d77(foldable) {
    return foldable === 'enhanced' ? $d690491b6d31182a$export$b8397b5d072e676a : $d690491b6d31182a$export$398dd7520d5d04c0;
}
function $d690491b6d31182a$export$1093f66bab07389e(foldable, itemLength) {
    return foldable === 'enhanced' && itemLength > $d690491b6d31182a$export$e69afd517cd76d77(foldable) && (0, $dh538.fg)('navx-2610-uc-refactor-show-more');
}
function $d690491b6d31182a$export$9b76114550cc401f(foldable, itemLength) {
    return foldable === true && itemLength > $d690491b6d31182a$export$e69afd517cd76d77(foldable);
}
function $d690491b6d31182a$export$c8ef8ec3af207203(foldable, itemLength) {
    return $d690491b6d31182a$export$1093f66bab07389e(foldable, itemLength) || $d690491b6d31182a$export$9b76114550cc401f(foldable, itemLength);
}
function $d690491b6d31182a$export$2e2bcd8739ae039({ heading: heading, sectionIndex: sectionIndex, itemLength: itemLength, foldable: foldable, compact: compact = false, isNative: isNative = true, toggleShowMore: toggleShowMore, children: children, showAll: showAll }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const text = showAll ? formatMessage((0, $867372c5edffcbdf$export$e32d6f5365665749).showLess) : formatMessage((0, $867372c5edffcbdf$export$e32d6f5365665749).showMore);
    if (!itemLength) return null;
     // when compact is true, it should hide both heading and divider
    // when compact is false or the section is native, it should only show the divider if it is not the first section
    const shouldShowDivider = (isNative || !compact) && sectionIndex !== 0;
    const shouldShowHeading = !!(heading && (isNative || !compact));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2KDGn.MenuSection), {
        children: [
            shouldShowDivider && /*#__PURE__*/ (0, $l998X.jsx)((0, $iZRoG.Divider), {}),
            shouldShowHeading && /*#__PURE__*/ (0, $l998X.jsx)((0, $d1f757cfbbc3d137$export$2e2bcd8739ae039), {
                isMenuItem: false,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2bhek.MenuSectionHeading), {
                    children: heading
                })
            }),
            (0, $dh538.fg)('platform_navx_universal_create_a11y_fix') ? // A11y: Wrap only menu items inside MenuList for proper semantic structure
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9kbAI.MenuList), {
                children: children
            }) : // Legacy behavior: children rendered directly
            children,
            $d690491b6d31182a$export$c8ef8ec3af207203(foldable, itemLength) && ($d690491b6d31182a$export$1093f66bab07389e(foldable, itemLength) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $867372c5edffcbdf$export$2e2bcd8739ae039), {
                onClick: toggleShowMore,
                heading: heading,
                showAll: showAll,
                foldable: foldable
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $d1f757cfbbc3d137$export$2e2bcd8739ae039), {
                isMenuItem: false,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                    ...$d690491b6d31182a$var$restProps,
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "",
                        color: "var(--ds-text-subtle)"
                    }),
                    onClick: toggleShowMore,
                    testId: "toggle-more-less-button",
                    "aria-label": `Toggle for ${text}${heading ? ` ${heading}` : ''} options`,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $d690491b6d31182a$var$styles.textStyle,
                        children: text
                    })
                })
            }))
        ]
    }, `menu-section-${sectionIndex}`);
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $lAJUP = parcelRequire("lAJUP");


var $4rwCt = parcelRequire("4rwCt");




var $cGtPE = parcelRequire("cGtPE");


var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");








var $fFa3V = parcelRequire("fFa3V");


var $5qzNs = parcelRequire("5qzNs");


var $lvsjl = parcelRequire("lvsjl");

const $a714a9fde214d42c$export$f8e186cd2da1abff = 100;
const $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT = 767;
function $a714a9fde214d42c$export$2a50c0408cf3ddb8() {
    const [isResponsiveMode, setIsResponsiveMode] = (0, $42omo.useState)(window.innerWidth <= $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT);
    const [handleResizeDebounced] = (0, $lvsjl.default)(()=>{
        const isCurrentlyMobile = window.innerWidth <= $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT;
        setIsResponsiveMode((prev)=>prev !== isCurrentlyMobile ? isCurrentlyMobile : prev);
    }, $a714a9fde214d42c$export$f8e186cd2da1abff);
    (0, $42omo.useEffect)(()=>{
        let unbind;
        unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'resize',
                listener: handleResizeDebounced
            }
        ]);
        return unbind;
    }, [
        handleResizeDebounced
    ]);
    return isResponsiveMode;
}
const $a714a9fde214d42c$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(item, ...properties);





parcelRequire("42omo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $6F6hl = parcelRequire("6F6hl");




const $63d1bead1b1651fc$var$messages = (0, $cgtv4.defineMessages)({
    menuItemLoading: {
        id: "navigation.universal-create.menuItemLoading",
        defaultMessage: "Menu item is loading"
    }
});
var $63d1bead1b1651fc$export$2e2bcd8739ae039 = $63d1bead1b1651fc$var$messages;


const $f0781448a6f252f4$var$LEGACY_MENU_SKELETON_HEIGHT = 40;
const $f0781448a6f252f4$var$LEGACY_CONTENT_HEIGHT = 9;
const $f0781448a6f252f4$var$DEFAULT_CONTENT_HEIGHT = 8;
const $f0781448a6f252f4$var$menuSkeletonStyles = {
    wrapperLegacy: "_4t3i1ylp _1bsb1osq _19bv1b66 _u5f31b66",
    wrapper: "_4t3izwfg _1bsb1osq _19bv1b66 _u5f31b66"
};
const $f0781448a6f252f4$export$cde35cc9e1359709 = ({ testId: testId, contentHeight: contentHeight = (0, $dh538.fg)('navx-2644-loading-menu') ? $f0781448a6f252f4$var$DEFAULT_CONTENT_HEIGHT : $f0781448a6f252f4$var$LEGACY_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: (0, $dh538.fg)('navx-2644-loading-menu') ? $f0781448a6f252f4$var$menuSkeletonStyles.wrapper : $f0781448a6f252f4$var$menuSkeletonStyles.wrapperLegacy,
        alignBlock: "center",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    testId: "skeleton-item-v2",
                    width: "100%",
                    height: contentHeight,
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $63d1bead1b1651fc$export$2e2bcd8739ae039).menuItemLoading)
            })
        ]
    });
};


const $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f0781448a6f252f4$export$cde35cc9e1359709), {
        ...props
    });
};



const $036eedccb5a0b632$var$textStyle = null; // Function to check if the element's text is truncated
function $036eedccb5a0b632$var$isTextClamped(labelElement, boxElement) {
    return labelElement.scrollWidth > boxElement.scrollWidth;
}
const $036eedccb5a0b632$var$Item = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, onContextMenu: onContextMenu, isLoading: isLoading, loadCreateContent: createContent, onClickCloseMenu: onClickCloseMenu = true, children: children, testId: testId, isDisabled: isDisabled, href: href, rel: rel, target: target, elemBefore: elemBefore, Wrapper: Wrapper }, forwardRef)=>{
    const { product: product, ...menuControl } = (0, $19BZl.useMenuControl)();
    const labelRef = (0, $42omo.useRef)(null);
    const buttonClick = (0, $42omo.useCallback)((event)=>{
        if (createContent) menuControl.load(createContent);
        else if (onClickCloseMenu) menuControl.close();
        onClick?.(event);
    }, [
        menuControl,
        onClick,
        onClickCloseMenu,
        createContent
    ]);
    const renderButton = (0, $42omo.useCallback)((props)=>{
        const { triggerProps: triggerProps } = props || {};
        const { ref: triggerRef, ...restTriggerProps } = triggerProps || {};
        const mergedRef = (0, $4rwCt.mergeRefs)([
            ...forwardRef ? [
                forwardRef
            ] : [],
            ...triggerRef ? [
                triggerRef
            ] : []
        ]);
        const Icon = elemBefore;
        const baseProps = {
            testId: testId,
            iconBefore: Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: "",
                color: "var(--ds-text-subtle, #505258)"
            }) : undefined,
            onClick: buttonClick,
            onContextMenu: onContextMenu,
            className: 'custom-item-style',
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1t5c13mh _1t211l2s _1xdi1ule"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    ref: labelRef,
                    maxLines: 1,
                    color: "color.text.subtle",
                    weight: "medium",
                    children: children
                })
            })
        };
        const canTooltipAppear = ()=>{
            return labelRef.current && mergedRef.current ? $036eedccb5a0b632$var$isTextClamped(labelRef.current, mergedRef.current) : false;
        };
        const itemProps = {
            ...baseProps,
            ...restTriggerProps,
            ...mergedRef && {
                ref: mergedRef
            },
            href: href,
            rel: rel,
            target: target,
            isDisabled: isDisabled
        };
        const buttonItemProps = (0, $a714a9fde214d42c$export$d6eadbd047ebd460)(itemProps, 'href', 'rel', 'target', 'role', 'UNSAFE_shouldDisableRouterLink', 'UNSAFE_isDraggable');
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: children,
            canAppear: canTooltipAppear,
            children: href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
                ...itemProps
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                ...buttonItemProps
            })
        });
    }, [
        testId,
        elemBefore,
        buttonClick,
        children,
        forwardRef,
        href,
        rel,
        isDisabled,
        target,
        onContextMenu
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e), {
        testId: `loading-${testId}`
    });
    if (product === 'confluence' && Wrapper) return /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
        children: (props)=>renderButton(props)
    });
    return renderButton();
});
function $036eedccb5a0b632$export$2e2bcd8739ae039({ item: item }) {
    const { ref: ref, ...props } = item;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d1f757cfbbc3d137$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($036eedccb5a0b632$var$Item, {
                ...props,
                ref: ref
            })
        })
    });
}



const $0b21ce6c65459807$var$MAX_ITEMS = 10;
function $0b21ce6c65459807$var$NativeMenuSection({ namedItems: namedItems, sectionIndex: sectionIndex, totalMenuItemsCount: totalMenuItemsCount, sectionStartIndex: sectionStartIndex }) {
    const [showAll, setShowAll] = (0, $42omo.useState)(false);
    const { fireNewNativeMenuItemClicked: fireNewNativeMenuItemClicked } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const { product: product } = (0, $19BZl.useMenuControl)();
    const sectionItemsCount = namedItems.items.length;
    const items = (0, $42omo.useMemo)(()=>{
        if (!sectionItemsCount) return [];
        if (!namedItems.foldable || sectionItemsCount <= (0, $d690491b6d31182a$export$e69afd517cd76d77)(namedItems.foldable)) return namedItems.items;
        return namedItems.items.slice(0, showAll ? $0b21ce6c65459807$var$MAX_ITEMS : (0, $d690491b6d31182a$export$e69afd517cd76d77)(namedItems.foldable));
    }, [
        namedItems,
        showAll,
        sectionItemsCount
    ]);
    const toggleShowMore = (0, $42omo.useCallback)(()=>{
        if (namedItems.foldable === 'enhanced' && (0, $dh538.fg)('navx-2610-uc-refactor-show-more')) setShowAll(true); // removing show less functionality under this fg
        else setShowAll((prev)=>!prev);
    }, [
        setShowAll,
        namedItems.foldable
    ]);
    const menuItemWithAnalytics = (0, $42omo.useCallback)((item, itemIndex)=>{
        const fireAnalytics = (isRightClick)=>{
            const itemAti = item.ati.toString();
            fireNewNativeMenuItemClicked({
                ati: itemAti,
                menuItemsCount: totalMenuItemsCount,
                // Total number of items in the native sections part of menu
                menuItemIndex: sectionStartIndex + itemIndex,
                // Position of the item in the native sections part of menu
                groupItemProduct: product,
                groupItemsCount: sectionItemsCount,
                // Number of items in the section
                groupItemsIndex: itemIndex,
                isRightClick: // Position of the item in the section
                isRightClick
            });
        };
        return {
            ...item,
            onClick: (event)=>{
                fireAnalytics(false);
                item.onClick?.(event);
            },
            onContextMenu: (event)=>{
                fireAnalytics(true);
                item.onContextMenu?.(event);
            }
        };
    }, [
        fireNewNativeMenuItemClicked,
        totalMenuItemsCount,
        sectionStartIndex,
        sectionItemsCount,
        product
    ]);
    if (!namedItems?.items?.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d690491b6d31182a$export$2e2bcd8739ae039), {
        sectionIndex: sectionIndex,
        itemLength: namedItems.items.length,
        foldable: namedItems.foldable,
        heading: namedItems.heading,
        showAll: showAll,
        toggleShowMore: toggleShowMore,
        isNative: true,
        children: items.map((menuItem, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $036eedccb5a0b632$export$2e2bcd8739ae039), {
                item: menuItemWithAnalytics(menuItem, index)
            }, `menu-section-${sectionIndex}-item-${index}`))
    });
}
var $0b21ce6c65459807$export$2e2bcd8739ae039 = (0, $503da3927b063db6$export$a5d940130f33be3f)($0b21ce6c65459807$var$NativeMenuSection);


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















// ===============================
// UC Suggestions API Communication types
// ===============================













var $6lFYf = parcelRequire("6lFYf");











var $iAFAo = parcelRequire("iAFAo");

/**
 * Helper function to create a deterministic cache key from an object
 * by sorting keys and stringifying the result
 */ function $67bf03c55a136376$var$createSortedCacheKey(unordered) {
    return JSON.stringify(Object.keys(unordered).sort().reduce((obj, key)=>{
        obj[key] = unordered[key];
        return obj;
    }, {}));
}
function $67bf03c55a136376$export$53a1e737d45016e2(props) {
    const { value: { consumer: consumer, cache: cache }, setValue: setValue } = (0, $caUKj.useBFFContext)();
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    // Compute cache key using useMemo with sorted JSON stringification
    const cacheKey = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('navx-2468_generic_cache_key')) {
            const sortedJsonString = $67bf03c55a136376$var$createSortedCacheKey(props);
            return `gc-${consumer}-${sortedJsonString}`;
        }
        // Legacy cache key format
        const { orgId: orgId = 'NO_ORG_ID', cloudId: cloudId = 'NO_CLOUD_ID', accountId: accountId = 'NO_ACCOUNT_ID', productType: productType, subProduct: subProduct = 'NO_SUB_PRODUCT', locale: locale = 'NO_LOCALE', nativeAtis: nativeAtis = [], excludeAtis: excludeAtis = [], preferredAtis: preferredAtis = [] } = props;
        const nativeAtisParams = (0, $iAFAo.atiArrayToParams)(nativeAtis) || '';
        const excludeAtisParams = (0, $iAFAo.atiArrayToParams)(excludeAtis) || '';
        const preferredAtisParams = (0, $iAFAo.atiArrayToParams)(preferredAtis) || '';
        return `gc-${consumer}-${orgId}:${cloudId}:${accountId}:${productType}:${subProduct}:${locale}:${nativeAtisParams}:${excludeAtisParams}:${preferredAtisParams}`;
    }, [
        consumer,
        props
    ]);
    const cachedObject = cache[cacheKey];
    const setCachedObject = (0, $42omo.useCallback)((objectToCache)=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: objectToCache
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    const removeCachedObject = (0, $42omo.useCallback)(()=>{
        setValue((prev)=>{
            const { [cacheKey]: removed, ...remainingCache } = prev.cache;
            return {
                ...prev,
                cache: remainingCache
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const getCachedObject = (targetCacheKey)=>cache[targetCacheKey];
    const hasCachedObject = (targetCacheKey)=>cache[targetCacheKey] !== undefined;
    return {
        setCachedObject: setCachedObject,
        removeCachedObject: removeCachedObject,
        getCachedObject: getCachedObject,
        hasCachedObject: hasCachedObject,
        cacheKey: cacheKey,
        cachedObject: cachedObject
    };
}



var $ik19A = parcelRequire("ik19A");


var $cdX3N = parcelRequire("cdX3N");

function $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, nativeAtis: nativeAtis, excludeAtis: excludeAtis, preferredAtis: preferredAtis }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const { buildUCRecommendationURL: buildUCRecommendationURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId
    });
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $67bf03c55a136376$export$53a1e737d45016e2)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        nativeAtis: nativeAtis,
        excludeAtis: excludeAtis,
        preferredAtis: preferredAtis
    });
    const requestIdRef = (0, $42omo.useRef)(0);
    // We need to set the data from the cache on mount (if applicable)
    // because setting it as the initial state value causes it to
    // return undefined in component usages and not be fetched from the network when expected
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCSuggestions = (0, $42omo.useCallback)(async ()=>{
        // Kill switch: return early if feature flag is disabled
        if (!(0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled')) return undefined;
        // Early exit: filter out invalid param requests when required identifiers are missing
        if (!cloudId || !orgId) return undefined;
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        try {
            const url = buildUCRecommendationURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                nativeAtis: nativeAtis,
                excludeAtis: excludeAtis,
                preferredAtis: preferredAtis
            });
            setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) return undefined;
            if (response.status === (0, $4jETc.RequestStatus).ERROR) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
                return undefined;
            }
            if (response.status === (0, $4jETc.RequestStatus).COMPLETE && response.data) {
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
                return response.data;
            }
        } catch (error) {
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            }
        }
        return undefined;
    }, [
        cloudId,
        cachedObject,
        orgId,
        product,
        userId,
        locale,
        subProduct,
        nativeAtis,
        excludeAtis,
        preferredAtis,
        buildUCRecommendationURL,
        setStatus,
        setCachedObject
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled')) {
            // We check if the current loading requests include UC suggestions rather than the BFF status directly
            // to ensure that it only returns true for UC suggestions and not other BFF requests.
            const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY)) ?? false;
            // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
            // before running things like onResultChange, so that we don't do those things an unnecessary extra time
            // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
            const hasSuggestionDataBeenReturned = data !== undefined || hasError;
            return isBffLoadingOurStuff && !hasSuggestionDataBeenReturned;
        }
        return currentLoadingRequests?.includes((0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY)) ?? false;
    }, [
        currentLoadingRequests,
        data,
        hasError
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCSuggestions: fetchUCSuggestions
    };
}











function $060ce356f1549e47$export$a0e86d06727a8039(atiType) {
    // Access the MenuControlContext
    const { suggestionConfig: suggestionConfig } = (0, $19BZl.useMenuControl)();
    // Determine ATIs to pass to the hook
    const atis = (0, $42omo.useMemo)(()=>{
        if (!suggestionConfig.enabled) return undefined;
        const atiArray = atiType === 'preferred' ? suggestionConfig.preferredAtis : suggestionConfig.excludeAtis;
        if (!atiArray) return undefined;
        // Convert Ati[] to string[]
        if (Array.isArray(atiArray) && atiArray.length > 0) return atiArray.map((ati)=>ati.toString());
        // Default fallback
        return undefined;
    }, [
        suggestionConfig,
        atiType
    ]);
    return atis;
}
function $060ce356f1549e47$export$4984a78a2f2592cd() {
    return $060ce356f1549e47$export$a0e86d06727a8039('preferred');
}
function $060ce356f1549e47$export$d6dcc91285361556() {
    return $060ce356f1549e47$export$a0e86d06727a8039('exclude');
}








function $bdcbf50357937847$export$ace2aad66e79cd4e() {
    // Access the MenuControlContext
    const { suggestionConfig: suggestionConfig, mixedItems: mixedItems } = (0, $19BZl.useMenuControl)();
    // Determine native ATIs to pass to the hook
    const nativeAtis = (0, $42omo.useMemo)(()=>{
        if (!suggestionConfig.enabled || !suggestionConfig.nativeAtis) return undefined;
        // If nativeAtis is 'auto', extract ATIs from native menu items
        if (suggestionConfig.nativeAtis === 'auto') return (0, $d27513c3e3d1447c$export$911e33c48adcec1b)(mixedItems);
        // If nativeAtis is manually defined as Ati[], convert to strings and use it
        if (Array.isArray(suggestionConfig.nativeAtis) && suggestionConfig.nativeAtis.length > 0) return suggestionConfig.nativeAtis.map((ati)=>ati.toString());
        // Default fallback
        return undefined;
    }, [
        suggestionConfig,
        mixedItems
    ]);
    return nativeAtis;
}







/* SuggestionItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $9DI9J = parcelRequire("9DI9J");

/* formLoader.tsx generated by @compiled/babel-plugin v0.36.1 */ 











/* Loading.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





const $cfb31863b8c4fcaa$var$styles = {
    wrapper: "_1ul91wdt",
    wrapperWithPadding: "_1ul91wdt _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi"
};
function $cfb31863b8c4fcaa$export$dab1248df0cdf0ab({ padded: padded = false }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "global-create-content-loading-menu",
        xcss: padded ? $cfb31863b8c4fcaa$var$styles.wrapperWithPadding : $cfb31863b8c4fcaa$var$styles.wrapper,
        children: Array.from({
            length: 6
        }, (_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e), {
                contentHeight: 8
            }, `loading-skeleton-item-${index}`))
    });
}


const $8890500e2831b54e$var$styles = {
    wrapper: "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi _1bsb1gwv"
};
const $8890500e2831b54e$var$messages = (0, $cgtv4.defineMessages)({
    loading: {
        id: "platform.navigation-experiences.universal-create.integrations.form-loading",
        defaultMessage: "Loading"
    }
});
function $8890500e2831b54e$export$2f1709634d27333b() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8890500e2831b54e$var$styles.wrapper),
        children: [
            (0, $dh538.fg)('navx-2644-loading-menu') && /*#__PURE__*/ (0, $l998X.jsx)((0, $cfb31863b8c4fcaa$export$dab1248df0cdf0ab), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                id: $8890500e2831b54e$var$messages.loading.id,
                children: formatMessage($8890500e2831b54e$var$messages.loading)
            })
        ]
    });
}



const $b19599a70b1ea9c9$var$GoalCreateWrapperAsync = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("80GhR")).then((module)=>({
            default: module.GoalCreateWrapper
        })));

const $b19599a70b1ea9c9$var$TeamCreateWrapperAsync = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jfkWB")).then((module)=>({
            default: module.TeamCreateWrapper
        })));

const $b19599a70b1ea9c9$var$ProjectCreateWrapperAsync = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ibcnC")).then((module)=>({
            default: module.ProjectCreateWrapper
        })));
function $b19599a70b1ea9c9$var$LazyLoadCreateContent({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $8890500e2831b54e$export$2f1709634d27333b), {}),
            children: children
        })
    });
}
const $b19599a70b1ea9c9$var$CREATE_CONTENT_PRESETS = {
    [(0, $9DI9J.ATI_PRESETS).GOAL]: (props)=>/*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$LazyLoadCreateContent, {
            children: /*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$GoalCreateWrapperAsync, {
                ...props
            })
        }),
    [(0, $9DI9J.ATI_PRESETS).TEAM]: (props)=>/*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$LazyLoadCreateContent, {
            children: /*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$TeamCreateWrapperAsync, {
                ...props
            })
        }),
    [(0, $9DI9J.ATI_PRESETS).PROJECT]: (props)=>/*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$LazyLoadCreateContent, {
            children: /*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$ProjectCreateWrapperAsync, {
                ...props
            })
        })
};
function $b19599a70b1ea9c9$export$38e36ff3c4cb0c61(ati) {
    return $b19599a70b1ea9c9$var$CREATE_CONTENT_PRESETS[ati];
}


/* LinkItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

/* SuggestionItemBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6yCpa = parcelRequire("6yCpa");



























function $807ba750c6a5720b$var$importIcon(name) {
    switch(name){
        // lab-icons start
        case 'page-live-doc':
            return Promise.resolve((parcelRequire("e0ycV")));
        case 'suggested-edit':
            return (parcelRequire("53z01"));
        // lab-icons end
        case 'page':
            return Promise.resolve((parcelRequire("8jHAi")));
        case 'video':
            return Promise.resolve((parcelRequire("2Yaht")));
        case 'database':
            return Promise.resolve((parcelRequire("6B0jU")));
        case 'whiteboard':
            return Promise.resolve((parcelRequire("ZDq1z")));
        case 'quotation-mark':
            return Promise.resolve((parcelRequire("9RVmI")));
        case 'smart-link':
            return Promise.resolve((parcelRequire("duwSm")));
        case 'globe':
            return Promise.resolve((parcelRequire("buthI")));
        case 'teams':
            return Promise.resolve((parcelRequire("1dKyn")));
        case 'goal':
            return Promise.resolve((parcelRequire("gJsgh")));
        case 'project':
            return Promise.resolve((parcelRequire("bVHZY")));
        case 'heart':
            return Promise.resolve((parcelRequire("j8LwF")));
        case 'dashboard':
            return (parcelRequire("036Ie"));
        case 'work-item':
            return Promise.resolve((parcelRequire("2qVkt")));
        case 'work-items':
            return Promise.resolve((parcelRequire("7ZcJJ")));
        case 'roadmap':
            return (parcelRequire("k8V49"));
        case 'sprint':
            return (parcelRequire("fq08g"));
        case 'focus-area':
            return (parcelRequire("eNNHQ"));
        case 'calendar-plus':
            return (parcelRequire("ji6i4"));
        default:
            throw new Error(`Icon ${name} not found`);
    }
}
async function $807ba750c6a5720b$export$832efc97cccfe549(icon) {
    try {
        if (!icon) return undefined;
        const iconModule = await $807ba750c6a5720b$var$importIcon(icon);
        return iconModule ? iconModule.default : undefined;
    } catch (error) {
        return undefined;
    }
}



const $27f0e6b33328c20f$var$noop = ()=>{};
function $27f0e6b33328c20f$export$b5de039d8eaccb66({ responseItem: responseItem, customisedItemConfig: customisedItemConfig, itemIndex: itemIndex, totalItemsCount: totalItemsCount }) {
    const { suggestionConfig: suggestionConfig } = (0, $19BZl.useMenuControl)();
    const { fireNewSuggestionsMenuItemClicked: fireNewSuggestionsMenuItemClicked } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const onClick = (0, $42omo.useCallback)(()=>{
        const onItemClick = suggestionConfig?.enabled && suggestionConfig?.onItemClick || $27f0e6b33328c20f$var$noop;
        fireNewSuggestionsMenuItemClicked({
            ati: responseItem.ati,
            groupItemProduct: responseItem.product,
            groupItemsCount: totalItemsCount,
            groupItemsIndex: itemIndex,
            isRightClick: false,
            menuItemIndex: itemIndex,
            menuItemsCount: totalItemsCount
        });
        // TODO: add skip condition in the future for platform items, such as goal, project or team forms.
        onItemClick?.(responseItem.ati);
    }, [
        suggestionConfig,
        responseItem,
        fireNewSuggestionsMenuItemClicked,
        itemIndex,
        totalItemsCount
    ]);
    const [icon, setIcon] = (0, $42omo.useState)(undefined);
    const [isIconLoading, setIsIconLoading] = (0, $42omo.useState)(false);
    const { isLoading: isCustomisedItemConfigLoading, ...restCustomisedItemConfig } = customisedItemConfig || {};
    const onRightClick = (0, $42omo.useCallback)((event)=>{
        // Fire analytics first
        fireNewSuggestionsMenuItemClicked({
            ati: responseItem.ati,
            groupItemProduct: responseItem.product,
            groupItemsCount: totalItemsCount,
            groupItemsIndex: itemIndex,
            isRightClick: true,
            menuItemIndex: itemIndex,
            menuItemsCount: totalItemsCount
        });
        // Then call custom onContextMenu handler if provided
        const customOnContextMenu = restCustomisedItemConfig?.onContextMenu;
        customOnContextMenu?.(event);
    }, [
        fireNewSuggestionsMenuItemClicked,
        responseItem,
        totalItemsCount,
        itemIndex,
        restCustomisedItemConfig?.onContextMenu
    ]);
    (0, $42omo.useEffect)(function loadIcon() {
        if (!responseItem.icon) {
            setIcon(undefined);
            setIsIconLoading(false);
            return;
        }
        setIsIconLoading(true);
        (0, $807ba750c6a5720b$export$832efc97cccfe549)(responseItem.icon).then((loadedIcon)=>{
            if (loadedIcon) setIcon(()=>loadedIcon);
            else setIcon(undefined);
            setIsIconLoading(false);
        });
    }, [
        responseItem.icon
    ]);
    // Extract custom onClick handler and compose with analytics onClick
    const customOnClick = restCustomisedItemConfig?.onClick;
    const composedOnClick = (0, $42omo.useCallback)((event)=>{
        // Fire analytics first
        onClick();
        // Then call custom click handler if provided
        customOnClick?.(event);
    }, [
        customOnClick,
        onClick
    ]);
    const menuItem = (0, $42omo.useMemo)(()=>{
        const { onClick: _, onContextMenu: __, ...otherCustomConfig } = restCustomisedItemConfig || {};
        return {
            ati: (0, $6yCpa.Ati).parse(responseItem.ati),
            children: responseItem.name,
            elemBefore: icon,
            isLoading: isIconLoading || isCustomisedItemConfigLoading,
            testId: `suggestion-item-${responseItem.ati}`,
            onClick: customOnClick ? composedOnClick : onClick,
            onContextMenu: onRightClick,
            ...otherCustomConfig
        };
    }, [
        responseItem.ati,
        responseItem.name,
        icon,
        isIconLoading,
        isCustomisedItemConfigLoading,
        onClick,
        composedOnClick,
        customOnClick,
        restCustomisedItemConfig,
        onRightClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $036eedccb5a0b632$export$2e2bcd8739ae039), {
        item: menuItem
    });
}






var $39XmP = parcelRequire("39XmP");


var $kfZYI = parcelRequire("kfZYI");







function $43cfab306ab8c906$var$getUrlEnv(serverSessionSyncUrl) {
    const url = new URL(serverSessionSyncUrl);
    if (url.hostname === 'id.stg.internal.atlassian.com') return 'staging';
    if (url.hostname === 'id.atlassian.com') return 'prod';
    return null;
}
function $43cfab306ab8c906$var$compileIcSessionSyncUrl(serverSessionSyncUrl) {
    const env = $43cfab306ab8c906$var$getUrlEnv(serverSessionSyncUrl);
    const icEnvUrl = env ? (0, $kfZYI.getUrlForDomainInContext)('id', env) : undefined;
    if (icEnvUrl) {
        const icFinalUrl = new URL(serverSessionSyncUrl);
        const icEnvHostname = new URL(icEnvUrl).hostname;
        icFinalUrl.hostname = icEnvHostname;
        return icFinalUrl.toString();
    }
    return serverSessionSyncUrl;
}
function $43cfab306ab8c906$var$useBuildLinkItemUrl(item) {
    const { product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'universalCreate',
        product: product,
        subProduct: subProduct
    });
    if (!item.href || !item.hostname) return '';
    const base = item.hostname.startsWith('https://') ? item.hostname : `https://${item.hostname}`;
    const targetUrl = new URL(item.href, base);
    // Add query parameters from options
    for (const [key, value] of Object.entries(item.options || {}))if (value !== null) targetUrl.searchParams.append(key, String(value));
    const finalTargetUrl = buildUrlWithAnalyticsParams(targetUrl.toString());
    // Handle session sync URL logic
    if (!item.sessionSyncUrl) // When session sync URL is empty, return the current URL
    return finalTargetUrl;
    // When session sync URL is set, use it as base and set continue param to current URL
    const finalSessionSyncUrl = $43cfab306ab8c906$var$compileIcSessionSyncUrl(item.sessionSyncUrl);
    const sessionSyncUrl = new URL(finalSessionSyncUrl);
    sessionSyncUrl.searchParams.set('continue', finalTargetUrl);
    return sessionSyncUrl.toString();
}
function $43cfab306ab8c906$export$42845b6a2d6a3ac1(item) {
    const { suggestionConfig: suggestionConfig } = (0, $19BZl.useMenuControl)();
    const href = $43cfab306ab8c906$var$useBuildLinkItemUrl(item);
    // Priority: explicit config > item target > default '_blank'
    const target = suggestionConfig?.enabled ? suggestionConfig.suggestionLinkOpenTarget || item.target || '_blank' : item.target || '_blank';
    const onClick = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        window.parent.location.href = href;
    }, [
        href
    ]);
    return (0, $42omo.useMemo)(()=>{
        // Only add rel attributes for _blank targets to prevent security issues
        const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
        // Only add onClick handler for _self targets in iframes with valid href to minimize impact
        const shouldAddOnClick = href && target === '_self' && window !== window.parent && (0, $dh538.fg)('navx_universal_create_self_redirect_iframe');
        return {
            target: target,
            rel: rel,
            href: href,
            ...shouldAddOnClick && {
                onClick: onClick
            }
        };
    }, [
        href,
        target,
        onClick
    ]);
}


/**
 * Higher-order component that wraps a component with link item configuration
 * @param WrappedComponent - The component to wrap with link item configuration
 * @returns A new component with link item configuration applied
 */ function $1b108bbe34f9b79a$var$withLinkItemConfig(WrappedComponent) {
    return function WithLinkItemConfigComponent(props) {
        const linkItemConfig = (0, $43cfab306ab8c906$export$42845b6a2d6a3ac1)(props.responseItem);
        if (!linkItemConfig.href) return null; // early return should now show the item when computed href is invalid
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: linkItemConfig
        });
    };
}
const $1b108bbe34f9b79a$export$532cb6865ebe8946 = $1b108bbe34f9b79a$var$withLinkItemConfig((0, $27f0e6b33328c20f$export$b5de039d8eaccb66));


/* LoomVideoItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





























var $jJf3a = parcelRequire("jJf3a");


var $kyiqo = parcelRequire("kyiqo");

const $e7fdbca395b7a04f$export$873f91e3be81ab94 = (0, $kyiqo.metrics).interaction({
    key: 'open-loom-recorder-sdk'
});
const $e7fdbca395b7a04f$export$bf1068aa9f020d8f = (0, $kyiqo.metrics).interaction({
    key: 'initialize-loom-recorder-sdk'
});
const $e7fdbca395b7a04f$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $e7fdbca395b7a04f$export$fdda1c9b501679e3 = 'initialize-loom-entry-point';



var $ahR9w = parcelRequire("ahR9w");

/* eslint-disable @repo/internal/import/no-unresolved */ 
const $059afa58187a2540$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $059afa58187a2540$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, productName: productName, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: productName,
            entryPointName: entryPointName
        }
    };
    if (environment === 'dev') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $059afa58187a2540$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production'
    };
    if (environment === 'staging') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $059afa58187a2540$var$PUBLIC_APP_IDS.staging,
        environment: 'staging'
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $059afa58187a2540$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production'
    };
};


const $2049fe8012434f76$export$703005ecc9b7c87e = {
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    UNSUPPORTED_MEDIA_STREAMING: 'unsupported-media-streaming',
    UNSUPPORTED_3RD_PARTY_COOKIE: 'unsupported-third-party-cookie',
    UNSUPPORTED_UNKNOWN: 'unsupported-unknown',
    TOKEN_UNSUCCESSFUL: 'token-unsuccessful',
    UNMERGED_USER: 'token-unsuccessful-unmerged-user',
    TOKEN_EMPTY: 'token-empty',
    NETWORK: 'network',
    LOOM_INTERNAL_ERROR: 'loom-internal-error',
    UNKNOWN: 'unknown'
};
class $2049fe8012434f76$var$LoomInitError extends Error {
    constructor(type, message){
        super(message);
        this.type = void 0;
        this.type = type;
    }
}
function $2049fe8012434f76$var$mapLoomUnsupportedTypeToSubType(unsupportedReason) {
    switch(unsupportedReason){
        case 'incompatible-browser':
            return $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_BROWSER;
        case 'third-party-cookies-disabled':
            return $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_3RD_PARTY_COOKIE;
        case 'no-media-streams-support':
            return $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_MEDIA_STREAMING;
        default:
            return $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_UNKNOWN;
    }
}
async function $2049fe8012434f76$var$fetchJsonFromUrl(url, method = 'GET', expectedStatuses = []) {
    try {
        const response = await fetch(url, {
            method: method,
            headers: {
                Accept: 'application/json'
            }
        });
        if (!response.ok && !expectedStatuses.includes(response.status)) throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.NETWORK, response.statusText);
        const data = await response.json();
        return data;
    } catch (error) {
        throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.NETWORK, error instanceof Error ? error.message : '');
    }
}
async function $2049fe8012434f76$var$getAuthToken() {
    const { token: token, message: message } = await $2049fe8012434f76$var$fetchJsonFromUrl('/gateway/api/loom-auth/api/internal/auth/sdk_token', 'POST', [
        404
    ]);
    if (message === 'Loom user needs merge') throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.UNMERGED_USER);
    if (message !== 'Success') {
        let userStatus;
        try {
            // we don't want a failure to make the identity check to mask the original issue
            const { status: status } = await $2049fe8012434f76$var$fetchJsonFromUrl('/gateway/api/loom-auth/api/internal/identity/user-status', 'GET');
            userStatus = status;
        } catch (error) {
            userStatus = 'unknown user status';
        }
        throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.TOKEN_UNSUCCESSFUL, `${message} , ${userStatus}`);
    }
    if (!token) throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.TOKEN_EMPTY);
    return token;
}


async function $2049fe8012434f76$var$_init({ cloudId: cloudId, environment: environment, productName: productName, experienceTracker: experienceTracker, entryPointLocation: entryPointLocation }) {
    let loomSDKInstance;
    try {
        (0, $e7fdbca395b7a04f$export$bf1068aa9f020d8f).start();
        experienceTracker.start({
            id: (0, $e7fdbca395b7a04f$export$fdda1c9b501679e3),
            name: (0, $e7fdbca395b7a04f$export$fdda1c9b501679e3),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        const { isSupported: isSupported } = await (parcelRequire("aWuvK"));
        const { supported: supported, error: error } = isSupported();
        if (!supported) throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$var$mapLoomUnsupportedTypeToSubType(error));
        const recorderToken = environment === 'dev' ? '' : await $2049fe8012434f76$var$getAuthToken();
        const { createInstance: createInstance } = await (parcelRequire("11pmp"));
        loomSDKInstance = await createInstance((0, $059afa58187a2540$export$c150e4a8d8a3ab35)({
            environment: environment,
            jws: recorderToken,
            siteId: cloudId,
            productName: productName,
            entryPointName: entryPointLocation
        }));
        if (!loomSDKInstance.status().success) throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.LOOM_INTERNAL_ERROR, 'Loom SDK timeout or another internal issue');
        experienceTracker.succeed({
            name: (0, $e7fdbca395b7a04f$export$fdda1c9b501679e3),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        (0, $e7fdbca395b7a04f$export$bf1068aa9f020d8f).stop();
    } catch (error) {
        (0, $e7fdbca395b7a04f$export$bf1068aa9f020d8f).cancel();
        if (error instanceof $2049fe8012434f76$var$LoomInitError) {
            if (error.type === $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_BROWSER || error.type === $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_MEDIA_STREAMING || error.type === $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_3RD_PARTY_COOKIE || error.type === $2049fe8012434f76$export$703005ecc9b7c87e.UNMERGED_USER) experienceTracker.succeed({
                name: (0, $e7fdbca395b7a04f$export$fdda1c9b501679e3),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            else experienceTracker.fail({
                name: (0, $e7fdbca395b7a04f$export$fdda1c9b501679e3),
                error: new Error(error.type),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            return {
                kind: 'failure',
                initError: {
                    type: error.type,
                    message: error.message
                }
            };
        }
        experienceTracker.fail({
            name: (0, $e7fdbca395b7a04f$export$fdda1c9b501679e3),
            error: new Error($2049fe8012434f76$export$703005ecc9b7c87e.UNKNOWN),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (error instanceof Error) return {
            kind: 'failure',
            initError: {
                type: $2049fe8012434f76$export$703005ecc9b7c87e.UNKNOWN,
                message: error.message
            }
        };
        return {
            kind: 'failure',
            initError: {
                type: $2049fe8012434f76$export$703005ecc9b7c87e.UNKNOWN
            }
        };
    }
    return {
        kind: 'success',
        loomSDKInstance: loomSDKInstance
    };
}
// this will hold our singleton result instance
let $2049fe8012434f76$var$initSDKResultPromise;
function $2049fe8012434f76$export$a6ae7697c0f5af9d(params) {
    // Singleton
    if ($2049fe8012434f76$var$initSDKResultPromise === undefined) $2049fe8012434f76$var$initSDKResultPromise = $2049fe8012434f76$var$_init(params);
    return $2049fe8012434f76$var$initSDKResultPromise;
}
function $2049fe8012434f76$export$1702a3de4c96a056() {
    $2049fe8012434f76$var$initSDKResultPromise = undefined;
}


const $b5fbe98a0f081479$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, environment: environment, cloudId: cloudId, productName: productName, onInsert: onInsert, insertButtonText: insertButtonText, renderOnInsertFallbackWhen: renderOnInsertFallbackWhen, skipInitialisation: skipInitialisation, eventHandler: eventHandler, experimentalFeatures: experimentalFeatures = {} })=>{
    const singletonLoomSDKRef = (0, $42omo.useRef)();
    const [loomInitError, setLoomInitError] = (0, $42omo.useState)();
    const [recorderState, setRecorderState] = (0, $42omo.useState)('initialising');
    const [userSegmentationData, setUserSegmentationData] = (0, $42omo.useState)({});
    const updateOnInsertIfUnmountedRef = (0, $42omo.useRef)();
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        async function initLoom() {
            const initResult = await (0, $2049fe8012434f76$export$a6ae7697c0f5af9d)({
                environment: environment,
                cloudId: cloudId,
                productName: productName,
                experienceTracker: experienceTracker,
                entryPointLocation: entryPointLocation
            });
            if (initResult.kind === 'success') {
                singletonLoomSDKRef.current = initResult.loomSDKInstance;
                // TODO - we need to set this to the current state of the singleton (maybe it's already recording), but currently no way to subscibe to changes in the global state
                setRecorderState('ready');
            } else {
                setLoomInitError(initResult.initError);
                setRecorderState('initialisation-failed');
            }
        }
        if (!skipInitialisation) {
            initLoom();
            (0, $dh538.fg)('loom_examples_in_sdk_killswitch') && (0, $ahR9w.getUserSegmentationData)(createAnalyticsEvent).then((resp)=>{
                setUserSegmentationData({
                    jobTitle: resp.title,
                    teamType: resp.teamType
                });
            });
        }
    // Assumption - the dependencies cannot change without a full page regresh
    }, [
        environment,
        cloudId,
        productName,
        experienceTracker,
        skipInitialisation,
        entryPointLocation,
        createAnalyticsEvent
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, $42omo.useEffect)(()=>{
        // this will run on unmount
        return function changeOnInsertBehaviorOnUnmount() {
            if (!singletonLoomSDKRef.current || !updateOnInsertIfUnmountedRef.current) return;
            if (renderOnInsertFallbackWhen === 'unmount') updateOnInsertIfUnmountedRef.current();
        };
    }, [
        renderOnInsertFallbackWhen
    ]);
    const openLoomRecorder = (0, $42omo.useCallback)(()=>{
        try {
            (0, $e7fdbca395b7a04f$export$873f91e3be81ab94).start();
            experienceTracker.start({
                id: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                name: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            // TODO - another instance can try to open the recorder while it's doing something else, we should disallow that by subscribing to the singleton state
            if (singletonLoomSDKRef.current === undefined) {
                (0, $e7fdbca395b7a04f$export$873f91e3be81ab94).cancel();
                const failureReason = 'still-initialising';
                experienceTracker.abort({
                    name: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                    reason: failureReason,
                    attributes: {
                        entryPointLocation: entryPointLocation
                    }
                });
                return {
                    isSuccess: false,
                    failureReason: failureReason
                };
            }
            if (singletonLoomSDKRef.current.status().state === 'active-recording') {
                (0, $e7fdbca395b7a04f$export$873f91e3be81ab94).cancel();
                const failureReason = 'already-recording';
                experienceTracker.abort({
                    name: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                    reason: failureReason,
                    attributes: {
                        entryPointLocation: entryPointLocation
                    }
                });
                return {
                    isSuccess: false,
                    failureReason: failureReason
                };
            }
            const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current;
            const sdkButton = configureButton();
            updateConfig({
                config: {
                    insertButtonText: insertButtonText,
                    entryPointName: entryPointLocation,
                    ...(0, $dh538.fg)('loom_examples_in_sdk_killswitch') && {
                        experimentalFeatures: {
                            teamType: userSegmentationData.teamType,
                            ...experimentalFeatures
                        }
                    }
                }
            });
            sdkButton.on('start', ()=>{
                eventHandler?.onStart?.();
            });
            sdkButton.on('recording-start', ()=>{
                eventHandler?.onRecordingStarted?.();
                setRecorderState('recording');
            });
            sdkButton.on('cancel', ()=>{
                eventHandler?.onCancel?.();
            });
            sdkButton.on('complete', ()=>{
                eventHandler?.onComplete?.();
            });
            sdkButton.on('recording-complete', (video)=>{
                eventHandler?.onRecordingComplete?.(video);
            });
            sdkButton.on('upload-complete', (video)=>{
                eventHandler?.onUploadComplete?.(video);
            });
            sdkButton.on('insert-click', (video)=>{
                onInsert(video.sharedUrl, video);
                eventHandler?.onInsertClicked?.(false);
                experienceTracker.succeed({
                    name: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                    attributes: {
                        inserted: true,
                        entryPointLocation: entryPointLocation
                    }
                });
            });
            updateOnInsertIfUnmountedRef.current = ()=>{
                updateConfig({
                    config: {
                        // TODO - format message?
                        insertButtonText: 'Open on Loom'
                    }
                });
                sdkButton.off('insert-click');
                sdkButton.on('insert-click', (video)=>{
                    if (typeof window !== 'undefined') {
                        window.open(video.sharedUrl, '_blank');
                        experienceTracker.succeed({
                            name: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                            attributes: {
                                inserted: true,
                                insertFunctionWasReset: true,
                                entryPointLocation: entryPointLocation
                            }
                        });
                    }
                    eventHandler?.onInsertClicked?.(true);
                });
            };
            sdkButton.on('lifecycle-update', (lifecycleState)=>{
                if (lifecycleState === 'pre-recording') {
                    setRecorderState('pre-recording');
                    (0, $e7fdbca395b7a04f$export$873f91e3be81ab94).stop();
                } else if (lifecycleState === 'post-recording') {
                    if (typeof renderOnInsertFallbackWhen === 'function' && renderOnInsertFallbackWhen() && !!updateOnInsertIfUnmountedRef.current) updateOnInsertIfUnmountedRef.current();
                    setRecorderState('post-recording');
                } else if (lifecycleState === 'closed') {
                    setRecorderState('ready');
                    experienceTracker.succeed({
                        name: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                        attributes: {
                            closed: true,
                            entryPointLocation: entryPointLocation
                        }
                    });
                    updateOnInsertIfUnmountedRef.current = undefined;
                } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                    name: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                    attributes: {
                        cascaded: true,
                        entryPointLocation: entryPointLocation
                    }
                });
            });
            sdkButton.openPreRecordPanel();
            return {
                isSuccess: true
            };
        } catch (error) {
            (0, $e7fdbca395b7a04f$export$873f91e3be81ab94).cancel();
            experienceTracker.fail({
                name: (0, $e7fdbca395b7a04f$export$5e1aeeb6f31be57a),
                error: error instanceof Error ? error : new Error('unknown error in openLoomRecorder'),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            return {
                isSuccess: false,
                failureReason: 'unexpected-error'
            };
        }
    }, [
        onInsert,
        entryPointLocation,
        insertButtonText,
        renderOnInsertFallbackWhen,
        experienceTracker,
        eventHandler,
        userSegmentationData.teamType,
        experimentalFeatures
    ]);
    return loomInitError ? {
        recorderState: 'initialisation-failed',
        loomInitError: loomInitError,
        openLoomRecorder: null
    } : {
        openLoomRecorder: openLoomRecorder,
        loomInitError: null,
        recorderState: recorderState
    };
};









const $c9b4f272f6863880$var$messages = (0, $cgtv4.defineMessages)({
    insertButtonText: {
        id: "universal-create.loom-video-menu-item.share-video",
        defaultMessage: "Share"
    }
});
function $c9b4f272f6863880$export$d8ef0486cf8cfe05({ cloudId: cloudId, productName: productName, environment: environment = 'prod', onItemClick: onItemClick, skipInitialisation: skipInitialisation = false }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isNav4Enabled: isNav4Enabled, product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const attributes = {
        isNav4: isNav4Enabled,
        product: product,
        subProduct: subProduct
    };
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $b5fbe98a0f081479$export$c8d9dc913e9e33ec)({
        entryPointLocation: (0, $38e5614694cf6bb5$export$c2ae99333adf8094),
        environment: environment,
        cloudId: cloudId,
        productName: productName,
        onInsert: (videoUrl)=>{
            const url = new URL(videoUrl);
            // Open video in new tab with share permissions modal open
            url.searchParams.set('open_share_permissions', '1');
            window.open(url.toString(), '_blank', 'noopener');
        },
        insertButtonText: formatMessage($c9b4f272f6863880$var$messages.insertButtonText),
        eventHandler: {
            onRecordingComplete: ()=>createAnalyticsEvent({
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    eventType: 'track',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL)),
            onUploadComplete: ()=>createAnalyticsEvent({
                    action: 'uploaded',
                    actionSubject: 'loomRecording',
                    eventType: 'track',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL)),
            onInsertClicked: ()=>createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'insertVideoLink',
                    eventType: 'ui',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL))
        },
        skipInitialisation: skipInitialisation
    });
    const onClick = (0, $42omo.useCallback)(()=>{
        if (openLoomRecorder) {
            onItemClick?.((0, $dh538.fg)('navx-2354-uc-refactor-ati-preset') ? (0, $9DI9J.ATI_PRESETS).LOOM : (0, $9DI9J.LOOM_ATI));
            openLoomRecorder();
        }
    }, [
        openLoomRecorder,
        onItemClick
    ]);
    switch(recorderState){
        case 'initialising':
            return {
                isLoading: true
            };
        case 'ready':
            if (openLoomRecorder) return {
                onClick: onClick
            };
            return {
                isDisabled: true
            };
        default:
            return {
                isDisabled: true
            };
    }
}


const $a045c9e8d9067aa0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    loomVideo: {
        id: "universal-create.loom-video-menu-item.create-loom-video",
        defaultMessage: "Loom video"
    }
});
function $a045c9e8d9067aa0$export$f8e8ac264d7fe02e(product, subProduct) {
    switch(product){
        case 'townsquare':
            if (subProduct === 'goal') return 'GOAL';
            if (subProduct === 'teams') return 'TEAMS';
            if (subProduct === 'home') return 'HOME';
            return 'TOWNSQUARE';
        case 'confluence':
            return 'CONFLUENCE';
        case 'rovoExtension':
            return 'ROVO_EXTENSION';
        default:
            return 'UNKNOWN';
    }
}
/**
 * Higher-order component that wraps a component with Loom video configuration
 * @param WrappedComponent - The component to wrap with Loom video configuration
 * @returns A new component with Loom video configuration applied
 */ function $a045c9e8d9067aa0$var$withLoomVideoConfig(WrappedComponent) {
    return function WithLoomVideoConfigComponent(props) {
        const { context: context, product: product } = props;
        const customisedItemConfig = (0, $c9b4f272f6863880$export$d8ef0486cf8cfe05)({
            cloudId: context.cloudId,
            productName: $a045c9e8d9067aa0$export$f8e8ac264d7fe02e(product),
            environment: context.environment || 'prod',
            onItemClick: context.onItemClick
        });
        const finalItemConfig = {
            ...customisedItemConfig
        };
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: finalItemConfig
        });
    };
}
const $a045c9e8d9067aa0$export$7b2dceeaf04ce250 = $a045c9e8d9067aa0$var$withLoomVideoConfig((0, $27f0e6b33328c20f$export$b5de039d8eaccb66));



function $54e4d0be0033339a$var$renderPlatformSuggestionItem({ responseItem: responseItem, itemIndex: itemIndex, totalItemsCount: totalItemsCount, context: context, product: product }) {
    switch(responseItem.ati){
        case (0, $9DI9J.ATI_PRESETS).LOOM:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $a045c9e8d9067aa0$export$7b2dceeaf04ce250), {
                responseItem: responseItem,
                context: context,
                product: product,
                itemIndex: itemIndex,
                totalItemsCount: totalItemsCount
            });
        case (0, $9DI9J.ATI_PRESETS).GOAL:
        case (0, $9DI9J.ATI_PRESETS).PROJECT:
        case (0, $9DI9J.ATI_PRESETS).TEAM:
            {
                if (!(0, $dh538.fg)('navx_uc_platformisation_forms_enabled')) return null; // should not show this item if the feature flag is off
                const loadCreateContent = (0, $b19599a70b1ea9c9$export$38e36ff3c4cb0c61)(responseItem.ati);
                const customisedItemConfig = {
                    loadCreateContent: loadCreateContent,
                    onClickCloseMenu: !loadCreateContent
                };
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $27f0e6b33328c20f$export$b5de039d8eaccb66), {
                    responseItem: responseItem,
                    itemIndex: itemIndex,
                    totalItemsCount: totalItemsCount,
                    customisedItemConfig: customisedItemConfig
                });
            }
        default:
            return undefined;
    }
}
function $54e4d0be0033339a$var$renderSuggestionItem({ responseItem: responseItem, itemIndex: itemIndex, totalItemsCount: totalItemsCount, context: context, product: product }) {
    switch(responseItem.type){
        case 'platform':
            return $54e4d0be0033339a$var$renderPlatformSuggestionItem({
                responseItem: responseItem,
                itemIndex: itemIndex,
                totalItemsCount: totalItemsCount,
                context: context,
                product: product
            });
        case 'link':
            return(// eslint-disable-next-line @atlassian/a11y/anchor-is-valid, @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1b108bbe34f9b79a$export$532cb6865ebe8946), {
                responseItem: responseItem,
                context: context,
                product: product,
                itemIndex: itemIndex,
                totalItemsCount: totalItemsCount
            }));
        default:
            break;
    }
    return undefined;
}
function $54e4d0be0033339a$var$SuggestionItemInner({ responseItem: responseItem, itemIndex: itemIndex, totalItemsCount: totalItemsCount, context: context, product: product }) {
    if (context) {
        const renderedItem = $54e4d0be0033339a$var$renderSuggestionItem({
            responseItem: responseItem,
            itemIndex: itemIndex,
            totalItemsCount: totalItemsCount,
            context: context,
            product: product
        });
        if (renderedItem !== undefined) return renderedItem;
    }
    // Return general suggestion item with no customisedItemConfig
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $27f0e6b33328c20f$export$b5de039d8eaccb66), {
        responseItem: responseItem,
        itemIndex: itemIndex,
        totalItemsCount: totalItemsCount
    });
}
function $54e4d0be0033339a$export$18af743539b68cfc(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($54e4d0be0033339a$var$SuggestionItemInner, {
            ...props
        })
    });
}


const $be7df9cf7c49e65b$var$messages = (0, $cgtv4.defineMessages)({
    sectionHeading: {
        id: "platform.navigation-experiences.universal-create.suggestion.section-heading",
        defaultMessage: "{count, plural, one {Suggestion} other {Suggestions}}"
    }
});
function $be7df9cf7c49e65b$var$SuggestionMenuSectionContent() {
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { mixedItems: mixedItems, product: product, suggestionConfig: suggestionConfig, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const cloudId = suggestionConfig.enabled ? suggestionConfig.cloudId : '';
    const orgId = suggestionConfig.enabled ? suggestionConfig.orgId : '';
    const userId = suggestionConfig.enabled ? suggestionConfig.accountId : '';
    const compact = suggestionConfig.enabled && !!suggestionConfig.compact;
    const location = suggestionConfig.enabled ? suggestionConfig.location : 'end'; // Use the shared hooks for ATIs logic
    const nativeAtis = (0, $bdcbf50357937847$export$ace2aad66e79cd4e)();
    const preferredAtis = (0, $060ce356f1549e47$export$4984a78a2f2592cd)();
    const excludeAtis = (0, $060ce356f1549e47$export$d6dcc91285361556)();
    const { data: data, isLoading: isLoading, hasError: hasError } = (0, $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2)({
        cloudId: cloudId,
        orgId: orgId,
        userId: userId,
        product: product,
        subProduct: subProduct,
        locale: locale,
        nativeAtis: nativeAtis,
        preferredAtis: preferredAtis,
        excludeAtis: excludeAtis
    });
    const [showAll, setShowAll] = (0, $42omo.useState)(false);
    const handleShowMore = (0, $42omo.useCallback)(()=>{
        setShowAll((prev)=>!prev);
    }, [
        setShowAll
    ]);
    const { fireNewSuggestionsMenuViewed_old: fireNewSuggestionsMenuViewed_old, fireNewSuggestionsMenuViewed: fireNewSuggestionsMenuViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    (0, $42omo.useEffect)(()=>{
        const items = data?.items;
        if (items?.length) {
            const suggestedItems = items.map((item)=>item.ati);
            if ((0, $dh538.fg)('navx-2236-unified-instrumentation-updates')) fireNewSuggestionsMenuViewed({
                crossAppSuggestionsEnabled: suggestionConfig.enabled || false,
                suggestionsGroupCount: 0,
                suggestionsItemCount: items.length,
                suggestionGroupList: [
                    {
                        // Note: Currently only one suggestion section is supported, and more button is not in use
                        groupHeading: formatMessage($be7df9cf7c49e65b$var$messages.sectionHeading, {
                            count: items.length
                        }),
                        groupIndex: 0,
                        groupItemAtisList: suggestedItems,
                        groupItemCount: items.length,
                        inMoreItemAtisList: [],
                        inMoreItemCount: 0,
                        showMoreButton: false // At the moment, no foldable attribute is provided for primitive section component, therefore this is always false
                    }
                ]
            });
            else fireNewSuggestionsMenuViewed_old({
                crossAppSuggestionsEnabled: suggestionConfig.enabled || false,
                suggestionMenuGroup: {
                    displayModeCompact: compact,
                    itemAtis: suggestedItems,
                    showMoreButton: false,
                    // At the moment, no foldable attribute is provided for primitive section component, therefore this is always false
                    suggestionLocation: location
                },
                totalSuggestionItems: items.length
            });
        }
    }, [
        data,
        fireNewSuggestionsMenuViewed,
        fireNewSuggestionsMenuViewed_old,
        formatMessage,
        compact,
        location,
        suggestionConfig.enabled
    ]);
    if (suggestionConfig.enabled && isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d1f757cfbbc3d137$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e), {
            testId: "loading-suggestion-section"
        })
    });
    if (!suggestionConfig.enabled || hasError || !data?.items?.length) return null;
    const items = data.items;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d690491b6d31182a$export$2e2bcd8739ae039), {
        sectionIndex: location === 'start' ? 0 : mixedItems.length + 1,
        itemLength: items.length,
        showAll: showAll,
        toggleShowMore: handleShowMore,
        compact: compact,
        heading: formatMessage($be7df9cf7c49e65b$var$messages.sectionHeading, {
            count: items.length
        }),
        isNative: false,
        children: items.map((responseItem, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $54e4d0be0033339a$export$18af743539b68cfc), {
                responseItem: responseItem,
                context: suggestionConfig,
                product: product,
                itemIndex: index,
                totalItemsCount: items.length
            }, `suggestion-menu-item-${responseItem.ati}`))
    });
}
function $be7df9cf7c49e65b$export$2e2bcd8739ae039() {
    // We need better error boundary, this is a temporary solution
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($be7df9cf7c49e65b$var$SuggestionMenuSectionContent, {})
    });
}


const $6ab96820cdb7ca90$var$styles = {
    menuWrap: "_ca0qu2gc _n3tdu2gc"
};
function $6ab96820cdb7ca90$var$MenuContent() {
    const { mixedItems: mixedItems, suggestionConfig: suggestionConfig } = (0, $19BZl.useMenuControl)();
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { fireNewNativeMenuViewed_old: fireNewNativeMenuViewed_old, fireNewNativeMenuViewed: fireNewNativeMenuViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const analyticsFired = (0, $42omo.useRef)(false);
    // Check if any menu items are currently loading
    const hasLoadingItems = mixedItems.some((section)=>section.items.some((item)=>item.isLoading === true));
    const sectionsToAnalyze = mixedItems.slice(0, (0, $38e5614694cf6bb5$export$4e49778ae689b92a));
    (0, $42omo.useEffect)(()=>{
        if (mixedItems.length > 0 && !hasLoadingItems && !analyticsFired.current) {
            const totalNativeItems = sectionsToAnalyze.reduce((total, section)=>total + section.items.length, 0);
            let unnamedSectionIndex = 0;
            if ((0, $dh538.fg)('navx-2236-unified-instrumentation-updates')) {
                const sections = sectionsToAnalyze.map((namedItem, sectionIndex)=>{
                    const moreButtonEnabled = (0, $d690491b6d31182a$export$c8ef8ec3af207203)(namedItem.foldable, namedItem.items.length);
                    return {
                        groupHeading: namedItem.heading || `native-section-${unnamedSectionIndex++}`,
                        groupIndex: sectionIndex,
                        // Index of section out of all sections
                        groupItemCount: namedItem.items.length,
                        // total number of items in the section
                        groupItemAtisList: moreButtonEnabled ? namedItem.items.slice(0, (0, $d690491b6d31182a$export$e69afd517cd76d77)(namedItem.foldable)).map((item)=>item.ati.toString()) : namedItem.items.map((item)=>item.ati.toString()),
                        inMoreItemAtisList: moreButtonEnabled ? namedItem.items.slice((0, $d690491b6d31182a$export$e69afd517cd76d77)(namedItem.foldable)).map((item)=>item.ati.toString()) : [],
                        inMoreItemCount: moreButtonEnabled ? namedItem.items.length - (0, $d690491b6d31182a$export$e69afd517cd76d77)(namedItem.foldable) : 0,
                        showMoreButton: moreButtonEnabled // true if items in section have been truncated with show more button
                    };
                });
                fireNewNativeMenuViewed({
                    crossAppSuggestionsEnabled: crossAppCreationEnabled,
                    nativeGroupCount: sectionsToAnalyze.length,
                    nativeItemCount: totalNativeItems,
                    nativeMenuGroups: sections
                });
            } else {
                const sections = sectionsToAnalyze.map((namedItem, sectionIndex)=>({
                        groupHeading: namedItem.heading || `native-section-${unnamedSectionIndex++}`,
                        groupIndex: sectionIndex,
                        // Index of section out of all sections
                        groupItemCount: namedItem.items.length,
                        // total number of items in the section
                        itemAtis: namedItem.items.map((item)=>item.ati.toString()),
                        // Atis of items in the section
                        showMoreButton: (0, $d690491b6d31182a$export$c8ef8ec3af207203)(namedItem.foldable, namedItem.items.length) // true if items in section have been truncated with show more button
                    }));
                fireNewNativeMenuViewed_old({
                    crossAppSuggestionsEnabled: crossAppCreationEnabled,
                    totalGroups: sectionsToAnalyze.length,
                    totalNativeItems: totalNativeItems,
                    nativeMenuGroups: sections
                });
            }
            analyticsFired.current = true;
        }
    }, [
        mixedItems,
        hasLoadingItems,
        crossAppCreationEnabled,
        fireNewNativeMenuViewed,
        fireNewNativeMenuViewed_old,
        sectionsToAnalyze
    ]);
    // Reset analytics when loading state changes
    (0, $42omo.useEffect)(()=>{
        if (hasLoadingItems) analyticsFired.current = false;
    }, [
        hasLoadingItems
    ]);
    if (!mixedItems.length) return null;
    const isSuggestionSectionEnabled = crossAppCreationEnabled && suggestionConfig.enabled;
    // including a check for enabled here ensures we avoid error TS2339 Property location does not exist on type SuggestionConfigDisabled
    const showSuggestionsAtStart = suggestionConfig?.enabled && suggestionConfig?.location === 'start';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        spacing: "compact",
        testId: "global-create-content-popover-menu",
        ...sectionsToAnalyze.some((section)=>section.foldable === 'enhanced') && (0, $dh538.fg)('navx_universal_create_overflow_mode') ? {
            maxHeight: (0, $38e5614694cf6bb5$export$441df76988f6d01)
        } : undefined,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($6ab96820cdb7ca90$var$styles.menuWrap),
            children: [
                isSuggestionSectionEnabled && showSuggestionsAtStart && /*#__PURE__*/ (0, $l998X.jsx)((0, $be7df9cf7c49e65b$export$2e2bcd8739ae039), {}),
                sectionsToAnalyze.map((namedItem, sectionIndex)=>{
                    const totalNativeItems = sectionsToAnalyze.reduce((total, section)=>total + section.items.length, 0);
                    // Calculate the starting index for this section by summing items from all previous sections
                    const sectionStartIndex = sectionsToAnalyze.slice(0, sectionIndex).reduce((total, section)=>total + section.items.length, 0);
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0b21ce6c65459807$export$2e2bcd8739ae039), {
                        namedItems: namedItem,
                        sectionIndex: isSuggestionSectionEnabled && showSuggestionsAtStart && !suggestionConfig.compact ? sectionIndex + 1 : sectionIndex,
                        totalMenuItemsCount: totalNativeItems,
                        sectionStartIndex: sectionStartIndex
                    }, `menu-section-${sectionIndex}`);
                }),
                isSuggestionSectionEnabled && !showSuggestionsAtStart && /*#__PURE__*/ (0, $l998X.jsx)((0, $be7df9cf7c49e65b$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $6ab96820cdb7ca90$export$2e2bcd8739ae039 = (0, $503da3927b063db6$export$a5d940130f33be3f)($6ab96820cdb7ca90$var$MenuContent);















var $gWF6I = parcelRequire("gWF6I");





function $6477ac45fd3dd7b4$export$98eff9c5659394e3({ children: children }) {
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { product: product, suggestionConfig: suggestionConfig, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const { locale: locale } = (0, $8C5kA.default)();
    // Use the shared hooks for ATIs logic
    const nativeAtis = (0, $bdcbf50357937847$export$ace2aad66e79cd4e)();
    const preferredAtis = (0, $060ce356f1549e47$export$4984a78a2f2592cd)();
    const excludeAtis = (0, $060ce356f1549e47$export$d6dcc91285361556)();
    const { fetchUCSuggestions: fetchUCSuggestions } = (0, $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        orgId: suggestionConfig.enabled ? suggestionConfig.orgId : '',
        userId: suggestionConfig.enabled ? suggestionConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: suggestionConfig.enabled ? subProduct : undefined,
        nativeAtis: nativeAtis,
        preferredAtis: preferredAtis,
        excludeAtis: excludeAtis
    });
    (0, $42omo.useEffect)(()=>{
        if (crossAppCreationEnabled && suggestionConfig.enabled) fetchUCSuggestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        crossAppCreationEnabled,
        suggestionConfig.enabled,
        locale
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.ConditionalRelayEnvironmentProvider), {
        children: children
    });
}

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


























function $9e0b6cda42c52c0b$var$PopupWrapperContent({ children: children }) {
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { product: product, suggestionConfig: suggestionConfig, subProduct: subProduct } = (0, $19BZl.useMenuControl)(); // Determine if prefetch is enabled based on suggestionConfig.prefetch
    const isPrefetchEnabled = suggestionConfig.enabled && suggestionConfig.prefetch === true;
    const { locale: locale } = (0, $8C5kA.default)();
    // This gets around TypeScript errors where it doesn't understand that we expect suggestionConfig to be
    // of type SuggestionConfigEnabled where we check for and use onResultChange, never SuggestionConfigDisabled
    const onResultChange = suggestionConfig.enabled ? suggestionConfig?.onResultChange : undefined;
    // Use the shared hooks for ATIs logic
    const nativeAtis = (0, $bdcbf50357937847$export$ace2aad66e79cd4e)();
    const preferredAtis = (0, $060ce356f1549e47$export$4984a78a2f2592cd)();
    const excludeAtis = (0, $060ce356f1549e47$export$d6dcc91285361556)();
    const { status: status, data: data, isLoading: isLoading, hasError: hasError, fetchUCSuggestions: fetchUCSuggestions } = (0, $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        orgId: suggestionConfig.enabled ? suggestionConfig.orgId : '',
        userId: suggestionConfig.enabled ? suggestionConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: suggestionConfig.enabled ? subProduct : undefined,
        nativeAtis: nativeAtis,
        preferredAtis: preferredAtis,
        excludeAtis: excludeAtis
    });
    const LoomAti = (0, $dh538.fg)('navx-2354-uc-refactor-ati-preset') ? (0, $9DI9J.ATI_PRESETS).LOOM : (0, $9DI9J.LOOM_ATI);
    const hasLoomEnabled = !isLoading && !hasError && data?.items?.some((item)=>item.ati === LoomAti);
    const skipInitialisation = !isPrefetchEnabled || !crossAppCreationEnabled || !hasLoomEnabled;
    const shouldFetchSuggestions = crossAppCreationEnabled && isPrefetchEnabled && suggestionConfig.enabled;
    (0, $c9b4f272f6863880$export$d8ef0486cf8cfe05)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        productName: (0, $a045c9e8d9067aa0$export$f8e8ac264d7fe02e)(product),
        environment: suggestionConfig.enabled && suggestionConfig?.environment || 'prod',
        onItemClick: suggestionConfig.enabled ? suggestionConfig.onItemClick : undefined,
        skipInitialisation: skipInitialisation
    });
    // Trigger fetch when environment changes
    (0, $42omo.useEffect)(function fetchUCSuggestionsForLoomEnabledApps() {
        if (shouldFetchSuggestions) fetchUCSuggestions();
    }, [
        shouldFetchSuggestions,
        fetchUCSuggestions
    ]);
    // Memoize the BFF status scenario we want to check against
    // so that our notifySuggestionResultChange effect does not run for all non-init statuses individually
    const bffHasInitialized = (0, $42omo.useMemo)(()=>{
        return status !== (0, $4jETc.RequestStatus).INIT;
    }, [
        status
    ]); // Notify consumer when the suggestion result changes
    // (if they provided an onResultChange function and the conditions for whether to use it are met).
    // We call this in a second effect rather than after the fetchUCSuggestions promise resolves, in case
    // the data or error state changes some other way.
    (0, $42omo.useEffect)(function notifySuggestionResultChange() {
        // we should theoretically not need to check against shouldFetchSuggestions in this effect,
        // because if it's false the data/loading/error values should not change...as long as the BFF status is INIT.
        // If somehow the BFF status is not INIT, onResultChange would run if we didn't check this here.
        if (!shouldFetchSuggestions) return;
        if (onResultChange && bffHasInitialized) onResultChange?.({
            data: data,
            isLoading: isLoading,
            hasError: hasError
        });
    }, [
        onResultChange,
        data,
        isLoading,
        hasError,
        bffHasInitialized,
        shouldFetchSuggestions
    ]);
    return children;
}
function $9e0b6cda42c52c0b$export$3354c7b2b0c57e({ children: children }) {
    // We need better error boundary, this is a temporary solution
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: children
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($9e0b6cda42c52c0b$var$PopupWrapperContent, {
            children: children
        })
    });
}

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






















var $dv953 = parcelRequire("dv953");









/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




function $d7c773b6c8a524b1$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            source: 'topNav'
        },
        children: children
    });
}













// ===============================
// UC Menu Items V2 API Communication
// ===============================






/**
 * Encode configuration to binary format with query parameters
 */ /**
 * Encode ATI string to binary representation
 */ /**
 * Utility functions for parsing and constructing ATI strings
 * Uses @atlassian/ari package for ATI parsing
 */ 


function $0bf79e81331e4541$export$5597e67f4dded1e6(ati) {
    try {
        const parsed = (0, $6yCpa.Ati).parse(ati);
        return {
            prefix: parsed.platformQualifier,
            owner: parsed.resourceOwner,
            type: parsed.resourceType
        };
    } catch  {
        throw new Error(`Invalid ATI format: expected "ati:<prefix>:<owner>:<type>", got "${ati}"`);
    }
}
function $0bf79e81331e4541$export$9acdaf42ad16ae47({ prefix: prefix, owner: owner, type: type }) {
    if (!prefix || !owner || !type) throw new Error('All ATI components (prefix, owner, type) must be non-empty');
    try {
        const ati = (0, $6yCpa.Ati).create({
            platformQualifier: prefix,
            resourceOwner: owner,
            resourceType: type
        });
        return ati.toString();
    } catch  {
        throw new Error('Failed to construct ATI from components');
    }
}
function $0bf79e81331e4541$export$9039e3b1770c6b8(ati) {
    if (typeof ati !== 'string') return false;
    try {
        (0, $6yCpa.Ati).parse(ati);
        return true;
    } catch  {
        return false;
    }
}
function $0bf79e81331e4541$export$912bb685303c4ec7(items) {
    return Object.fromEntries(items.map((item, index)=>[
            item,
            index
        ]));
}


/**
 * Binary Encoding Constants for Universal Create Menu (V2 API)
 *
 * This module defines the constants used for encoding/decoding ATI configurations
 * into a compact binary format for URL transmission.
 *
 * These constants are shared across frontend and backend for binary encoding/decoding operations.
 */ 
const $dccf36f4b2146e6b$export$3167453beff01750 = 2;
const $dccf36f4b2146e6b$export$b2144c689c2ff042 = [
    'cloud',
    'third-party'
];
const $dccf36f4b2146e6b$export$61beacecbf214ae6 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$b2144c689c2ff042);
const $dccf36f4b2146e6b$export$89e1a37ecee09500 = [
    // ALL NEW RESOURCE OWNERS MUST BE ADDED AT THE END OF THIS LIST
    'jira',
    'confluence',
    'loom',
    'townsquare',
    'trello',
    'bitbucket',
    'opsgenie',
    'compass',
    'statuspage',
    'atlas'
];
const $dccf36f4b2146e6b$export$83dfff18be6bef06 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$89e1a37ecee09500);
const $dccf36f4b2146e6b$export$9dd62a2b56d5462d = [
    // ALL NEW RESOURCE TYPES MUST BE ADDED AT THE END OF THIS LIST
    'issue',
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'space',
    'video',
    'goal',
    'project',
    'team',
    'post',
    'board',
    'repository',
    'workspace',
    'component',
    'embed',
    'livedoc',
    'chat',
    'agent'
];
const $dccf36f4b2146e6b$export$38830b2321100ef2 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$9dd62a2b56d5462d);
const $dccf36f4b2146e6b$export$b1e8f8dc54861a99 = 3;
const $dccf36f4b2146e6b$export$21d9e5eeb6ffaecd = 1;
const $dccf36f4b2146e6b$export$19409b356a31bc6d = {
    // Byte 0 masks
    PREFIX_FLAG_MASK: 128,
    OWNER_FLAG_MASK: 64,
    TYPE_FLAG_MASK: 32,
    PREFIX_VALUE_MASK: 16,
    OWNER_UPPER_MASK: 15,
    // Byte 1 masks
    OWNER_LOWER_MASK: 240,
    TYPE_UPPER_MASK: 15,
    // Byte 2 masks
    TYPE_LOWER_MASK: 255
};
const $dccf36f4b2146e6b$export$4c68bfc8c9124205 = {
    PREFIX_FLAG_SHIFT: 7,
    OWNER_FLAG_SHIFT: 6,
    TYPE_FLAG_SHIFT: 5,
    PREFIX_VALUE_SHIFT: 4,
    OWNER_LOWER_SHIFT: 4,
    OWNER_UPPER_BITS: 4,
    TYPE_UPPER_SHIFT: 4,
    TYPE_UPPER_BITS: 8
};
const $dccf36f4b2146e6b$export$597234ac346c7ad8 = 256;
const $dccf36f4b2146e6b$export$8c22d9b338278eca = 4096;
const $dccf36f4b2146e6b$export$3010378ceda42048 = 256;
const $dccf36f4b2146e6b$export$6048538928ea261a = 4096;
const $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa = 2;
const $dccf36f4b2146e6b$export$4030221cfc1fb63c = 5;
const $dccf36f4b2146e6b$export$ece7c64a85a33d85 = 255;
const $dccf36f4b2146e6b$export$6747badc61b8e57b = 512;
const $dccf36f4b2146e6b$export$48ffef5fac2e11a = 10;
const $dccf36f4b2146e6b$export$c38e76af505e38a1 = [
    'native',
    'link',
    'platform'
];
const $dccf36f4b2146e6b$export$3dcfc8418d714114 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$c38e76af505e38a1);
const $dccf36f4b2146e6b$export$c89f8194e7716284 = [
    'off',
    'full',
    'overflow'
];
const $dccf36f4b2146e6b$export$6cabc9b146da4ac8 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$c89f8194e7716284);
const $dccf36f4b2146e6b$export$9c3e0a77c247e0c = [
    'appDefinedSection',
    'suggestionSection'
];
const $dccf36f4b2146e6b$export$1e5c4f2c7d35f342 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$9c3e0a77c247e0c);
const $dccf36f4b2146e6b$export$dab292c7293b69ae = [
    '~',
    '|',
    ',',
    ':'
];


/**
 * Get configuration for a specific component kind
 */ function $bcdba2959b20769a$var$getComponentConfig(unknowns, kind) {
    switch(kind){
        case 'prefix':
            return {
                array: unknowns.prefixes,
                maxLimit: (0, $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa),
                errorMessage: `Too many unknown ATI prefixes (max ${0, $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa})`
            };
        case 'owner':
            return {
                array: unknowns.owners,
                maxLimit: (0, $dccf36f4b2146e6b$export$3010378ceda42048),
                errorMessage: `Too many unknown resource owners (max ${0, $dccf36f4b2146e6b$export$3010378ceda42048})`
            };
        case 'type':
            return {
                array: unknowns.types,
                maxLimit: (0, $dccf36f4b2146e6b$export$6048538928ea261a),
                errorMessage: `Too many unknown resource types (max ${0, $dccf36f4b2146e6b$export$6048538928ea261a})`
            };
    }
}
/**
 * Ensure capacity for a component kind
 * @throws Error if capacity limit is exceeded
 */ function $bcdba2959b20769a$var$ensureCapacity(unknowns, kind) {
    const config = $bcdba2959b20769a$var$getComponentConfig(unknowns, kind);
    if (config.array.length >= config.maxLimit) throw new Error(config.errorMessage);
}
/**
 * Track unknown component value and return its index
 * Reuses existing index if value already tracked
 */ function $bcdba2959b20769a$var$trackUnknown({ unknowns: unknowns, kind: kind, value: value }) {
    const config = $bcdba2959b20769a$var$getComponentConfig(unknowns, kind);
    const existing = config.array.indexOf(value);
    if (existing !== -1) return existing;
    $bcdba2959b20769a$var$ensureCapacity(unknowns, kind);
    config.array.push(value);
    return config.array.length - 1;
}
/**
 * Encode a component (prefix/owner/type) to its code
 * Returns code and unknown flag
 */ function $bcdba2959b20769a$var$encodeComponent({ unknowns: unknowns, kind: kind, value: value, knownMap: knownMap }) {
    const knownCode = knownMap[value];
    const isUnknown = knownCode === undefined;
    const code = isUnknown ? $bcdba2959b20769a$var$trackUnknown({
        unknowns: unknowns,
        kind: kind,
        value: value
    }) : knownCode;
    return {
        code: code,
        isUnknown: isUnknown
    };
}
function $bcdba2959b20769a$export$4b052fcb66ebb451(ati, unknowns) {
    const { prefix: prefix, owner: owner, type: type } = (0, $0bf79e81331e4541$export$5597e67f4dded1e6)(ati);
    const { code: prefixCode, isUnknown: prefixIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'prefix',
        value: prefix,
        knownMap: (0, $dccf36f4b2146e6b$export$61beacecbf214ae6)
    });
    const { code: ownerCode, isUnknown: ownerIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'owner',
        value: owner,
        knownMap: (0, $dccf36f4b2146e6b$export$83dfff18be6bef06)
    });
    const { code: typeCode, isUnknown: typeIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'type',
        value: type,
        knownMap: (0, $dccf36f4b2146e6b$export$38830b2321100ef2)
    });
    return {
        prefixCode: prefixCode,
        prefixIsUnknown: prefixIsUnknown,
        ownerCode: ownerCode,
        ownerIsUnknown: ownerIsUnknown,
        typeCode: typeCode,
        typeIsUnknown: typeIsUnknown
    };
}
function $bcdba2959b20769a$export$9fa514be131db9ec({ encoded: encoded, buffer: buffer, offset: offset }) {
    const { prefixCode: prefixCode, prefixIsUnknown: prefixIsUnknown, ownerIsUnknown: ownerIsUnknown, typeIsUnknown: typeIsUnknown, ownerCode: ownerCode, typeCode: typeCode } = encoded;
    // Byte 0: [P|O|T|P|OOOO]
    const ownerUpper = ownerCode >> (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_UPPER_BITS & 0x0f;
    const byte0 = (prefixIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).PREFIX_FLAG_SHIFT | (ownerIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_FLAG_SHIFT | (typeIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).TYPE_FLAG_SHIFT | (prefixCode & 0x01) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).PREFIX_VALUE_SHIFT | ownerUpper;
    // Byte 1: [OOOO|TTTT]
    const ownerLower = ownerCode & 0x0f;
    const typeUpper = typeCode >> 8 & 0x0f;
    const byte1 = ownerLower << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_LOWER_SHIFT | typeUpper;
    // Byte 2: [TTTTTTTT]
    const byte2 = typeCode & 0xff;
    // Write bytes directly (inline writeUInt8)
    buffer[offset] = byte0 & 0xff;
    buffer[offset + 1] = byte1 & 0xff;
    buffer[offset + 2] = byte2 & 0xff;
}


/**
 * Platform-agnostic buffer utilities for binary encoding/decoding
 * Works in both browser and Node.js environments
 */ /**
 * Encode Uint8Array to base64url string (without padding)
 *
 * @param bytes - Uint8Array to encode
 * @returns Base64URL-encoded string
 */ 
var $iA9co = parcelRequire("iA9co");

var $5120b89f81d97ddd$require$Buffer = $iA9co.Buffer;
function $5120b89f81d97ddd$export$b0ffcdf8b133e63c(bytes) {
    if (bytes.length === 0) return '';
    if (btoa === undefined) return $5120b89f81d97ddd$require$Buffer.from(bytes).toString('base64url');
    else {
        // Browser: convert to binary string using Array.from (safe for large arrays and null bytes)
        const binaryString = Array.from(bytes, (byte)=>String.fromCharCode(byte)).join('');
        return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
}



// =============================================================================
// Configuration Validation
// =============================================================================
const $e39212095b0d4be5$var$MAX_SECTIONS = 15;
function $e39212095b0d4be5$var$validateConfig(config) {
    if (!config || typeof config !== 'object') throw new Error('Config must be an object');
    if (!Array.isArray(config.appMenuConfig)) throw new Error('Config sections must be an array');
    if (config.appMenuConfig.length === 0) throw new Error('Cannot encode empty sections array');
    if (config.appMenuConfig.length > $e39212095b0d4be5$var$MAX_SECTIONS) throw new Error(`Too many sections (max ${$e39212095b0d4be5$var$MAX_SECTIONS})`);
}
// =============================================================================
// ATI Encoding
// =============================================================================
/**
 * Encode a single ATI string to 3-byte binary format, then Base64URL
 *
 * @param ati - ATI string to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Base64URL-encoded ATI (4 characters)
 */ function $e39212095b0d4be5$var$encodeATIToBase64(ati, unknowns) {
    const encoded = (0, $bcdba2959b20769a$export$4b052fcb66ebb451)(ati, unknowns);
    const buffer = new Uint8Array(3);
    (0, $bcdba2959b20769a$export$9fa514be131db9ec)({
        encoded: encoded,
        buffer: buffer,
        offset: 0
    });
    return (0, $5120b89f81d97ddd$export$b0ffcdf8b133e63c)(buffer);
}
/**
 * Encode a list of ATI strings to comma-separated Base64URL format
 *
 * @param atiList - Array of ATI strings (optional)
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Comma-separated Base64URL-encoded ATIs, or empty string if no ATIs
 */ function $e39212095b0d4be5$var$encodeATIList(atiList, unknowns) {
    if (!atiList || atiList.length === 0) return '';
    return atiList.map((ati)=>$e39212095b0d4be5$var$encodeATIToBase64(ati, unknowns)).join(',');
}
// =============================================================================
// Encoding Utilities
// =============================================================================
/**
 * Join array parts with hierarchical delimiter, truncating trailing empty/undefined values
 *
 * This utility implements a common pattern across encoding functions:
 * 1. Construct an array with known data
 * 2. Truncate array at last non-empty item
 * 3. Join array as string with delimiter at specified hierarchy level
 *
 * @param parts - Array of values to join (string | number | undefined)
 * @param delimiterLevel - Hierarchy level of delimiter to use (0=~, 1=|, 2=,, 3=:)
 * @returns Joined string with trailing empties removed
 *
 * @example
 * joinWithTruncation(['a', 'b', ''], 3) // 'a:b' (level 3 = ':')
 * joinWithTruncation(['a', '', ''], 2) // 'a' (level 2 = ',')
 * joinWithTruncation([1, 2, undefined], 1) // '1|2' (level 1 = '|')
 */ function $e39212095b0d4be5$var$joinWithTruncation(parts, delimiterLevel) {
    // When delimiter level is out of bounds, default to '~'
    const delimiter = (0, $dccf36f4b2146e6b$export$dab292c7293b69ae)[delimiterLevel] ?? '~';
    // Find last index where value is not empty string or undefined
    let lastIndex = parts.length - 1;
    while(lastIndex >= 0 && (parts[lastIndex] === '' || parts[lastIndex] === undefined))lastIndex--;
    // Slice to last non-empty index + 1, convert all to string, and join
    return parts.slice(0, lastIndex + 1).map(String).join(delimiter);
}
// =============================================================================
// Menu Item Encoding
// =============================================================================
const $e39212095b0d4be5$var$PROMOTED_FLAG = '1';
/**
 * Encode a single menu item
 *
 * Format: atiBase64:itemType[:promoted]
 * - The promoted flag is only included when true
 *
 * @param item - Menu item to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded menu item string
 * @throws Error if item type is unknown
 */ function $e39212095b0d4be5$var$encodeMenuItem(item, unknowns) {
    const typeCode = item.type !== undefined ? $e39212095b0d4be5$var$getCodeByType(item) : undefined;
    const atiBase64 = $e39212095b0d4be5$var$encodeATIToBase64(item.ati, unknowns);
    const isPromoted = item.promoted === true;
    const promotedFlag = isPromoted ? $e39212095b0d4be5$var$PROMOTED_FLAG : undefined;
    return $e39212095b0d4be5$var$joinWithTruncation([
        atiBase64,
        typeCode,
        promotedFlag
    ], 3); // Level 3: ':' (item properties)
}
/**
 * Get the numeric type code for a menu item
 *
 * @param item - Menu item
 * @returns Numeric type code
 * @throws Error if item type is unknown or undefined
 */ function $e39212095b0d4be5$var$getCodeByType(item) {
    // If go down the path of getting code, type should not be undefined
    if (item.type === undefined) throw new Error('Item type is undefined');
    const typeCode = (0, $dccf36f4b2146e6b$export$3dcfc8418d714114)[item.type];
    if (typeCode === undefined) throw new Error(`Unknown item type: ${item.type}`);
    return typeCode;
}
/**
 * Get the numeric code for a menu section
 *
 * @param sectionType - Section type MenuSection['type']
 * @returns String type code number
 */ function $e39212095b0d4be5$var$sectionTypeToCode(sectionType) {
    const typeCode = (0, $dccf36f4b2146e6b$export$1e5c4f2c7d35f342)[sectionType];
    if (typeCode === undefined) throw new Error(`Unknown section type: ${String(sectionType)}`);
    return typeCode;
}
// =============================================================================
// Section Encoding
// =============================================================================
/**
 * Get the numeric code for a personalize mode
 *
 * @param mode - Personalize mode
 * @returns Numeric code for the mode
 * @throws Error if mode is unknown
 */ function $e39212095b0d4be5$var$personalizeCodeByMode(mode) {
    const code = (0, $dccf36f4b2146e6b$export$6cabc9b146da4ac8)[mode];
    if (code === undefined) throw new Error(`Unknown personalize mode: ${mode}`);
    return code;
}
/**
 * Encode an app-defined section
 *
 * Format: 0|item1,item2,...|personalizeCode
 * - Trailing default values are truncated (personalize='0' / 'off' can be omitted)
 * - personalizeCode: 0=off, 1=full, 2=overflow
 *
 * @private
 * @param section - App-defined section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $e39212095b0d4be5$var$encodeAppDefinedSection(section, unknowns) {
    const sectionType = $e39212095b0d4be5$var$sectionTypeToCode('appDefinedSection');
    const encodedItems = section.items.map((item)=>$e39212095b0d4be5$var$encodeMenuItem(item, unknowns)).join(',');
    const personalizeCode = section.personalize && section.personalize !== 'off' ? $e39212095b0d4be5$var$personalizeCodeByMode(section.personalize) : undefined;
    return $e39212095b0d4be5$var$joinWithTruncation([
        sectionType,
        encodedItems,
        personalizeCode
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a suggestion section
 *
 * Format: 1|limit|excludeAti1,excludeAti2,...|preferredAti1,preferredAti2,...
 * - Trailing empty values are truncated (empty excludeAtis/preferredAtis can be omitted)
 * - Default limit (5) is included explicitly for clarity
 *
 * @private
 * @param section - Suggestion section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $e39212095b0d4be5$var$encodeSuggestionSection(section, unknowns) {
    const sectionType = $e39212095b0d4be5$var$sectionTypeToCode('suggestionSection');
    const limit = section.limit;
    const excludeAtis = $e39212095b0d4be5$var$encodeATIList(section.excludeAtis, unknowns);
    const preferredAtis = $e39212095b0d4be5$var$encodeATIList(section.preferredAtis, unknowns);
    return $e39212095b0d4be5$var$joinWithTruncation([
        sectionType,
        limit,
        excludeAtis,
        preferredAtis
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a single menu section based on its type
 *
 * @param section - Menu section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 * @throws Error if section type is unknown
 */ function $e39212095b0d4be5$var$encodeSection(section, unknowns) {
    switch(section.type){
        case 'appDefinedSection':
            return $e39212095b0d4be5$var$encodeAppDefinedSection(section, unknowns);
        case 'suggestionSection':
            return $e39212095b0d4be5$var$encodeSuggestionSection(section, unknowns);
        default:
            // TypeScript exhaustiveness check - this should never happen
            throw new Error(`Unknown section type: ${String(section)}`);
    }
}
// =============================================================================
// Final Assembly
// =============================================================================
/**
 * Build the raw configuration string from encoded sections
 *
 * Format: v{SCHEMA_VERSION}~section1~section2~...
 *
 * @private
 * @param encodedSections - Array of encoded section strings
 * @returns Raw configuration string with version prefix
 */ function $e39212095b0d4be5$var$buildRawConfigString(encodedSections) {
    return `v${0, $dccf36f4b2146e6b$export$3167453beff01750}~${encodedSections.join('~')}`;
}
/**
 * Attach unknown component query parameters to the encoded result
 *
 * @private
 * @param encodedData - Base64URL-encoded configuration data
 * @param unknowns - Unknown ATI components collected during encoding
 * @returns Encoded configuration with query parameters
 */ function $e39212095b0d4be5$var$attachQueryParameters(encodedData, unknowns) {
    const result = {
        d: encodedData
    };
    if (unknowns.owners.length > 0) result.ro = unknowns.owners.join(',');
    if (unknowns.types.length > 0) result.rt = unknowns.types.join(',');
    if (unknowns.prefixes.length > 0) result.ap = unknowns.prefixes.join(',');
    return result;
}
function $e39212095b0d4be5$export$1282978798683232(config) {
    $e39212095b0d4be5$var$validateConfig(config);
    const unknowns = {
        owners: [],
        types: [],
        prefixes: []
    };
    const encodedSections = config.appMenuConfig.map((section)=>$e39212095b0d4be5$var$encodeSection(section, unknowns));
    const rawConfigString = $e39212095b0d4be5$var$buildRawConfigString(encodedSections);
    // Encode UTF-8 string to bytes, then to base64url
    const utf8Bytes = new TextEncoder().encode(rawConfigString);
    const encodedData = (0, $5120b89f81d97ddd$export$b0ffcdf8b133e63c)(utf8Bytes);
    return $e39212095b0d4be5$var$attachQueryParameters(encodedData, unknowns);
}


















function $3ef0e6a21c4da545$export$23f37315094bc4d3({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, appMenuConfig: appMenuConfig, skipInitialization: skipInitialization = false }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const { buildUCMenuItemsURL: buildUCMenuItemsURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId
    });
    // Encode the config to get binary parameters
    const encodedConfig = (0, $42omo.useMemo)(()=>{
        if (skipInitialization) return null;
        try {
            return (0, $e39212095b0d4be5$export$1282978798683232)(appMenuConfig);
        } catch (error) {
            // If encoding fails, we'll handle it in the fetch
            return null;
        }
    }, [
        appMenuConfig,
        skipInitialization
    ]);
    // Generate cache key based on encoded config and metadata
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $67bf03c55a136376$export$53a1e737d45016e2)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        // Include encoded config in cache key to ensure different configs get different cache entries
        ...encodedConfig && {
            encodedConfigD: encodedConfig.d
        }
    });
    const requestIdRef = (0, $42omo.useRef)(0);
    const inFlightRequestKeyRef = (0, $42omo.useRef)(null);
    // Set data from cache on mount if available
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCMenuItems = (0, $42omo.useCallback)(async ()=>{
        // Kill switch: return early if feature flag is disabled
        if (!(0, $dh538.fg)('navx_uc_cross_app_creation_v2_enabled')) return undefined;
        // Early exit: filter out invalid param requests when required identifiers are missing or skip initialization if requested
        if (!cloudId || !orgId || skipInitialization) return undefined;
        // Early exit: if encoding failed
        if (!encodedConfig) {
            setHasError(true);
            setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return undefined;
        }
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Generate request key to prevent duplicate concurrent requests
        const requestKey = `${product}|${orgId}|${userId}|${locale}|${subProduct}|${encodedConfig.d}`;
        // Skip if an identical request is already in progress
        if (inFlightRequestKeyRef.current === requestKey) return undefined;
        // Mark this request as in-flight
        inFlightRequestKeyRef.current = requestKey;
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        try {
            const url = buildUCMenuItemsURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                d: encodedConfig.d,
                ro: encodedConfig.ro,
                rt: encodedConfig.rt,
                ap: encodedConfig.ap
            });
            setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) {
                // Clear in-flight key if this was the request that set it
                if (inFlightRequestKeyRef.current === requestKey) inFlightRequestKeyRef.current = null;
                return undefined;
            }
            if (response.status === (0, $4jETc.RequestStatus).ERROR) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on error
                inFlightRequestKeyRef.current = null;
                return undefined;
            }
            if (response.status === (0, $4jETc.RequestStatus).COMPLETE && response.data) {
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on success
                inFlightRequestKeyRef.current = null;
                return response.data;
            }
        } catch (error) {
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            }
            // Clear in-flight key on exception
            inFlightRequestKeyRef.current = null;
        }
        return undefined;
    }, [
        cloudId,
        cachedObject,
        orgId,
        product,
        userId,
        locale,
        subProduct,
        encodedConfig,
        buildUCMenuItemsURL,
        setStatus,
        setCachedObject,
        skipInitialization
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('navx_uc_cross_app_creation_v2_enabled')) {
            if (skipInitialization) return false;
            // We check if the current loading requests include UC menu items rather than the BFF status directly
            // to ensure that it only returns true for UC menu items and not other BFF requests.
            const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY)) ?? false;
            // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
            // before running things like onResultChange, so that we don't do those things an unnecessary extra time
            // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
            const hasMenuItemDataBeenReturned = data !== undefined || hasError;
            return isBffLoadingOurStuff && !hasMenuItemDataBeenReturned;
        }
        return false;
    }, [
        currentLoadingRequests,
        data,
        hasError,
        skipInitialization
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCMenuItems: fetchUCMenuItems
    };
}






const $79b80363c4ad79e3$export$68f958d92a17ef71 = (item)=>{
    return 'children' in item && !('type' in item);
};


const $6f8e2274fdd0fece$export$20ae29efbf02e075 = (item)=>({
        type: (0, $79b80363c4ad79e3$export$68f958d92a17ef71)(item) ? 'native' : item.type,
        ati: item.ati.toString(),
        promoted: item?.promoted
    });
const $6f8e2274fdd0fece$export$95539883fd80ce6 = (section)=>{
    if (section.type === 'suggestionSection') return {
        type: 'suggestionSection',
        limit: section.limit ?? 5,
        ...section.excludeAtis && {
            excludeAtis: section.excludeAtis.map((ati)=>ati.toString())
        },
        ...section.preferredAtis && {
            preferredAtis: section.preferredAtis.map((ati)=>ati.toString())
        }
    };
    if (section.type === 'appDefinedSection') return {
        type: 'appDefinedSection',
        items: section.items.map($6f8e2274fdd0fece$export$20ae29efbf02e075),
        personalize: section.personalize
    };
    // Assert that we have handled all possible section types
    const exhaustive = section;
    return exhaustive;
};
const $6f8e2274fdd0fece$export$c9ba238fd04e08d2 = (sections)=>({
        appMenuConfig: sections.map($6f8e2274fdd0fece$export$95539883fd80ce6)
    });




function $3bd67b199eaebcfb$export$2eeb31739875ab1e({ crossAppCreationConfig: crossAppCreationConfig, product: product, subProduct: subProduct, sections: sections, skip: skip = false }) {
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_uc_cross_app_creation_v2_enabled');
    const { locale: locale } = (0, $8C5kA.default)();
    const shouldSkip = skip || !crossAppCreationEnabled || !crossAppCreationConfig.enabled;
    const shouldFetchV2Data = !shouldSkip && crossAppCreationConfig.enabled && crossAppCreationConfig.prefetch === true;
    // Convert sections to app menu config for V2 API (memoized to avoid recalculation)
    const appMenuConfig = (0, $42omo.useMemo)(()=>(0, $6f8e2274fdd0fece$export$c9ba238fd04e08d2)(sections), [
        sections
    ]);
    // Fetch V2 menu items
    const { data: data, hasError: hasError, fetchUCMenuItems: fetchUCMenuItems } = (0, $3ef0e6a21c4da545$export$23f37315094bc4d3)({
        cloudId: crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : '',
        orgId: crossAppCreationConfig.enabled ? crossAppCreationConfig.orgId : '',
        userId: crossAppCreationConfig.enabled ? crossAppCreationConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: subProduct,
        appMenuConfig: appMenuConfig,
        skipInitialization: !shouldFetchV2Data
    });
    // Skip prefetching if there's an error
    const shouldSkipDueToError = hasError;
    // Check if Loom is enabled in the fetched data (only recalculate when data changes)
    const hasLoomEnabled = (0, $42omo.useMemo)(()=>{
        if (!data || shouldSkipDueToError || !data.sections || !Array.isArray(data.sections)) return false;
        // Check all sections for Loom items
        return data.sections.some((section)=>section && section.items && Array.isArray(section.items) && section.items.some((item)=>item && item.ati === (0, $9DI9J.LOOM_ATI)));
    }, [
        data,
        shouldSkipDueToError
    ]);
    const shouldFetchLoom = shouldFetchV2Data && hasLoomEnabled && !shouldSkipDueToError;
    // Initialize Loom SDK if needed
    (0, $c9b4f272f6863880$export$d8ef0486cf8cfe05)({
        cloudId: crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : '',
        productName: (0, $a045c9e8d9067aa0$export$f8e8ac264d7fe02e)(product),
        environment: crossAppCreationConfig.enabled && crossAppCreationConfig?.environment || 'prod',
        onItemClick: crossAppCreationConfig.enabled ? crossAppCreationConfig.onItemClick : undefined,
        skipInitialisation: !shouldFetchLoom
    });
    // Trigger fetch when conditions are met
    (0, $42omo.useEffect)(function fetchUCMenuItemsForV2() {
        if (shouldFetchV2Data) fetchUCMenuItems();
    }, [
        shouldFetchV2Data,
        fetchUCMenuItems
    ]);
    // Check if we need to fetch user data (only recalculate when data changes)
    const hasUserItemsRequired = (0, $42omo.useMemo)(()=>{
        if (!data || shouldSkipDueToError || !data.sections || !Array.isArray(data.sections)) return false;
        // Check all sections for items requiring user data
        return data.sections.some((section)=>section && section.items && Array.isArray(section.items) && section.items.some((item)=>item && item.ati && (0, $38e5614694cf6bb5$export$4c7df19e787d8989).includes(item.ati)));
    }, [
        data,
        shouldSkipDueToError
    ]);
    const shouldFetchUser = shouldFetchV2Data && hasUserItemsRequired && !shouldSkipDueToError;
    return {
        shouldFetchV2Data: shouldFetchV2Data && !shouldSkipDueToError,
        shouldFetchLoom: shouldFetchLoom,
        shouldFetchUser: shouldFetchUser
    };
}


function $9b030845b586bf65$export$96a2ac746aa7d3ab({ children: children, skipUserFetch: skipUserFetch }) {
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { product: product, suggestionConfig: suggestionConfig, subProduct: subProduct, crossAppCreationConfig: crossAppCreationConfig, sections: sections } = (0, $19BZl.useMenuControl)(); // Determine if prefetch is enabled based on suggestionConfig.prefetch
    const isPrefetchEnabled = suggestionConfig.enabled && suggestionConfig.prefetch === true;
    const { locale: locale } = (0, $8C5kA.default)(); // This gets around TypeScript errors where it doesn't understand that we expect suggestionConfig to be
    // of type SuggestionConfigEnabled where we check for and use onResultChange, never SuggestionConfigDisabled
    const onResultChange = suggestionConfig.enabled ? suggestionConfig?.onResultChange : undefined; // Use the shared hooks for ATIs logic
    const nativeAtis = (0, $bdcbf50357937847$export$ace2aad66e79cd4e)();
    const preferredAtis = (0, $060ce356f1549e47$export$4984a78a2f2592cd)();
    const excludeAtis = (0, $060ce356f1549e47$export$d6dcc91285361556)();
    const { status: status, data: data, isLoading: isLoading, hasError: hasError, fetchUCSuggestions: fetchUCSuggestions } = (0, $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        orgId: suggestionConfig.enabled ? suggestionConfig.orgId : '',
        userId: suggestionConfig.enabled ? suggestionConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: suggestionConfig.enabled ? subProduct : undefined,
        nativeAtis: nativeAtis,
        preferredAtis: preferredAtis,
        excludeAtis: excludeAtis
    });
    const LoomAti = (0, $dh538.fg)('navx-2354-uc-refactor-ati-preset') ? (0, $9DI9J.ATI_PRESETS).LOOM : (0, $9DI9J.LOOM_ATI);
    const hasLoomEnabled = !isLoading && !hasError && data?.items?.some((item)=>item.ati === LoomAti);
    const skipInitialisation = !isPrefetchEnabled || !crossAppCreationEnabled || !hasLoomEnabled;
    const shouldFetchSuggestions = crossAppCreationEnabled && isPrefetchEnabled && suggestionConfig.enabled; // V2 prefetch logic for cross-app creation
    const { shouldFetchUser: shouldFetchUserV2 } = (0, $3bd67b199eaebcfb$export$2eeb31739875ab1e)({
        crossAppCreationConfig: crossAppCreationConfig,
        product: product,
        subProduct: subProduct,
        sections: sections
    });
    const { user: currentUser } = (0, $caUKj.useUserContext)();
    const { fetchUser: fetchUser } = (0, $dv953.useFetchUser)();
    const [user, setUser] = (0, $42omo.useState)(()=>currentUser ? currentUser : undefined);
    (0, $c9b4f272f6863880$export$d8ef0486cf8cfe05)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        productName: (0, $a045c9e8d9067aa0$export$f8e8ac264d7fe02e)(product),
        environment: suggestionConfig.enabled && suggestionConfig?.environment || 'prod',
        onItemClick: suggestionConfig.enabled ? suggestionConfig.onItemClick : undefined,
        skipInitialisation: skipInitialisation
    }); // Trigger fetch when environment changes
    (0, $42omo.useEffect)(function fetchUCSuggestionsForLoomEnabledApps() {
        if (shouldFetchSuggestions) fetchUCSuggestions();
    }, [
        shouldFetchSuggestions,
        fetchUCSuggestions
    ]); // Memoize the BFF status scenario we want to check against
    // so that our notifySuggestionResultChange effect does not run for all non-init statuses individually
    const bffHasInitialized = (0, $42omo.useMemo)(()=>{
        return status !== (0, $4jETc.RequestStatus).INIT;
    }, [
        status
    ]); // Notify consumer when the suggestion result changes
    // (if they provided an onResultChange function and the conditions for whether to use it are met).
    // We call this in a second effect rather than after the fetchUCSuggestions promise resolves, in case
    // the data or error state changes some other way.
    (0, $42omo.useEffect)(function notifySuggestionResultChange() {
        // we should theoretically not need to check against shouldFetchSuggestions in this effect,
        // because if it's false the data/loading/error values should not change...as long as the BFF status is INIT.
        // If somehow the BFF status is not INIT, onResultChange would run if we didn't check this here.
        if (!shouldFetchSuggestions) return;
        if (onResultChange && bffHasInitialized) onResultChange?.({
            data: data,
            isLoading: isLoading,
            hasError: hasError
        });
    }, [
        onResultChange,
        data,
        isLoading,
        hasError,
        bffHasInitialized,
        shouldFetchSuggestions
    ]);
    const needFetchUser = (0, $42omo.useMemo)(()=>{
        return data?.items?.some((item)=>{
            return (0, $38e5614694cf6bb5$export$4c7df19e787d8989).includes(item.ati);
        });
    }, [
        data?.items
    ]);
    (0, $42omo.useEffect)(function fetchUserConditionally() {
        async function getUser() {
            if ((0, $dh538.fg)('navx-2335-improving-uc-fetch-performance')) {
                // If consumer provided a user, use that
                if (currentUser) {
                    setUser(currentUser);
                    return;
                } // otherwise fetch user once if not already provided by currentUser
                const fetchedUser = await fetchUser();
                if (fetchedUser) setUser(fetchedUser);
            }
        }
        if ((needFetchUser || shouldFetchUserV2) && !skipUserFetch) getUser();
    }, [
        currentUser,
        fetchUser,
        needFetchUser,
        shouldFetchUserV2,
        skipUserFetch
    ]);
    return (0, $dh538.fg)('navx-2335-improving-uc-fetch-performance') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $caUKj.UserContext).Provider, {
        value: {
            user: user
        },
        children: children
    }) : children;
}
function $9b030845b586bf65$var$FlagsWrapper({ children: children }) {
    if ((0, $dh538.fg)('navx_uc_platformisation_forms_enabled')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: children
    });
    return children;
}
function $9b030845b586bf65$var$TopLevelWrappersInner({ children: children, skipUserFetch: skipUserFetch }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($9b030845b586bf65$export$96a2ac746aa7d3ab, {
        skipUserFetch: skipUserFetch,
        children: /*#__PURE__*/ (0, $l998X.jsx)($9b030845b586bf65$var$FlagsWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d7c773b6c8a524b1$export$2e2bcd8739ae039), {
                children: children
            })
        })
    });
} /**
   * @description Wraps the children in a ErrorBoundary, BFFProvider, and PopupWrapperInner
   * Be careful to add any new wrappers that does asnyc requests or lazy loading components, which could break SSR or vc90s
   * @param children - The children to wrap
   * @returns
   */ 
function $9b030845b586bf65$export$2374d7ac6bcc110a(props) {
    return(// We need better error boundary, this is a temporary solution
    /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $caUKj.BFFProvider), {
            consumer: (0, $4jETc.BFFConsumerEnum).UNIVERSAL_CREATE,
            children: /*#__PURE__*/ (0, $l998X.jsx)($9b030845b586bf65$var$TopLevelWrappersInner, {
                ...props
            })
        })
    }));
}

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $4KS7f = parcelRequire("4KS7f");


var $9gE7g = parcelRequire("9gE7g");


var $g5gZt = parcelRequire("g5gZt");


var $ghftu = parcelRequire("ghftu");


var $hmuev = parcelRequire("hmuev");


var $aaBfd = parcelRequire("aaBfd");


var $1lhEF = parcelRequire("1lhEF");

var $5izcQ = parcelRequire("5izcQ");





var $291hi = parcelRequire("291hi");

var $26eSY = parcelRequire("26eSY");

var $fFc6D = parcelRequire("fFc6D");












const $be8eb3f37dd41711$var$triggerButton = null; /**
                             * Refactor this whole logic after T-25, we should use the proper Create component instead.
                             * https://jplat.atlassian.net/browse/BLU-7401
                             */ 
const $be8eb3f37dd41711$var$nav3ButtonTextStyles = null;
const $be8eb3f37dd41711$var$messages = (0, $cgtv4.defineMessages)({
    secondaryButtonTooltipText: {
        id: "platform.navigation-experiences.universal-create.secondary-tooltip-text",
        defaultMessage: "More create options"
    }
});
function $be8eb3f37dd41711$var$TooltipWrapper({ children: children, text: text, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = true }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: text,
        isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled,
        position: "bottom",
        ignoreTooltipPointerEvents: (0, $dh538.fg)('gc_button_tooltip_ignore_pointer_events'),
        children: children
    });
}
function $be8eb3f37dd41711$var$TriggerButtonInner({ triggerProps: triggerProps, testId: testId, onClick: onClick, children: children, isOpen: isOpen, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, enableTriggerPulse: enableTriggerPulse, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem }) {
    const { product: product } = (0, $19BZl.useMenuControl)();
    const { fireCreateButtonClicked: fireCreateButtonClicked } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isDesktop = (0, $fFc6D.UNSAFE_useMediaQuery)('above.sm')?.matches ?? false;
    const onButtonClick = (0, $42omo.useCallback)(()=>{
        fireCreateButtonClicked({
            itemState: isOpen ? 'collapsed' : 'expanded'
        });
        onClick();
    }, [
        fireCreateButtonClicked,
        isOpen,
        onClick
    ]);
    const CreateIcon = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))) : (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt)));
    const enterEvent = (0, $42omo.useCallback)((event)=>{
        onMouseEnter?.(event);
    }, [
        onMouseEnter
    ]);
    const leaveEvent = (0, $42omo.useCallback)((event)=>{
        onMouseLeave?.(event);
    }, [
        onMouseLeave
    ]); // Calculate feature flag values outside of useMemo to avoid render-time calls
    const isSplitButtonFeatureEnabled = primaryActionItem && (0, $dh538.fg)('navx-2421-uc-split-button-enabled');
    const isResponsiveButtonUpdateEnabled = (0, $dh538.fg)('navx-uc-responsive-button-update');
    const button = /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_12y21ule _uis9u2gc _1rrju2gc _15nzidpf _dlu2idpf"
        ]),
        children: product === 'confluence' && !isNav4Enabled ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_x0l4u2gc _19ywu2gc _1xc3idpf _pj60idpf _muvxglyw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4KS7f.default), {
                ...triggerProps,
                appearance: "primary",
                theme: buttonTheme,
                onMouseEnter: enterEvent,
                onMouseLeave: leaveEvent,
                onClick: onButtonClick,
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(CreateIcon, {
                    label: "",
                    "data-vc": "global-content-create-button"
                }),
                testId: testId || (0, $38e5614694cf6bb5$export$3f4cc858c0cb6e84),
                "aria-label": children,
                isSelected: isOpen,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "sm",
                    as: "span",
                    children: children
                })
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
            text: children,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                ...triggerProps,
                appearance: "primary",
                onClick: onButtonClick,
                onMouseEnter: enterEvent,
                onMouseLeave: leaveEvent,
                isSelected: isOpen,
                iconBefore: CreateIcon,
                testId: testId || (0, $38e5614694cf6bb5$export$3f4cc858c0cb6e84),
                "aria-label": children,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "sm",
                    as: "span",
                    children: children
                })
            })
        })
    });
    const responsiveSafeButton = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                above: "sm",
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                        ...isDesktop ? triggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        iconBefore: CreateIcon,
                        testId: testId || (0, $38e5614694cf6bb5$export$3f4cc858c0cb6e84),
                        "aria-label": children,
                        "data-responsive-variant": "desktop",
                        children: children
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $291hi.Hide), {
                above: "sm",
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                        ...!isDesktop ? triggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        icon: CreateIcon,
                        testId: `${testId || (0, $38e5614694cf6bb5$export$3f4cc858c0cb6e84)}-mobile`,
                        label: children,
                        "data-responsive-variant": "mobile"
                    })
                })
            })
        ]
    });
    const splitButtonVariant = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                above: "sm",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $9gE7g.SplitButton), {
                    appearance: "primary",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                            text: children,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                                appearance: "primary",
                                onClick: primaryActionItem?.onClick,
                                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
                                "aria-label": children,
                                testId: "uc-trigger-button-primary",
                                children: children
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                            text: formatMessage($be8eb3f37dd41711$var$messages.secondaryButtonTooltipText),
                            isScreenReaderAnnouncementDisabled: false,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                                ...isDesktop ? triggerProps : {},
                                appearance: "primary",
                                onClick: onButtonClick,
                                isSelected: isOpen,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
                                "data-responsive-variant": "desktop",
                                label: children,
                                testId: `${testId || (0, $38e5614694cf6bb5$export$3f4cc858c0cb6e84)}-split`,
                                onMouseEnter: onMouseEnter,
                                onMouseLeave: onMouseLeave
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $291hi.Hide), {
                above: "sm",
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                        ...!isDesktop ? triggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        icon: CreateIcon,
                        testId: `${testId || (0, $38e5614694cf6bb5$export$3f4cc858c0cb6e84)}-mobile`,
                        label: children,
                        "data-responsive-variant": "mobile"
                    })
                })
            })
        ]
    });
    const buttonToRender = isSplitButtonFeatureEnabled ? splitButtonVariant : isResponsiveButtonUpdateEnabled && isNav4Enabled ? responsiveSafeButton : button;
    return triggerButtonSpotlightTarget ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
        name: triggerButtonSpotlightTarget,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1lhEF.Pulse), {
            radius: 3,
            pulse: enableTriggerPulse,
            children: buttonToRender
        })
    }) : buttonToRender;
}
const $be8eb3f37dd41711$export$4129321aecd13375 = (0, $503da3927b063db6$export$a5d940130f33be3f)($be8eb3f37dd41711$var$TriggerButtonInner);


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

































/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














/* CrossAppItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











/* CrossAppItemBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 










const $4ef2ae8434994ccc$var$noop = ()=>{};
function $4ef2ae8434994ccc$export$671e3c96b60c4286({ responseItem: responseItem, customisedItemConfig: customisedItemConfig, context: context, injectClickAnalytics: injectClickAnalytics }) {
    const onClick = (0, $42omo.useCallback)(()=>{
        const onItemClick = context?.onItemClick || $4ef2ae8434994ccc$var$noop;
        // Call injected analytics for left click
        injectClickAnalytics?.onClick?.(false);
        // Call onItemClick callback if provided
        onItemClick?.(responseItem.ati);
    }, [
        context,
        responseItem,
        injectClickAnalytics
    ]);
    const [icon, setIcon] = (0, $42omo.useState)(undefined);
    const [isIconLoading, setIsIconLoading] = (0, $42omo.useState)(false);
    const { isLoading: isCustomisedItemConfigLoading, ...restCustomisedItemConfig } = customisedItemConfig || {};
    const onRightClick = (0, $42omo.useCallback)((event)=>{
        // Call injected analytics for right click
        injectClickAnalytics?.onClick?.(true);
        // Call custom onContextMenu handler if provided
        const customOnContextMenu = restCustomisedItemConfig?.onContextMenu;
        customOnContextMenu?.(event);
    }, [
        restCustomisedItemConfig?.onContextMenu,
        injectClickAnalytics
    ]);
    (0, $42omo.useEffect)(function loadIcon() {
        if (!responseItem.icon) {
            setIcon(undefined);
            setIsIconLoading(false);
            return;
        }
        setIsIconLoading(true);
        (0, $807ba750c6a5720b$export$832efc97cccfe549)(responseItem.icon).then((loadedIcon)=>{
            if (loadedIcon) setIcon(()=>loadedIcon);
            else setIcon(undefined);
            setIsIconLoading(false);
        });
    }, [
        responseItem.icon
    ]);
    // Extract custom onClick handler and compose with onClick
    const customOnClick = restCustomisedItemConfig?.onClick;
    const composedOnClick = (0, $42omo.useCallback)((event)=>{
        // Call onClick handler first
        onClick();
        // Then call custom click handler if provided
        customOnClick?.(event);
    }, [
        customOnClick,
        onClick
    ]);
    const menuItem = (0, $42omo.useMemo)(()=>{
        const { onClick: _, onContextMenu: __, ...otherCustomConfig } = restCustomisedItemConfig || {};
        return {
            ati: (0, $6yCpa.Ati).parse(responseItem.ati),
            children: responseItem.name,
            elemBefore: icon,
            isLoading: isIconLoading || isCustomisedItemConfigLoading,
            testId: `cross-app-item-${responseItem.ati}`,
            onClick: customOnClick ? composedOnClick : onClick,
            onContextMenu: onRightClick,
            ...otherCustomConfig
        };
    }, [
        responseItem.ati,
        responseItem.name,
        icon,
        isIconLoading,
        isCustomisedItemConfigLoading,
        onClick,
        composedOnClick,
        customOnClick,
        restCustomisedItemConfig,
        onRightClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $036eedccb5a0b632$export$2e2bcd8739ae039), {
        item: menuItem
    });
}


/* CrossAppLinkItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

















function $6e03daae58d17473$var$getUrlEnv(serverSessionSyncUrl) {
    const url = new URL(serverSessionSyncUrl);
    if (url.hostname === 'id.stg.internal.atlassian.com') return 'staging';
    if (url.hostname === 'id.atlassian.com') return 'prod';
    return null;
}
function $6e03daae58d17473$var$compileIcSessionSyncUrl(serverSessionSyncUrl) {
    const env = $6e03daae58d17473$var$getUrlEnv(serverSessionSyncUrl);
    const icEnvUrl = env ? (0, $kfZYI.getUrlForDomainInContext)('id', env) : undefined;
    if (icEnvUrl) {
        const icFinalUrl = new URL(serverSessionSyncUrl);
        const icEnvHostname = new URL(icEnvUrl).hostname;
        icFinalUrl.hostname = icEnvHostname;
        return icFinalUrl.toString();
    }
    return serverSessionSyncUrl;
}
function $6e03daae58d17473$var$useBuildLinkItemUrl(item) {
    const { product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'universalCreate',
        product: product,
        subProduct: subProduct
    });
    if (!item.href || !item.hostname) return '';
    const base = item.hostname.startsWith('https://') ? item.hostname : `https://${item.hostname}`;
    const targetUrl = new URL(item.href, base);
    // Add query parameters from options
    for (const [key, value] of Object.entries(item.options || {}))if (value !== null) targetUrl.searchParams.append(key, String(value));
    const finalTargetUrl = buildUrlWithAnalyticsParams(targetUrl.toString());
    // Handle session sync URL logic
    if (!item.sessionSyncUrl) // When session sync URL is empty, return the current URL
    return finalTargetUrl;
    // When session sync URL is set, use it as base and set continue param to current URL
    const finalSessionSyncUrl = $6e03daae58d17473$var$compileIcSessionSyncUrl(item.sessionSyncUrl);
    const sessionSyncUrl = new URL(finalSessionSyncUrl);
    sessionSyncUrl.searchParams.set('continue', finalTargetUrl);
    return sessionSyncUrl.toString();
}
function $6e03daae58d17473$export$42845b6a2d6a3ac1(item, context) {
    const href = $6e03daae58d17473$var$useBuildLinkItemUrl(item);
    // Priority: explicit config > item target > default '_blank'
    const target = context.crossAppLinkOpenTarget || item.target || '_blank';
    const onClick = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        window.parent.location.href = href;
    }, [
        href
    ]);
    return (0, $42omo.useMemo)(()=>{
        // Only add rel attributes for _blank targets to prevent security issues
        const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
        // Only add onClick handler for _self targets in iframes with valid href to minimize impact
        const shouldAddOnClick = href && target === '_self' && window !== window.parent && (0, $dh538.fg)('navx_universal_create_self_redirect_iframe');
        return {
            target: target,
            rel: rel,
            href: href,
            ...shouldAddOnClick && {
                onClick: onClick
            }
        };
    }, [
        href,
        target,
        onClick
    ]);
}


/**
 * Higher-order component that wraps a component with link item configuration
 * @param WrappedComponent - The component to wrap with link item configuration
 * @returns A new component with link item configuration applied
 */ function $7dec05f53c1ad0f4$var$withLinkItemConfig(WrappedComponent) {
    return function WithLinkItemConfigComponent(props) {
        const linkItemConfig = (0, $6e03daae58d17473$export$42845b6a2d6a3ac1)(props.responseItem, props.context);
        if (!linkItemConfig.href) return null; // early return should not show the item when computed href is invalid
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: linkItemConfig
        });
    };
}
const $7dec05f53c1ad0f4$export$995913b4338229ea = $7dec05f53c1ad0f4$var$withLinkItemConfig((0, $4ef2ae8434994ccc$export$671e3c96b60c4286));


/* LoomVideoItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");















const $91465855458ea778$var$messages = (0, $cgtv4.defineMessages)({
    insertButtonText: {
        id: "universal-create.loom-video-menu-item.share-video",
        defaultMessage: "Share"
    }
});
function $91465855458ea778$export$d8ef0486cf8cfe05({ cloudId: cloudId, productName: productName, environment: environment = 'prod', onItemClick: onItemClick, skipInitialisation: skipInitialisation = false }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $b5fbe98a0f081479$export$c8d9dc913e9e33ec)({
        entryPointLocation: (0, $38e5614694cf6bb5$export$c2ae99333adf8094),
        environment: environment,
        cloudId: cloudId,
        productName: productName,
        onInsert: (videoUrl)=>{
            const url = new URL(videoUrl);
            // Open video in new tab with share permissions modal open
            url.searchParams.set('open_share_permissions', '1');
            window.open(url.toString(), '_blank', 'noopener');
        },
        insertButtonText: formatMessage($91465855458ea778$var$messages.insertButtonText),
        skipInitialisation: // Analytics removed - will be added in future task
        skipInitialisation
    });
    const onClick = (0, $42omo.useCallback)(()=>{
        if (openLoomRecorder) {
            onItemClick?.((0, $9DI9J.LOOM_ATI));
            openLoomRecorder();
        }
    }, [
        openLoomRecorder,
        onItemClick
    ]);
    switch(recorderState){
        case 'initialising':
            return {
                isLoading: true
            };
        case 'ready':
            if (openLoomRecorder) return {
                onClick: onClick
            };
            return {
                isDisabled: true
            };
        default:
            return {
                isDisabled: true
            };
    }
}


function $47aeebca6b9e8bb2$export$f8e8ac264d7fe02e(product, subProduct) {
    switch(product){
        case 'townsquare':
            if (subProduct === 'goal') return 'GOAL';
            if (subProduct === 'teams') return 'TEAMS';
            if (subProduct === 'home') return 'HOME';
            return 'TOWNSQUARE';
        case 'confluence':
            return 'CONFLUENCE';
        case 'rovoExtension':
            return 'ROVO_EXTENSION';
        default:
            return 'UNKNOWN';
    }
}
/**
 * Higher-order component that wraps a component with Loom video configuration
 * @param WrappedComponent - The component to wrap with Loom video configuration
 * @returns A new component with Loom video configuration applied
 */ function $47aeebca6b9e8bb2$var$withLoomVideoConfig(WrappedComponent) {
    return function WithLoomVideoConfigComponent(props) {
        const { context: context, product: product } = props;
        const customisedItemConfig = (0, $91465855458ea778$export$d8ef0486cf8cfe05)({
            cloudId: context.cloudId,
            productName: $47aeebca6b9e8bb2$export$f8e8ac264d7fe02e(product),
            environment: context.environment || 'prod',
            onItemClick: context.onItemClick
        });
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: customisedItemConfig
        });
    };
}
const $47aeebca6b9e8bb2$export$7b2dceeaf04ce250 = $47aeebca6b9e8bb2$var$withLoomVideoConfig((0, $4ef2ae8434994ccc$export$671e3c96b60c4286));


function $3a24b12925157d12$var$renderPlatformCrossAppItem({ responseItem: responseItem, context: context, product: product, injectClickAnalytics: injectClickAnalytics }) {
    switch(responseItem.ati){
        case (0, $9DI9J.ATI_PRESETS).LOOM:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $47aeebca6b9e8bb2$export$7b2dceeaf04ce250), {
                responseItem: responseItem,
                context: context,
                product: product,
                injectClickAnalytics: injectClickAnalytics
            });
        case (0, $9DI9J.ATI_PRESETS).GOAL:
        case (0, $9DI9J.ATI_PRESETS).PROJECT:
        case (0, $9DI9J.ATI_PRESETS).TEAM:
            {
                if (!(0, $dh538.fg)('navx_uc_platformisation_forms_enabled')) return null; // should not show this item if the feature flag is off
                const loadCreateContent = (0, $b19599a70b1ea9c9$export$38e36ff3c4cb0c61)(responseItem.ati);
                const customisedItemConfig = {
                    loadCreateContent: loadCreateContent,
                    onClickCloseMenu: !loadCreateContent
                };
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $4ef2ae8434994ccc$export$671e3c96b60c4286), {
                    responseItem: responseItem,
                    context: context,
                    customisedItemConfig: customisedItemConfig,
                    injectClickAnalytics: injectClickAnalytics
                });
            }
        default:
            return undefined;
    }
}
function $3a24b12925157d12$var$renderCrossAppItem({ responseItem: responseItem, context: context, product: product, injectClickAnalytics: injectClickAnalytics }) {
    switch(responseItem.type){
        case 'platform':
            return $3a24b12925157d12$var$renderPlatformCrossAppItem({
                responseItem: responseItem,
                context: context,
                product: product,
                injectClickAnalytics: injectClickAnalytics
            });
        case 'link':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $7dec05f53c1ad0f4$export$995913b4338229ea), {
                responseItem: responseItem,
                context: context,
                product: product,
                injectClickAnalytics: injectClickAnalytics
            });
        default:
            break;
    }
    return undefined;
}
function $3a24b12925157d12$var$CrossAppItemInner({ responseItem: responseItem, context: context, product: product, injectClickAnalytics: injectClickAnalytics }) {
    const renderedItem = $3a24b12925157d12$var$renderCrossAppItem({
        responseItem: responseItem,
        context: context,
        product: product,
        injectClickAnalytics: injectClickAnalytics
    });
    if (renderedItem !== undefined) return renderedItem;
    // Return general cross-app item with no customisedItemConfig
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4ef2ae8434994ccc$export$671e3c96b60c4286), {
        responseItem: responseItem,
        context: context,
        injectClickAnalytics: injectClickAnalytics
    });
}
function $3a24b12925157d12$export$93ca0712ad6ac26d(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($3a24b12925157d12$var$CrossAppItemInner, {
            ...props
        })
    });
}



const $5872fbca13241433$export$964d21685ad57bfa = (item)=>{
    return 'children' in item && !('type' in item);
};
function $5872fbca13241433$export$2e2bcd8739ae039({ item: item, itemIndex: itemIndex, totalMenuItemsCount: totalMenuItemsCount, sectionStartIndex: sectionStartIndex, sectionItemsCount: sectionItemsCount }) {
    const { crossAppCreationConfig: crossAppCreationConfig, product: product } = (0, $19BZl.useMenuControl)();
    const { fireNewMenuItemClicked: fireNewMenuItemClicked } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const fireAnalytics = (0, $42omo.useCallback)((props)=>{
        if ((0, $dh538.fg)('navx_uc_cross_app_creation_v2_enabled')) {
            const itemAti = $5872fbca13241433$export$964d21685ad57bfa(item) ? item.ati.toString() : item.ati || 'unknown';
            fireNewMenuItemClicked({
                ati: itemAti,
                itemType: props.itemType,
                sectionType: 'appDefinedSection',
                groupItemProduct: product,
                groupItemsCount: sectionItemsCount,
                groupItemsIndex: itemIndex,
                menuItemsCount: totalMenuItemsCount,
                menuItemIndex: sectionStartIndex + itemIndex,
                isNativeItem: props.itemType === 'native',
                isRightClick: props.isRightClick
            });
        }
    }, [
        fireNewMenuItemClicked,
        item,
        itemIndex,
        totalMenuItemsCount,
        sectionStartIndex,
        sectionItemsCount,
        product
    ]);
    const menuItemWithAnalytics = (0, $42omo.useCallback)((item)=>{
        if ($5872fbca13241433$export$964d21685ad57bfa(item)) return {
            ...item,
            onClick: (event)=>{
                fireAnalytics({
                    isRightClick: false,
                    itemType: 'native'
                });
                item.onClick?.(event);
            },
            onContextMenu: (event)=>{
                fireAnalytics({
                    isRightClick: true,
                    itemType: 'native'
                });
                item.onContextMenu?.(event);
            }
        };
        return item;
    }, [
        fireAnalytics
    ]);
    const handleCrossAppItemClickAnalytics = (0, $42omo.useCallback)((isRightClick)=>{
        // Determine itemType dynamically based on whether item is native or cross-app
        const itemType = $5872fbca13241433$export$964d21685ad57bfa(item) ? 'native' : item.type;
        fireAnalytics({
            isRightClick: isRightClick,
            itemType: itemType
        });
    }, [
        fireAnalytics,
        item
    ]);
    const menuItem = menuItemWithAnalytics(item);
    // Check if this is a native menu item
    if ($5872fbca13241433$export$964d21685ad57bfa(menuItem)) // Render native menu item using existing MenuItem component
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $036eedccb5a0b632$export$2e2bcd8739ae039), {
        item: menuItem
    });
    // For cross-app items, check if context exists and is enabled
    if (!crossAppCreationConfig.enabled) return null;
    // Render cross-app item with injected analytics
    const injectClickAnalytics = {
        onClick: handleCrossAppItemClickAnalytics
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3a24b12925157d12$export$93ca0712ad6ac26d), {
        responseItem: menuItem,
        context: crossAppCreationConfig,
        product: product,
        injectClickAnalytics: injectClickAnalytics
    });
}



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 











const $6530a2f588fdf043$var$MAX_ITEMS = 10;
function $6530a2f588fdf043$var$RenderableMenuSectionInner({ section: section, sectionIndex: sectionIndex, sectionStartIndex: sectionStartIndex, totalMenuItemsCount: totalMenuItemsCount }) {
    const [showAll, setShowAll] = (0, $42omo.useState)(false);
    const sectionItems = section.items;
    const sectionItemsCount = sectionItems.length;
    const items = (0, $42omo.useMemo)(()=>{
        if (!sectionItemsCount) return [];
        if (!section.foldable || sectionItemsCount <= (0, $d690491b6d31182a$export$e69afd517cd76d77)(section.foldable)) return sectionItems;
        return sectionItems.slice(0, showAll ? $6530a2f588fdf043$var$MAX_ITEMS : (0, $d690491b6d31182a$export$e69afd517cd76d77)(section.foldable));
    }, [
        section.foldable,
        sectionItems,
        showAll,
        sectionItemsCount
    ]);
    const toggleShowMore = (0, $42omo.useCallback)(()=>{
        if (section.foldable === 'enhanced' && (0, $dh538.fg)('navx-2610-uc-refactor-show-more')) setShowAll(true); // removing show less functionality under this fg
        else setShowAll((prev)=>!prev);
    }, [
        setShowAll,
        section.foldable
    ]);
    if (!sectionItems?.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d690491b6d31182a$export$2e2bcd8739ae039), {
        sectionIndex: sectionIndex,
        itemLength: sectionItems.length,
        foldable: section.foldable,
        heading: section.heading,
        showAll: showAll,
        toggleShowMore: toggleShowMore,
        isNative: true,
        children: items.map((menuItem, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5872fbca13241433$export$2e2bcd8739ae039), {
                item: menuItem,
                itemIndex: index,
                sectionStartIndex: sectionStartIndex,
                sectionItemsCount: sectionItemsCount,
                totalMenuItemsCount: totalMenuItemsCount
            }, `menu-section-${sectionIndex}-item-${index}`))
    });
}
const $6530a2f588fdf043$export$47b6a3742898d49e = (0, $503da3927b063db6$export$a5d940130f33be3f)($6530a2f588fdf043$var$RenderableMenuSectionInner);





const $cfff25737a37447f$var$filterNativeItems = (items)=>items.filter((0, $79b80363c4ad79e3$export$68f958d92a17ef71));
/**
 * Sorts items to place promoted items at the top while preserving relative order.
 * Uses stable sort to maintain original order within promoted and non-promoted groups.
 *
 * @param items - Array of items with optional promoted flag
 * @returns New array with promoted items first, maintaining relative order
 *
 * @example
 * Input:  [A, B(promoted), C, D(promoted)]
 * Output: [B(promoted), D(promoted), A, C]
 */ const $cfff25737a37447f$var$sortByPromoted = (items)=>{
    const promotedItems = [];
    const regularItems = [];
    items.forEach((item)=>{
        if (item.promoted === true) promotedItems.push(item);
        else regularItems.push(item);
    });
    return [
        ...promotedItems,
        ...regularItems
    ];
};
const $cfff25737a37447f$var$createSection = (configSection, items)=>({
        type: 'appDefinedSection',
        heading: configSection.heading,
        foldable: configSection.foldable,
        items: items
    });
const $cfff25737a37447f$var$createConfigItemsMap = (items)=>new Map(items.filter((0, $79b80363c4ad79e3$export$68f958d92a17ef71)).map((item)=>[
            item.ati.toString(),
            item
        ]));
const $cfff25737a37447f$var$hydrateResponseItem = (responseItem, configItemsByAti)=>{
    // Cross-app item: use as-is from response
    if (responseItem.type !== 'native') return responseItem;
    // Native item: find corresponding config item with full data
    const configItem = configItemsByAti.get(responseItem.ati);
    return configItem ?? null;
};
const $cfff25737a37447f$var$hydrateSection = (configSection, responseSection)=>{
    // No response section: return native items only with promoted items at the top
    if (!responseSection) {
        const nativeItems = $cfff25737a37447f$var$filterNativeItems(configSection.items);
        const sortedItems = $cfff25737a37447f$var$sortByPromoted(nativeItems);
        return sortedItems.length > 0 ? $cfff25737a37447f$var$createSection(configSection, sortedItems) : null;
    }
    // Use response order: map each response item to its hydrated version
    const configItemsByAti = $cfff25737a37447f$var$createConfigItemsMap(configSection.items);
    const hydratedItems = responseSection.items.map((responseItem)=>$cfff25737a37447f$var$hydrateResponseItem(responseItem, configItemsByAti)).filter((item)=>item !== null);
    return hydratedItems.length > 0 ? $cfff25737a37447f$var$createSection(configSection, hydratedItems) : null;
};
const $cfff25737a37447f$export$f60e04956fac8ba8 = (data, sections)=>{
    const appDefinedSectionsFromResponse = data.sections.filter((section)=>section.type === 'appDefinedSection');
    // Map each config section to its hydrated version
    // Keep null entries to maintain index alignment with config sections
    return sections.map((configSection, index)=>$cfff25737a37447f$var$hydrateSection(configSection, appDefinedSectionsFromResponse[index]));
};
const $cfff25737a37447f$export$fd0ba75bb069af58 = (sections)=>sections.map((section)=>{
        const nativeItems = $cfff25737a37447f$var$filterNativeItems(section.items);
        const sortedItems = $cfff25737a37447f$var$sortByPromoted(nativeItems);
        return sortedItems.length > 0 ? $cfff25737a37447f$var$createSection(section, sortedItems) : null;
    }).filter((section)=>section !== null);


const $7aed742ac61dd32a$export$f6dc3460757f5999 = (section)=>section.type === 'appDefinedSection';
const $7aed742ac61dd32a$export$9ba1633297a665ab = (section)=>section.type === 'suggestionSection';
const $7aed742ac61dd32a$export$f3cccc0ced3c2bed = (sections)=>sections.filter($7aed742ac61dd32a$export$f6dc3460757f5999);
/**
 * Processes a single suggestion section by matching it with a response section.
 * Suggestion sections contain directly renderable items from the backend.
 * Only cross-app items are included (native item references are filtered out).
 */ const $7aed742ac61dd32a$var$processSuggestionSection = (configSection, responseSection)=>{
    if (!responseSection || responseSection.items.length === 0) return null;
    return {
        type: 'suggestionSection',
        heading: configSection.heading,
        foldable: configSection.foldable,
        items: responseSection.items
    };
};
/**
 * Hydrates app-defined sections by matching native items from the API response with configured sections.
 *
 * This function:
 * 1. Takes the API response data and the original sections configuration
 * 2. For each app-defined section in the configuration:
 *    - Uses section metadata (heading, foldable, etc.) from config
 *    - Uses item ordering from the response
 *    - For native items: finds matching config item by ATI to preserve properties (onClick, children, etc.)
 *    - For cross-app items: uses data directly from response
 * 3. Returns hydrated sections ready for rendering
 *
 * Note: Sections with no items after hydration are filtered out (returns null in array).
 */ const $7aed742ac61dd32a$var$hydrateAppDefinedSections = (configSections, data)=>{
    return (0, $cfff25737a37447f$export$f60e04956fac8ba8)(data, configSections);
};
const $7aed742ac61dd32a$export$d02f102e1bd204d6 = ({ sections: sections, data: data, hasError: hasError, isNativeOnly: isNativeOnly })=>{
    // Error/no data/native-only case: return only native items from app-defined sections
    if (hasError || !data || isNativeOnly) {
        const appDefinedSections = $7aed742ac61dd32a$export$f3cccc0ced3c2bed(sections);
        return (0, $cfff25737a37447f$export$fd0ba75bb069af58)(appDefinedSections);
    }
    // Separate sections by type for processing
    const suggestionResponseSections = data.sections.filter((section)=>section.type === 'suggestionSection');
    const appDefinedConfigSections = $7aed742ac61dd32a$export$f3cccc0ced3c2bed(sections);
    // Hydrate app-defined sections with response data
    // This returns an array that may contain null entries for sections that couldn't be hydrated
    const hydratedAppSections = $7aed742ac61dd32a$var$hydrateAppDefinedSections(appDefinedConfigSections, data);
    // Process sections in original order, matching with response data
    // Use separate indices to track position in filtered arrays
    let suggestionIndex = 0;
    let appSectionIndex = 0;
    return sections.map((configSection)=>{
        if ($7aed742ac61dd32a$export$9ba1633297a665ab(configSection)) {
            const responseSection = suggestionResponseSections[suggestionIndex++];
            return $7aed742ac61dd32a$var$processSuggestionSection(configSection, responseSection);
        }
        if ($7aed742ac61dd32a$export$f6dc3460757f5999(configSection)) {
            // Get the hydrated section (may be null if hydration failed)
            const hydratedSection = hydratedAppSections[appSectionIndex++];
            return hydratedSection;
        }
        return null;
    }).filter((section)=>section !== null);
};
const $7aed742ac61dd32a$export$a628dce1485ab731 = (sections)=>sections.reduce((total, section)=>total + section.items.length, 0);
const $7aed742ac61dd32a$export$15c1c48db7fb6757 = (sections)=>{
    let totalCount = 0;
    const startIndices = [];
    sections.forEach((section)=>{
        startIndices.push(totalCount);
        totalCount += section.items.length;
    });
    return {
        totalCount: totalCount,
        startIndices: startIndices
    };
};


const $9aa5319017567367$var$styles = {
    menuWrap: "_ca0qu2gc _n3tdu2gc"
};
function $9aa5319017567367$var$MenuContentV2Inner() {
    const { locale: locale } = (0, $8C5kA.default)();
    const { sections: sections, crossAppCreationConfig: crossAppCreationConfig, product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const { cloudId: cloudId = '', orgId: orgId = '', accountId: accountId = '' } = crossAppCreationConfig?.enabled ? crossAppCreationConfig : {};
    // Determine if we're in native-only mode (no cross-app creation)
    const isNativeOnly = !crossAppCreationConfig?.enabled; // Skip appMenuConfig generation when in native-only mode
    const appMenuConfig = (0, $42omo.useMemo)(()=>(0, $6f8e2274fdd0fece$export$c9ba238fd04e08d2)(isNativeOnly ? [] : sections), [
        isNativeOnly,
        sections
    ]);
    const { data: data, isLoading: isLoading, hasError: hasError, fetchUCMenuItems: fetchUCMenuItems } = (0, $3ef0e6a21c4da545$export$23f37315094bc4d3)({
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        subProduct: subProduct,
        userId: accountId,
        locale: locale,
        appMenuConfig: appMenuConfig,
        skipInitialization: isNativeOnly
    });
    // Fetch menu items when cross-app creation is enabled
    (0, $42omo.useEffect)(()=>{
        if (crossAppCreationConfig?.enabled) fetchUCMenuItems();
    }, [
        crossAppCreationConfig?.enabled,
        fetchUCMenuItems
    ]);
    const renderableSections = (0, $42omo.useMemo)(()=>(0, $7aed742ac61dd32a$export$d02f102e1bd204d6)({
            sections: sections,
            data: data,
            hasError: hasError,
            isNativeOnly: isNativeOnly
        }), [
        sections,
        data,
        hasError,
        isNativeOnly
    ]);
    const sectionsToAnalyze = (0, $42omo.useMemo)(()=>renderableSections.slice(0, (0, $38e5614694cf6bb5$export$4e49778ae689b92a)), [
        renderableSections
    ]); // Pre-compute section metadata (start indices and total count) to avoid O(n²) complexity
    const sectionMetadata = (0, $42omo.useMemo)(()=>(0, $7aed742ac61dd32a$export$15c1c48db7fb6757)(sectionsToAnalyze), [
        sectionsToAnalyze
    ]); // Only show loading state when cross-app creation is enabled
    // This ensures native-only items render immediately when cross-app is disabled
    if (isLoading && crossAppCreationConfig?.enabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        spacing: "compact",
        testId: "global-create-content-popover-menu-v2-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($9aa5319017567367$var$styles.menuWrap),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d1f757cfbbc3d137$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e), {
                    testId: "loading-menu-content-v2"
                })
            })
        })
    });
    if (sectionsToAnalyze.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        spacing: "compact",
        testId: "global-create-content-popover-menu-v2",
        ...sectionsToAnalyze.some((section)=>section.foldable === 'enhanced') && (0, $dh538.fg)('navx_universal_create_overflow_mode') ? {
            maxHeight: (0, $38e5614694cf6bb5$export$441df76988f6d01)
        } : undefined,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($9aa5319017567367$var$styles.menuWrap),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)($9aa5319017567367$export$db78b92a799823ab, {
                    sections: sectionsToAnalyze
                }),
                sectionsToAnalyze.map((section, sectionIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6530a2f588fdf043$export$47b6a3742898d49e), {
                        section: section,
                        sectionIndex: sectionIndex,
                        totalMenuItemsCount: sectionMetadata.totalCount,
                        sectionStartIndex: sectionMetadata.startIndices[sectionIndex]
                    }, `menu-section-${section.type}-${sectionIndex}`))
            ]
        })
    });
}
function $9aa5319017567367$export$db78b92a799823ab({ sections: sections }) {
    const { fireNewMenuItemsViewed: fireNewMenuItemsViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const analyticsFired = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (sections.length === 0 || analyticsFired.current) return;
        if ((0, $dh538.fg)('navx_uc_cross_app_creation_v2_enabled')) {
            analyticsFired.current = true;
            const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled'); // Flatten all items from all sections
            const allItems = sections.flatMap((section)=>section.items); // Build metadata for each section
            const sectionMetadata = sections.map((section, sectionIndex)=>{
                const sectionItems = section.items; // Extract all ATIs and types from items in this section
                const sectionItemAtis = sectionItems.map((item)=>(0, $5872fbca13241433$export$964d21685ad57bfa)(item) ? item.ati.toString() : item.ati || 'unknown');
                const sectionItemTypes = sectionItems.map((item)=>(0, $5872fbca13241433$export$964d21685ad57bfa)(item) ? 'native' : item.type); // Create metadata object for this section
                const baseMetadata = {
                    groupHeading: section.heading,
                    groupIndex: sectionIndex,
                    groupItemCount: section.items.length,
                    itemAtis: sectionItemAtis,
                    itemTypes: sectionItemTypes,
                    showMoreButton: !!(0, $d690491b6d31182a$export$c8ef8ec3af207203)(section.foldable, section.items.length)
                }; // Add type-specific properties
                if (section.type === 'appDefinedSection') return {
                    ...baseMetadata,
                    type: 'appDefinedSection',
                    personalize: section.personalize ?? 'off'
                };
                else return {
                    ...baseMetadata,
                    type: 'suggestionSection'
                };
            }); // Fire analytics event with aggregated data
            fireNewMenuItemsViewed({
                crossAppCreationEnabled: crossAppCreationEnabled,
                totalSections: sections.length,
                totalNativeItems: allItems.filter((0, $5872fbca13241433$export$964d21685ad57bfa)).length,
                totalCrossAppItems: allItems.filter((item)=>!(0, $5872fbca13241433$export$964d21685ad57bfa)(item)).length,
                sectionMetadata: sectionMetadata
            });
        }
    }, [
        sections,
        fireNewMenuItemsViewed
    ]);
    return null;
}
const $9aa5319017567367$var$MenuContentV2WithIntl = (0, $503da3927b063db6$export$a5d940130f33be3f)($9aa5319017567367$var$MenuContentV2Inner);
const $9aa5319017567367$export$d54d952454c9bc12 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($9aa5319017567367$var$MenuContentV2WithIntl, {})
    });



/**
 * Type guard to check if props are v1 (has 'items' property)
 */ function $4ddd708270831c0a$var$isV1Props(props) {
    return 'items' in props;
}
/**
 * Type guard to check if props are v2 (has 'sections' property)
 */ function $4ddd708270831c0a$var$isV2Props(props) {
    return 'sections' in props;
}
const $4ddd708270831c0a$var$FlagsWrapper = ({ children: children })=>{
    if ((0, $dh538.fg)('navx_uc_platformisation_forms_enabled')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: children
    });
    return children;
};
function $4ddd708270831c0a$export$5c89068caaa33f77(props) {
    // ============================================================================
    // Props Extraction with Version Detection
    // ============================================================================
    // Extract common props (available in both v1 and v2)
    const { children: children, testId: testId, shouldRenderToParent: shouldRenderToParent, onClick: onClick, onClose: onClose, selectedItem: selectedItem, product: product, subProduct: subProduct, isOpen: controlledOpen = false, enableTriggerPulse: enableTriggerPulse = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, preventClose: preventClose = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem } = props;
    // Extract version-specific props with type narrowing
    // V1 props
    const items = $4ddd708270831c0a$var$isV1Props(props) ? props.items : undefined;
    const suggestionConfig = $4ddd708270831c0a$var$isV1Props(props) ? props.suggestionConfig ?? {
        enabled: false
    } : {
        enabled: false
    };
    // V2 props
    const isV2Mode = (0, $dh538.fg)('navx_uc_cross_app_creation_v2_enabled') && $4ddd708270831c0a$var$isV2Props(props);
    const sections = (0, $42omo.useMemo)(()=>isV2Mode ? props.sections : [], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isV2Mode,
        isV2Mode && props.sections
    ]);
    const crossAppCreationConfig = isV2Mode ? props.crossAppCreationConfig ?? {
        enabled: false
    } : {
        enabled: false
    };
    // ============================================================================
    // Component Logic (unchanged from original)
    // ============================================================================
    const isResponsive = (0, $a714a9fde214d42c$export$2a50c0408cf3ddb8)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(controlledOpen || false);
    // Normalize items for v1, or use empty array for v2
    const structuredItems = (0, $d27513c3e3d1447c$export$badb391c957852f7)(items ?? []);
    const defaultMenu = (0, $42omo.useCallback)(()=>isV2Mode ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9aa5319017567367$export$d54d952454c9bc12), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6ab96820cdb7ca90$export$2e2bcd8739ae039), {}), [
        isV2Mode
    ]);
    const [createContent, setCreateContent] = (0, $42omo.useState)(()=>defaultMenu);
    const { fireMenuStateChanged: fireMenuStateChanged } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const reset = (0, $42omo.useCallback)(()=>{
        setCreateContent(()=>defaultMenu);
    }, [
        defaultMenu
    ]);
    const close = (0, $42omo.useCallback)(()=>{
        setCreateContent(()=>defaultMenu);
        setIsOpen(false);
    }, [
        defaultMenu
    ]);
    const load = (0, $42omo.useCallback)((loadCreateContent)=>{
        setCreateContent(()=>(contentProps)=>loadCreateContent(contentProps, {
                    reset: reset,
                    close: close
                }));
    }, [
        close,
        reset
    ]);
    const triggerButtonClick = (0, $42omo.useCallback)(()=>{
        setIsOpen((prev)=>{
            if (prev) onClose?.();
            return !prev;
        });
        onClick?.();
    }, [
        onClick,
        onClose,
        setIsOpen
    ]);
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $be8eb3f37dd41711$export$4129321aecd13375), {
            testId: testId,
            triggerButtonSpotlightTarget: triggerButtonSpotlightTarget,
            enableTriggerPulse: enableTriggerPulse,
            isOpen: isOpen,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: triggerButtonClick,
            triggerProps: triggerProps,
            isNav4Enabled: isNav4Enabled,
            buttonTheme: buttonTheme,
            primaryActionItem: primaryActionItem,
            children: children
        }), [
        children,
        enableTriggerPulse,
        isOpen,
        testId,
        triggerButtonClick,
        triggerButtonSpotlightTarget,
        buttonTheme,
        isNav4Enabled,
        onMouseEnter,
        onMouseLeave,
        primaryActionItem
    ]);
    const onCloseMenu = (0, $42omo.useCallback)(()=>{
        if (product === 'confluence' && preventClose) return;
        setIsOpen(false);
        setCreateContent(()=>defaultMenu);
        onClose?.();
    }, [
        defaultMenu,
        onClose,
        product,
        preventClose
    ]);
    const foundItem = (0, $42omo.useMemo)(()=>{
        if (!selectedItem) return null;
        if (isV2Mode) return (0, $d27513c3e3d1447c$export$1ed1ee46541b3e7a)(sections, selectedItem);
        return (0, $d27513c3e3d1447c$export$5a8ab32aeea5694f)(structuredItems, selectedItem);
    }, [
        selectedItem,
        isV2Mode,
        sections,
        structuredItems
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isOpen) {
            const loadContent = foundItem?.loadCreateContent;
            if (loadContent) setCreateContent(()=>(contentProps)=>loadContent(contentProps, {
                        reset: reset,
                        close: close
                    }));
            else reset();
        }
    }, [
        close,
        isOpen,
        foundItem?.loadCreateContent,
        reset
    ]);
    (0, $42omo.useEffect)(()=>{
        if (controlledOpen !== undefined) setIsOpen(controlledOpen);
    }, [
        controlledOpen
    ]);
    const prevIsOpenRef = (0, $42omo.useRef)(isOpen);
    (0, $42omo.useEffect)(()=>{
        const prevIsOpen = prevIsOpenRef.current;
        // Only fire analytics on actual state transitions
        if (isOpen !== prevIsOpen) fireMenuStateChanged({
            itemState: isOpen ? 'expanded' : 'collapsed',
            version: isV2Mode ? 'v2' : 'v1'
        });
        prevIsOpenRef.current = isOpen;
    }, [
        isOpen,
        fireMenuStateChanged,
        prevIsOpenRef,
        isV2Mode
    ]);
    const loadPopupContent = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6477ac45fd3dd7b4$export$98eff9c5659394e3), {
            children: createContent(props)
        }), [
        createContent
    ]);
    const popup = /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        isOpen: isOpen,
        placement: isResponsive && isNav4Enabled || primaryActionItem ? 'bottom-end' : 'bottom-start',
        // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
        shouldRenderToParent: shouldRenderToParent,
        onClose: onCloseMenu,
        content: loadPopupContent,
        trigger: popupTrigger
    });
    // ============================================================================
    // MenuControlContext Value Construction
    // Populate context with appropriate values based on props version
    // ============================================================================
    const menuControlContextValue = {
        reset: reset,
        close: close,
        load: load,
        // V1 fields
        mixedItems: structuredItems,
        suggestionConfig: suggestionConfig ?? {
            enabled: false
        },
        sections: // V2 fields
        sections,
        crossAppCreationConfig: crossAppCreationConfig ?? {
            enabled: false
        },
        product: // Common fields
        product,
        subProduct: subProduct,
        isNav4Enabled: isNav4Enabled
    };
    if ((0, $dh538.fg)('navx_uc_top_level_wrappers_refactor')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $19BZl.MenuControlContext).Provider, {
        value: menuControlContextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9b030845b586bf65$export$2374d7ac6bcc110a), {
            children: popup
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $caUKj.BFFProvider), {
        consumer: (0, $4jETc.BFFConsumerEnum).UNIVERSAL_CREATE,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $19BZl.MenuControlContext).Provider, {
            value: menuControlContextValue,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9e0b6cda42c52c0b$export$3354c7b2b0c57e), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($4ddd708270831c0a$var$FlagsWrapper, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)($4ddd708270831c0a$var$AnalyticsWrapper, {
                        children: popup
                    })
                })
            })
        })
    });
}
const $4ddd708270831c0a$var$AnalyticsWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            source: 'topNav'
        },
        children: children
    });
};
var $4ddd708270831c0a$export$2e2bcd8739ae039 = $4ddd708270831c0a$export$5c89068caaa33f77;



var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $56QzY = parcelRequire("56QzY");


var $lBYCH = parcelRequire("lBYCH");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $de2j9 = parcelRequire("de2j9");


var $7zgzO = parcelRequire("7zgzO");


var $gz8ZY = parcelRequire("gz8ZY");


var $3J7nf = parcelRequire("3J7nf");


var $3Yga2 = parcelRequire("3Yga2");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7EIq6 = parcelRequire("7EIq6");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $bf0e479659c73d50$var$initialState = {
    isOpen: false,
    openFrom: ''
};
const $bf0e479659c73d50$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        },
    setOpenFrom: (openFrom)=>({ setState: setState })=>{
            setState({
                openFrom: openFrom
            });
        }
};
const $bf0e479659c73d50$var$Store = (0, $1P1Tu.createStore)({
    initialState: $bf0e479659c73d50$var$initialState,
    actions: $bf0e479659c73d50$var$actions,
    name: 'UniversalCreateStore'
});
const $bf0e479659c73d50$export$c7381b2490bb4d36 = (0, $9zUhf.createStateHook)($bf0e479659c73d50$var$Store);
const $bf0e479659c73d50$export$6c5b9a107b000099 = (0, $9zUhf.createActionsHook)($bf0e479659c73d50$var$Store);

















var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");








var $1KBSi = parcelRequire("1KBSi");

var $5xTWd = parcelRequire("5xTWd");


var $yuLaV = parcelRequire("yuLaV");





var $kDja4 = parcelRequire("kDja4");





var $6mKj3 = parcelRequire("6mKj3");


var $d9tcB = parcelRequire("d9tcB");





var $fSDMD = parcelRequire("fSDMD");













var $e0ycV = parcelRequire("e0ycV");





var $lqy4C = parcelRequire("lqy4C");


var $8Qafc = parcelRequire("8Qafc");


var $dilhZ = parcelRequire("dilhZ");








var $b3j2Y = parcelRequire("b3j2Y");








var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");


var $dkIiA = parcelRequire("dkIiA");





var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $5nBzc = parcelRequire("5nBzc");


var $c8U3F = parcelRequire("c8U3F");

const $925aeaac5c2ec2fe$var$titleSpacingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $925aeaac5c2ec2fe$export$32629a9f34b6d093 = ({ children: children, lozenge: lozenge, useLabsLozenge: useLabsLozenge })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $925aeaac5c2ec2fe$var$titleSpacingStyles
    }, children), useLabsLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8U3F.ConfluenceLabsLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "new"
    }, lozenge));


const $27cf2e1d8d21e923$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.liveDoc.title",
        defaultMessage: "Live Doc"
    },
    newLozenge: {
        id: "create-blank-fabric-page.universal-create.liveDoc.new.lozenge",
        defaultMessage: "New"
    }
});
const $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM = 'create-live-doc-popover-item';
function $27cf2e1d8d21e923$export$5af7ed73ba9cf3af({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
    });
    const createHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
        parentPageId: parentId,
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    });
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (e)=>{
        onClick('createLiveDocPopoverItem');
        hybridLinkClick(e);
        (0, $3Yga2.setLozengeShownTrackerMax)(); // Disable live docs lozenge after user creates live doc
    };
    // shouldShowLozenge should be stabilized so it is not checked each re-render
    // we also do not want the lozenge to disappear if it's already shown, even if tracker value changes
    const shouldShowLozenge = (0, $42omo.useMemo)(()=>(0, $3Yga2.checkShouldShowLozenge)(), []);
    // Lozenge is always removed only on Hello.
    const titleItem = (0, $9wGTI.fg)('confluence_remove_live_page_lozenge_hello') || !shouldShowLozenge ? formatMessage($27cf2e1d8d21e923$var$messages.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
        lozenge: formatMessage($27cf2e1d8d21e923$var$messages.newLozenge)
    }, formatMessage($27cf2e1d8d21e923$var$messages.title));
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:livedoc'),
        children: titleItem,
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        Wrapper: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27cf2e1d8d21e923$var$LiveDocSpotlightWrapper, {
                ...props,
                source: source,
                createHref: createHref,
                handleClick: handleClick
            }),
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}
const $27cf2e1d8d21e923$var$LiveDocSpotlightWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ children: children, source: source, createHref: createHref, handleClick: handleClick })=>{
    const hasFiredOnStartEventRef = (0, $42omo.useRef)(false);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { introSpotlight: introSpotlight, error: error } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { isVisible: shouldShowIntroSpotlight, complete: completeIntroSpotlight } = introSpotlight;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
    });
    const onSpotlightStart = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'spotlight',
                actionSubjectId: 'liveDocIntro',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldShowIntroSpotlight && !hasFiredOnStartEventRef.current) {
            onSpotlightStart();
            hasFiredOnStartEventRef.current = true;
        }
    }, [
        shouldShowIntroSpotlight,
        onSpotlightStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Qafc.CreateButtonSpotlightPulseWrapper), {
        condition: shouldShowIntroSpotlight,
        wrapper: (element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dilhZ.CreateLiveDocPopoverItemSpotlight), {
                handleDismiss: ()=>{
                    completeIntroSpotlight();
                },
                handleProceed: enforceStorageLimit((e)=>{
                    completeIntroSpotlight();
                    handleClick(e);
                    push(createHref);
                }),
                targetName: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM,
                source: source,
                fireAnalyticsEventOnMessageDisposition: false
            }, element, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }))
    }, children());
});











var $8jHAi = parcelRequire("8jHAi");













const $f6498381976d168b$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.title",
        defaultMessage: "Page"
    }
});
function $f6498381976d168b$export$e324b86258d66a8f({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-page-popover-item'
    });
    const createHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        parentPageId: parentId,
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    });
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        onClick('createPagePopoverItem');
        hybridPageLinkClick(e);
    }, [
        onClick,
        hybridPageLinkClick
    ]);
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:page'),
        children: formatMessage($f6498381976d168b$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}


/* useWhiteboardItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $ZDq1z = parcelRequire("ZDq1z");





var $gj7hi = parcelRequire("gj7hi");





var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");





var $eVXGa = parcelRequire("eVXGa");


var $8aF6s = parcelRequire("8aF6s");


var $lv5Bc = parcelRequire("lv5Bc");

var $gUusY = parcelRequire("gUusY");


var $8fj5s = parcelRequire("8fj5s");















var $5nX81 = parcelRequire("5nX81");


var $fCfQ7 = parcelRequire("fCfQ7");


var $98wxI = parcelRequire("98wxI");


var $dcUvx = parcelRequire("dcUvx");

const $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT = 'cc-whiteboard-nudge-global-create-experiment';
const $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM = 'globalCreateCohort';
const $10e7e2c648ba4dd0$export$118062d2c7c760ca = {
    experimentName: $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT,
    cohort: $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM
};
const $10e7e2c648ba4dd0$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.whiteboard.title",
        defaultMessage: "Whiteboard"
    },
    toolTipTextAnonymous: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-anonymous",
        defaultMessage: "Log in to create a whiteboard"
    },
    toolTipTextUnlicensed: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-unlicensed",
        defaultMessage: "Sign up to Confluence to create a whiteboard"
    }
});
const $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES = {
    contentType: 'whiteboard',
    paywallFlow: 'upfront'
};
const $10e7e2c648ba4dd0$var$f1GameStyles = {
    itemWrapper: "_4cvr1h6o _1bah1yb4 _1e0c1txw _kqswh2mm",
    childrenWrapper: "_16jlkb7n",
    rightIcon: "_4t3idlk8 _kqswstnw _1xi2pxbi _lcxvglyw"
};
const $10e7e2c648ba4dd0$var$F1GameWrapper = ({ children: children })=>{
    const [showRacecarIcon, setShowRacecarIcon] = (0, $42omo.useState)(false);
    const handleOnMouseEnter = (_)=>{
        (0, $6mKj3.isExperimentEnabled)('confluence_race_mode') && setShowRacecarIcon(true);
    };
    const handleOnMouseLeave = (_)=>{
        (0, $6mKj3.isExperimentEnabled)('confluence_race_mode') && setShowRacecarIcon(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: handleOnMouseEnter,
        onFocus: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave,
        onBlur: handleOnMouseLeave,
        className: (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.itemWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.childrenWrapper
        ])
    }, children()), showRacecarIcon && (0, $6mKj3.isExperimentEnabled)('confluence_race_mode') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Zoooom! Necessary to prevent inheritence from higher level css specificity
    ), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
        alt: "",
        testId: "confluence-whiteboards-car-icon",
        className: (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.rightIcon
        ])
    }));
};
function $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isOpen: isOpen } = (0, $bf0e479659c73d50$export$c7381b2490bb4d36)();
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)(); // const { accessStatus } = useSessionData();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // https://switcheroo.atlassian.com/ui/gates/43f5fd03-3bd9-48a0-b583-5de8b778977a/key/load-whiteboards-paywall-query-when-menu-is-open
    const skipPaywallQuery = (0, $9wGTI.fg)('load-whiteboards-paywall-query-when-menu-is-open') && !isOpen;
    const { deactivationIdentifier: deactivationIdentifier, error: creationPaywallError, paywallStatus: paywallStatus, showPaywallBeforeCreate: showPaywallBeforeCreate } = (0, $5nX81.useWhiteboardCreationPaywall)(skipPaywallQuery);
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-whiteboard-popover-item'
    });
    const buildWhiteboardCreationLink = (creationOverrides = {}, sourceSuffix = '')=>{
        return (0, $bZSO8.buildCreationLink)({
            contentType: 'whiteboard',
            parentPageId: parentId,
            withFallback: true,
            source: source + sourceSuffix,
            spaceKey: spaceKey,
            deactivationIdentifier: deactivationIdentifier,
            paywallStatus: paywallStatus,
            ...creationOverrides
        });
    };
    const createHref = buildWhiteboardCreationLink();
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (e)=>{
        onClick('createWhiteboardPopoverItem'); // https://switcheroo.atlassian.com/ui/gates/4fe23e91-1be4-4713-93b6-17b6bc84e9da/key/confluence_content_creation_paywall_fix_enabled
        if ((0, $9wGTI.fg)('confluence_content_creation_paywall_fix_enabled')) {
            experienceTracker.start({
                name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES,
                collect: (0, $5nX81.collectStartCreateWhiteboardExperience)
            });
            if (creationPaywallError) experienceTracker.fail({
                name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                error: creationPaywallError
            });
        }
        if (showPaywallBeforeCreate) {
            // stop the default behaviour - we want to show our modal instead
            e.stopPropagation();
            e.preventDefault();
            showModal((0, $fCfQ7.WhiteboardCreationPaywallDialog), {
                buildWhiteboardCreationLink: buildWhiteboardCreationLink
            });
        } else {
            if (paywallStatus === (0, $98wxI.PaywallStatus).UNSET) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'createUnsetWhiteboardLink',
                    source: source,
                    attributes: {
                        reason: creationPaywallError ? 'error' : 'loading'
                    }
                }
            }).fire();
            hybridLinkClick(e);
        }
    }; // TODO: add tooltip back post T25
    // const getTooltipContent = (accessStatusArg: AccessStatus | null): string | undefined => {
    // 	if (!isAllowedToCreateWhiteboard) {
    // 		if (accessStatusArg === null) {
    // 			return formatMessage(messages.toolTipTextAnonymous);
    // 		} else {
    // 			return formatMessage(messages.toolTipTextUnlicensed);
    // 		}
    // 	}
    // 	return undefined;
    // };
    // const toolTipContent = getTooltipContent(accessStatus);
    // Whiteboard Nudge Campaign Experiment
    const { getExperiment: getExperiment, skipCoordinationClientForExperiment: skipCoordinationClientForExperiment } = (0, $gUusY.useWhiteboardNudgeExperiments)($10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT, $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM);
    const [isWhiteboardExperimentationSpotlightActive, stopWhiteboardExperimentationSpotlight] = (0, $8fj5s.useSkippableCoordination)('cc-whiteboards-nudge-exp-spotlight-v2', shouldBlockCreate || skipCoordinationClientForExperiment);
    const [isSpotlightOpen, setIsSpotlightOpen] = (0, $42omo.useState)(true);
    const isEligibleToSeeSpotlight = isWhiteboardExperimentationSpotlightActive && getExperiment($10e7e2c648ba4dd0$export$118062d2c7c760ca['experimentName'], $10e7e2c648ba4dd0$export$118062d2c7c760ca['cohort'], true) === 'variation';
    const handleSpotlightClose = (0, $42omo.useCallback)(()=>{
        setIsSpotlightOpen(false);
        stopWhiteboardExperimentationSpotlight();
    }, [
        stopWhiteboardExperimentationSpotlight,
        setIsSpotlightOpen
    ]);
    const WhiteboardSpotlightWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lv5Bc.CreateWhiteboardExperimentPopoverItemSpotlight), {
            createHref: createHref,
            spotlightDialogPlacement: "right middle",
            handleSpotlightClose: handleSpotlightClose,
            handleClosePopoverMenu: handleClick,
            source: source,
            shouldWatchTarget: true
        }, children());
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:whiteboard'),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, !(0, $9wGTI.fg)('confluence_content_creation_paywall_fix_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            collect: (0, $5nX81.collectStartCreateWhiteboardExperience),
            attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES
        }), creationPaywallError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: creationPaywallError
        })), formatMessage($10e7e2c648ba4dd0$var$messages.title)),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        // Vroom Vroom! - F1 Game Wrapper should be overriden by onboarding spotlight wrapper
        ...(0, $6mKj3.isExperimentEnabled)('confluence_race_mode') && {
            Wrapper: $10e7e2c648ba4dd0$var$F1GameWrapper
        },
        ...!shouldBlockCreate && isAllowedToCreateWhiteboard && {
            href: createHref
        },
        ...isSpotlightOpen && isEligibleToSeeSpotlight && isAllowedToCreateWhiteboard && {
            Wrapper: WhiteboardSpotlightWrapper
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}








var $6B0jU = parcelRequire("6B0jU");













const $c6e82055c002803e$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.database",
        defaultMessage: "Database"
    }
});
function $c6e82055c002803e$export$c03ba1b69410a0fd({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-database-popover-item'
    });
    const createContentOptions = {
        contentType: 'database',
        parentPageId: parentId,
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    };
    const createHref = (0, $bZSO8.buildCreationLink)(createContentOptions);
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (e)=>{
        onClick('createDatabasePopoverItem');
        hybridPageLinkClick(e);
    };
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:database'),
        children: formatMessage($c6e82055c002803e$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}











var $9RVmI = parcelRequire("9RVmI");













const $b66cd3653b467139$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.blog.title",
        defaultMessage: "Blog"
    }
});
function $b66cd3653b467139$export$1850e31ba3eb45b0({ source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-blog-popover-item'
    });
    const createHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'blog',
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    });
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        onClick('createBlogPopoverItem');
        hybridPageLinkClick(e);
    }, [
        onClick,
        hybridPageLinkClick
    ]);
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:blogpost'),
        children: formatMessage($b66cd3653b467139$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}








var $duwSm = parcelRequire("duwSm");













const $2e6ededdd99584ac$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.smart-link-embed.title",
        defaultMessage: "Smart Link"
    }
});
function $2e6ededdd99584ac$export$da2a30a64353a280({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-smart-link-embed-popover-item'
    });
    const createContentOptions = {
        contentType: 'smartLinkEmbed',
        parentPageId: parentId,
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    };
    const createHref = (0, $bZSO8.buildCreationLink)(createContentOptions);
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (e)=>{
        onClick('createSmartLinkEmbedPopoverItem');
        hybridPageLinkClick(e);
    };
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:embed'),
        children: formatMessage($2e6ededdd99584ac$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($duwSm))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}











var $buthI = parcelRequire("buthI");


var $hbYDZ = parcelRequire("hbYDZ");

















var $bAyaS = parcelRequire("bAyaS");


var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");








var $jyA9t = parcelRequire("jyA9t");




const $293cf5b691bb25ab$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.space.title",
        defaultMessage: "Space"
    }
});
function $293cf5b691bb25ab$export$4adf07b2777336fa({ source: source, onClick: onClick }) {
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-space-button'
    });
    const { resetStickySearchRef: resetStickySearchRef, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const createSpaceButtonRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        resetStickySearchRef?.current?.();
        const location = 'topCreateNav';
        if (isRovoLLMEnabled && (0, $9wGTI.fg)('aifc_space_creation_enabled')) openModal('globalCreateSpaceButton', '');
        else openDrawer(createContentPopoverButtonRef || createSpaceButtonRef, location);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSpaceButton',
                source: source,
                attributes: {
                    location: location
                }
            }
        }).fire();
        onClick('createSpacePopoverItem');
        e.stopPropagation();
    }, [
        createAnalyticsEvent,
        createContentPopoverButtonRef,
        openDrawer,
        onClick,
        openModal,
        resetStickySearchRef,
        source,
        isRovoLLMEnabled
    ]);
    const preloadCreateSpace = ()=>{
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.CREATE_SPACE_DIALOG)
        });
    };
    const PreloadSpaceWrap = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            onMouseDown: preloadCreateSpace
        }, children());
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:space'),
        children: formatMessage($293cf5b691bb25ab$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
        testId: 'create-menu-button-item',
        Wrapper: PreloadSpaceWrap
    };
}














var $2Yaht = parcelRequire("2Yaht");


var $jojoK = parcelRequire("jojoK");





var $4R3wx = parcelRequire("4R3wx");


var $f5Ulo = parcelRequire("f5Ulo");


var $9uAPw = parcelRequire("9uAPw");


var $8Q0mA = parcelRequire("8Q0mA");








var $7QM6o = parcelRequire("7QM6o");


var $lKj5W = parcelRequire("lKj5W");











const $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $3e0600a499c498b6$var$CROSS_JOIN = 'CROSS_JOIN';
const $3e0600a499c498b6$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.loom.title",
        defaultMessage: "Loom video"
    },
    crossJoinPopupTitle: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupTitle",
        defaultMessage: "Share your work with a video"
    },
    crossJoinPopupDescription: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossJoinCTA: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinCTA",
        defaultMessage: "Try now"
    },
    crossJoinLozenge: {
        id: "create-blank-fabric-page.universal-create.loom.cross-join-lozenge",
        defaultMessage: "Join"
    }
});
function $3e0600a499c498b6$export$5c18cb5d6208bad4(error, loading) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const href = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const PopupWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
            description: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupDescription),
            entryPointId: "loom-confluence-create-menu",
            shouldRenderToParent: false,
            title: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupTitle),
            sourceActionSubjectId: "createLoomPopoverItem",
            triggerLink: (_, triggerProps)=>children({
                    triggerProps: triggerProps
                })
        });
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:loom-cross-join'),
        ...!error && !loading && {
            href: href
        },
        isLoading: loading,
        target: '_blank',
        testId: 'create-menu-link-item',
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: formatMessage($3e0600a499c498b6$var$messages.crossJoinLozenge)
        }, formatMessage($3e0600a499c498b6$var$messages.title)),
        Wrapper: PopupWrapper,
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht)))
    };
}
const $3e0600a499c498b6$export$3bdf8358f565b3a3 = ({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, hasRecordingAccess: hasRecordingAccess } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        entryPointLocation: $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE,
        flags: flags
    });
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'record-loom-popover-item'
    });
    const handleClick = (0, $42omo.useCallback)(()=>{
        onClick('createLoomPopoverItem');
        openLoomRecorder({
            onInsert: (videoUrl)=>{
                const createUrl = (0, $bZSO8.buildCreationLink)({
                    contentType: 'smartLinkEmbed',
                    parentPageId: parentId,
                    withFallback: true,
                    smartLinkCreateSource: 'loomRecordSDK',
                    smartLinkEmbedUrl: videoUrl,
                    source: source,
                    spaceKey: spaceKey
                });
                push(createUrl);
                (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'insertVideo',
                            actionSubject: 'loom',
                            source: source,
                            objectType: 'embed',
                            containerType: 'space',
                            containerId: spaceId,
                            attributes: {
                                location: 'contentTreeItem',
                                video_id: hashedVideoId
                            }
                        }
                    }).fire();
                });
            },
            // intentionally not localized because Loom RecordSDK does not support i18n
            insertButtonText: 'Insert video',
            location: 'topNav'
        });
    }, [
        onClick,
        openLoomRecorder,
        parentId,
        source,
        spaceKey,
        push,
        createAnalyticsEvent,
        spaceId
    ]);
    const shouldShowLoomGAOnboarding = isLoomRecorderInitialized && hasRecordingAccess && (0, $9wGTI.fg)('confluence_m25_onboarding_spotlights');
    const [isLoomGAOnboardingActive, stopLoomGAOnboarding] = (0, $8fj5s.useSkippableCoordination)('cc-loom-onboarding-spotlight-creation', !shouldShowLoomGAOnboarding || shouldBlockCreate);
    const [isGASpotlightOpen, setIsGASpotlightOpen] = (0, $42omo.useState)(true);
    const handleSpotlightClose = (0, $42omo.useCallback)(()=>{
        if (isLoomGAOnboardingActive) {
            setIsGASpotlightOpen(false);
            stopLoomGAOnboarding();
        }
    }, [
        stopLoomGAOnboarding,
        isLoomGAOnboardingActive
    ]);
    const RecordLoomSpotlightWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lKj5W.RecordLoomPopoverItemSpotlight), {
            onRecord: enforceStorageLimit(handleClick),
            onClose: handleSpotlightClose,
            source: source,
            shouldWatchTarget: true
        }, children());
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:video'),
        children: formatMessage($3e0600a499c498b6$var$messages.title),
        isLoading: !isLoomRecorderInitialized,
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
        testId: 'create-menu-button-item',
        onClick: enforceStorageLimit(handleClick),
        ...shouldShowLoomGAOnboarding && isLoomGAOnboardingActive && isGASpotlightOpen && {
            Wrapper: RecordLoomSpotlightWrapper
        }
    };
};
function $3e0600a499c498b6$export$2c423d86f10c527b(props) {
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const recordItem = $3e0600a499c498b6$export$3bdf8358f565b3a3(props);
    const crossJoinItem = $3e0600a499c498b6$export$5c18cb5d6208bad4(error, loading);
    return entryPointVariant === $3e0600a499c498b6$var$CROSS_JOIN ? crossJoinItem : recordItem;
}











var $h7YX1 = parcelRequire("h7YX1");





var $16lEl = parcelRequire("16lEl");

var $7pmZw = parcelRequire("7pmZw");


var $hp2SH = parcelRequire("hp2SH");





var $dDAsV = parcelRequire("dDAsV");








var $cSCao = parcelRequire("cSCao");

const $a873bb1c9107ef25$export$8432db7340d3c5cd = ({ onClick: onClick, isLoading: isLoading, source: source, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSCao.AISmartCreateSpotlight), {
        onClick: onClick,
        offset: [
            0,
            16
        ],
        placement: "left-end",
        source: source,
        isLoading: isLoading
    }, children);
};



var $6fP4Z = parcelRequire("6fP4Z");




var $5w6h6 = parcelRequire("5w6h6");

const $03068ae1a528f6bf$var$i18n = (0, $cgtv4.defineMessages)({
    smartCreateTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-ai.title",
        defaultMessage: "Create with Rovo"
    }
});
const $03068ae1a528f6bf$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const spaceKeyResponse = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_schema_exp_2', 'isEnabled', true) ? (await (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: {
            ...spaceKeyRequest,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    })).data : // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    (await (0, $hp2SH.getApolloClient)().query({
        query: (0, $5w6h6.GetPromotedSpacesQuery),
        variables: spaceKeyRequest
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $03068ae1a528f6bf$export$57669fd702f839a2({ spaceKey: spaceKey, onClick: onClick, source: source, excludeContext: excludeContext }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isOpen: isOpen } = (0, $bf0e479659c73d50$export$c7381b2490bb4d36)();
    const experienceTracker = (0, $7pmZw.useAIMateExperienceTracker)();
    const { preloadSmartCreationModalQuery: preloadSmartCreationModalQuery } = (0, $6fP4Z.usePreloadSmartCreationModalQuery)();
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $42omo.useState)('');
    const [spaceKeyLoading, setSpaceKeyLoading] = (0, $42omo.useState)(true);
    // Promoted Spaces query should be cached, but we do have a race condition here for global create where there
    // can potentially be missing space key. This is fine for the early spike stage.
    (0, $42omo.useEffect)(()=>{
        setSpaceKeyLoading(true);
        $03068ae1a528f6bf$var$getSpaceKeyForCreation().then(setFetchedSpaceKey).finally(()=>setSpaceKeyLoading(false));
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (isOpen) preloadSmartCreationModalQuery();
    }, [
        isOpen,
        preloadSmartCreationModalQuery
    ]);
    const handleOpenCreateWithRovoExperience = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
            id: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
            attributes: {
                product: 'confluence',
                source: source
            }
        });
        if (excludeContext) openModal(source);
        else openModal(source, spaceKey ?? fetchedSpaceKey);
    }, [
        excludeContext,
        experienceTracker,
        fetchedSpaceKey,
        openModal,
        source,
        spaceKey
    ]);
    const handleItemOnClick = (0, $42omo.useCallback)((actionSubjectId, attributes)=>{
        onClick(actionSubjectId, attributes);
        handleOpenCreateWithRovoExperience();
    }, [
        onClick,
        handleOpenCreateWithRovoExperience
    ]);
    const CreateWithRovoSpotlightWrapper = (0, $42omo.useMemo)(()=>{
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a873bb1c9107ef25$export$8432db7340d3c5cd), {
                onClick: ()=>handleOpenCreateWithRovoExperience(),
                isLoading: spaceKeyLoading,
                source: source
            }, props.children && props.children());
    }, [
        handleOpenCreateWithRovoExperience,
        source,
        spaceKeyLoading
    ]);
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:page'),
        // todo: this is incorrect, we don't know the type identifier yet
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            useLabsLozenge: true
        }, formatMessage($03068ae1a528f6bf$var$i18n.smartCreateTitle)),
        Wrapper: CreateWithRovoSpotlightWrapper,
        onClick: ()=>handleItemOnClick('createAISmartCreatePopoverItem'),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
        testId: `create-menu-link-item`
    };
}


const $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $279d18c421fdc96b$var$messages = (0, $cgtv4.defineMessages)({
    moreFromAtlassian: {
        id: "create-blank-fabric-page.universal-create.suggestions",
        defaultMessage: "Suggestions"
    }
});
function $279d18c421fdc96b$export$aad046bd9909db8f(flags, closeMenu, openFrom) {
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const handleAnalyticsAndResetStickySearch = (0, $42omo.useCallback)((actionSubjectId, attributes)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId,
                source: $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE,
                attributes: {
                    navdexPointType: (0, $56QzY.END),
                    isOnEditRoute: isOnEditRoute,
                    currentRouteName: routeDataRef?.current?.routeName,
                    currentRouteIsLive: isLivePage,
                    openFrom: openFrom,
                    ...attributes
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isOnEditRoute,
        routeDataRef,
        isLivePage,
        openFrom
    ]);
    const onClick = (0, $42omo.useCallback)((actionSubjectId, attributes)=>{
        handleAnalyticsAndResetStickySearch(actionSubjectId, attributes);
        closeMenu?.();
    }, [
        handleAnalyticsAndResetStickySearch,
        closeMenu
    ]);
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const { isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled } = (0, $5xTWd.useCreateSpaceExperiment)();
    const { canCreateSpace: canCreateSpace } = (0, $1KBSi.useCanCreateSpace)();
    const isCreateSpaceFromGlobalCreateEnabled = canCreateSpace && isSpaceTypesCreationFlowEnabled;
    const isLoomEntryPointEnabled = (0, $fSDMD.useIsCreateMenuLoomRecorderEntryPointEnabled)();
    const liveDoc = (0, $27cf2e1d8d21e923$export$5af7ed73ba9cf3af)({
        source: 'globalCreateDropdown-liveDoc',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const page = (0, $f6498381976d168b$export$e324b86258d66a8f)({
        source: 'globalCreateDropdown-page',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const whiteboard = (0, $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5)({
        source: 'globalCreateDropdown-whiteboard',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const database = (0, $c6e82055c002803e$export$c03ba1b69410a0fd)({
        source: 'globalCreateDropdown-database',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const blog = (0, $b66cd3653b467139$export$1850e31ba3eb45b0)({
        source: 'globalCreateDropdown-blog',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const embed = (0, $2e6ededdd99584ac$export$da2a30a64353a280)({
        source: 'globalCreateDropdown-smartLinkEmbed',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const loom = (0, $3e0600a499c498b6$export$2c423d86f10c527b)({
        source: 'globalCreateDropdown-smartLinkEmbed',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick,
        flags: flags
    });
    const space = (0, $293cf5b691bb25ab$export$4adf07b2777336fa)({
        source: $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE,
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const smartCreate = (0, $03068ae1a528f6bf$export$57669fd702f839a2)({
        source: 'globalCreateDropdown-smartCreate',
        spaceKey: spaceKey,
        onClick: onClick,
        openFrom: openFrom,
        excludeContext: (0, $6mKj3.expValEquals)('platform_use_llm_space_recommendations', 'isEnabled', true)
    });
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isOptedOutedOfWhiteboards = isWhiteboardFeatureEnabled('whiteboardOptOut');
    const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const whiteboardOptIn = !isOptedOutedOfWhiteboards && isWhiteboardsEnabled;
    const databaseOptIn = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database') && !(0, $9wGTI.fg)('confluence_frontend_databases_opt-out');
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const getNativeItems = ()=>{
        const isAifcEnabled = isRovoLLMEnabled && !isAnonymousUser && (0, $9wGTI.fg)('aifc_create_enabled');
        if (!isAifcEnabled && (0, $6mKj3.expValEquals)('cc_fd_wb_create_menu_order', 'cohort', 'wb_first')) return {
            items: [
                ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                    whiteboard
                ] : [],
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...isCreateDatabaseEnabled && databaseOptIn ? [
                    database
                ] : [],
                ...isCreateBlogEnabled ? [
                    blog
                ] : [],
                ...isCreateSmartLinkEnabled ? [
                    embed
                ] : [],
                ...isCreateSpaceFromGlobalCreateEnabled ? [
                    space
                ] : []
            ]
        };
        else if (!isAifcEnabled && (0, $6mKj3.expValEquals)('cc_fd_wb_create_menu_order', 'cohort', 'db_first')) return {
            items: [
                ...isCreateDatabaseEnabled && databaseOptIn ? [
                    database
                ] : [],
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                    whiteboard
                ] : [],
                ...isCreateBlogEnabled ? [
                    blog
                ] : [],
                ...isCreateSmartLinkEnabled ? [
                    embed
                ] : [],
                ...isCreateSpaceFromGlobalCreateEnabled ? [
                    space
                ] : []
            ]
        };
        else return {
            items: [
                ...isAifcEnabled ? [
                    smartCreate
                ] : [],
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                    whiteboard
                ] : [],
                ...isCreateDatabaseEnabled && databaseOptIn ? [
                    database
                ] : [],
                ...isCreateBlogEnabled ? [
                    blog
                ] : [],
                ...isCreateSmartLinkEnabled ? [
                    embed
                ] : [],
                ...isCreateSpaceFromGlobalCreateEnabled ? [
                    space
                ] : []
            ]
        };
    };
    const menuItems = [
        getNativeItems()
    ];
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (isCreateSmartLinkEnabled && isLoomEntryPointEnabled) menuItems.push({
        heading: formatMessage($279d18c421fdc96b$var$messages.moreFromAtlassian),
        items: [
            loom
        ]
    });
    return menuItems;
}


const $f44feda85e5453ef$var$messages = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.universal-create.create.text",
        defaultMessage: "Create"
    }
});
const $f44feda85e5453ef$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $f44feda85e5453ef$var$Create = ({ flags: flags })=>{
    const { isOpen: isOpen } = (0, $bf0e479659c73d50$export$c7381b2490bb4d36)();
    const { setIsOpen: setIsOpen, setOpenFrom: setOpenFrom } = (0, $bf0e479659c73d50$export$6c5b9a107b000099)();
    const items = (0, $279d18c421fdc96b$export$aad046bd9909db8f)(flags, ()=>setIsOpen(false));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { theme: theme } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { introSpotlight: { isVisible: introSpotlightVisible } } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const hasIteratedShownTracker = (0, $42omo.useRef)(false);
    // shouldShowLozenge should be stabilized so it is not checked each re-render
    // we also do not want the lozenge to suddenly disappear if it's already shown
    const shouldShowLozenge = (0, $42omo.useMemo)(()=>(0, $3Yga2.checkShouldShowLozenge)(), []);
    const buttonTheme = theme?.mode?.create ? $f44feda85e5453ef$export$256eebed8e934f30(theme.mode.create) : undefined;
    const onCreateClick = (0, $42omo.useCallback)(()=>{
        if (!isOpen) {
            setIsOpen(true);
            if (shouldShowLozenge && isCreateLiveDocEnabled && !hasIteratedShownTracker.current) {
                (0, $3Yga2.iterateLozengeShownTracker)();
                hasIteratedShownTracker.current = true;
            }
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'globalCreateContentPopover',
                source: 'globalNavigation',
                attributes: {
                    selectedItemPageContext: match?.name,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: isNav4Enabled ? '4' : '3',
                    navdexPointType: (0, $56QzY.START),
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isNav4Enabled,
        isOnEditRoute,
        match?.name,
        isOpen,
        setIsOpen,
        shouldShowLozenge,
        isCreateLiveDocEnabled
    ]);
    //Reset the openFrom state when the create menu is closed
    const onClose = ()=>{
        setIsOpen(false);
        setOpenFrom('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ddd708270831c0a$export$2e2bcd8739ae039), {
        items: items,
        onClick: onCreateClick,
        triggerButtonSpotlightTarget: "top-nav-create",
        enableTriggerPulse: false,
        isNav4Enabled: isNav4Enabled,
        isOpen: isOpen,
        onClose: onClose,
        product: "confluence",
        buttonTheme: buttonTheme,
        testId: "create-content-popover-button",
        preventClose: introSpotlightVisible && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding'),
        suggestionConfig: (0, $9wGTI.fg)('navx_uc_enable_suggestion_in_confluence') ? {
            enabled: true,
            compact: true,
            cloudId: cloudId || '',
            orgId: orgId || '',
            accountId: userId || ''
        } : {
            enabled: false
        },
        ...(0, $9wGTI.fg)('platform_navx_universal_create_a11y_fix') && {
            shouldRenderToParent: true
        }
    }, formatMessage($f44feda85e5453ef$var$messages.create));
};
const $f44feda85e5453ef$var$CreateWithFlags = (0, $7aRa9.withFlags)($f44feda85e5453ef$var$Create);
function $f44feda85e5453ef$export$b8b0dfc3e3d56c92() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).NAVX
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f44feda85e5453ef$var$CreateWithFlags, null));
}
module.exports["UniversalCreate"] = $f44feda85e5453ef$export$b8b0dfc3e3d56c92;

});

parcelRegister("4jETc", function(module, exports) {
var $3fcb4d970a94e7e9$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $3fcb4d970a94e7e9$export$45e63649edff1e2a = 'ASSETS';
const $3fcb4d970a94e7e9$export$45c80c6b98d65f36 = 3;
const $3fcb4d970a94e7e9$export$7b4183e5f0de390a = 1000;
const $3fcb4d970a94e7e9$export$891dc7068a3d5e65 = 14;
const $3fcb4d970a94e7e9$export$6e594fe130dbe3b = 14;
var $3fcb4d970a94e7e9$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $3fcb4d970a94e7e9$export$c889532d47d74e9c = 'bff';
const $3fcb4d970a94e7e9$export$123b1b8742c0ac6a = 'flightdeck';
const $3fcb4d970a94e7e9$export$95d80cce92acae9 = 'uc-suggestions';
const $3fcb4d970a94e7e9$export$1631e8a201b50246 = 'uc-menu-items';
module.exports["BFFConsumerEnum"] = $3fcb4d970a94e7e9$export$9a146e025690327e;
module.exports["ASSETS_APP_KEY"] = $3fcb4d970a94e7e9$export$45e63649edff1e2a;
module.exports["MAX_ATTEMPTS_DEFAULT"] = $3fcb4d970a94e7e9$export$45c80c6b98d65f36;
module.exports["RETRY_INTERVAL_DEFAULT"] = $3fcb4d970a94e7e9$export$7b4183e5f0de390a;
module.exports["DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW"] = $3fcb4d970a94e7e9$export$891dc7068a3d5e65;
module.exports["DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW"] = $3fcb4d970a94e7e9$export$6e594fe130dbe3b;
module.exports["RequestStatus"] = $3fcb4d970a94e7e9$export$600e7c1f9e0414e1;
module.exports["BFF_REQUEST_STATUS_KEY"] = $3fcb4d970a94e7e9$export$c889532d47d74e9c;
module.exports["FLIGHTDECK_REQUEST_STATUS_KEY"] = $3fcb4d970a94e7e9$export$123b1b8742c0ac6a;
module.exports["UC_SUGGESTIONS_REQUEST_STATUS_KEY"] = $3fcb4d970a94e7e9$export$95d80cce92acae9;
module.exports["UC_MENU_ITEMS_REQUEST_STATUS_KEY"] = $3fcb4d970a94e7e9$export$1631e8a201b50246;

});

parcelRegister("caUKj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4jETc = parcelRequire("4jETc");

const $f9a84eccaed6c052$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $f9a84eccaed6c052$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $42omo.createContext)({
    value: $f9a84eccaed6c052$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: (name, status)=>{}
});
function $f9a84eccaed6c052$export$63342c357ecccda2() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($f9a84eccaed6c052$export$873dcaf380a86d6b);
}
function $f9a84eccaed6c052$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $4jETc.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState([]);
    const updateCurrentLoadingRequests = (0, $42omo.useCallback)((name, status)=>{
        switch(status){
            case (0, $4jETc.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $4jETc.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $4jETc.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($f9a84eccaed6c052$export$873dcaf380a86d6b.Provider, {
        value: {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        },
        children: children
    });
}
const $f9a84eccaed6c052$var$defaultUserControls = {
    user: undefined
};
const $f9a84eccaed6c052$export$38ee920e59704589 = /*#__PURE__*/ (0, $42omo.createContext)($f9a84eccaed6c052$var$defaultUserControls);
function $f9a84eccaed6c052$export$87c54b525b914dab() {
    return (0, $42omo.useContext)($f9a84eccaed6c052$export$38ee920e59704589);
}
module.exports["BFFContext"] = $f9a84eccaed6c052$export$873dcaf380a86d6b;
module.exports["useBFFContext"] = $f9a84eccaed6c052$export$63342c357ecccda2;
module.exports["BFFProvider"] = $f9a84eccaed6c052$export$71a938590b6955cc;
module.exports["UserContext"] = $f9a84eccaed6c052$export$38ee920e59704589;
module.exports["useUserContext"] = $f9a84eccaed6c052$export$87c54b525b914dab;

});

parcelRegister("19BZl", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8e4be96129d634f8$var$defaultFormControls = {
    load: function() {},
    reset: function() {},
    close: function() {},
    mixedItems: [],
    product: 'unknown',
    subProduct: undefined,
    suggestionConfig: {
        enabled: false
    },
    isNav4Enabled: true,
    crossAppCreationConfig: {
        enabled: false
    },
    sections: []
};
const $8e4be96129d634f8$export$39aa3c8950714d79 = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultFormControls);
function $8e4be96129d634f8$export$56d95dc846453c64() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
}
module.exports["MenuControlContext"] = $8e4be96129d634f8$export$39aa3c8950714d79;
module.exports["useMenuControl"] = $8e4be96129d634f8$export$56d95dc846453c64;

});

parcelRegister("7K3dX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9DI9J = parcelRequire("9DI9J");


var $19BZl = parcelRequire("19BZl");

function $c3ddb99f3c87e2eb$export$eebe354ebe67c94c() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    // Provide fallback for product if undefined
    const safeProduct = product || 'unknown';
    const baseAttributes = (0, $42omo.useMemo)(()=>({
            navLayer: (0, $9DI9J.NAV_LAYER),
            navContainer: (0, $9DI9J.NAV_CONTAINER),
            navVersion: (0, $9DI9J.NAV_VERSION),
            product: safeProduct,
            subProduct: subProduct
        }), [
        safeProduct,
        subProduct
    ]);
    const topLevelAttributes = (0, $42omo.useMemo)(()=>({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ]
        }), []);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88038
    const fireCreateButtonClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88332
    const fireNewNativeMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateNativeMenuItem',
            attributes: {
                group: 'native',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88486
    const fireNewSuggestionsMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateSuggestionsMenuItem',
            attributes: {
                group: 'suggestions',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88295
    const fireNewMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateMenuItem',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88599
    const fireNewNativeMenuViewed_old = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateNativeMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88599
    const fireNewNativeMenuViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateNativeMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88724
    const fireNewSuggestionsMenuViewed_old = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateSuggestionsMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88724
    const fireNewSuggestionsMenuViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateSuggestionsMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92169
    const fireNewMenuItemsViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateMenuSection',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/89698
    const fireMenuStateChanged = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'changed',
            actionSubjectId: 'universalCreateMenuState',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        baseAttributes
    ]);
    // createModal viewed Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90539
    // createModalBackButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90540
    // createModalCancelButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90541
    // createModalCreateButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90542
    const fireFormControlAttributes = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, action: action = 'clicked', ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            actionSubject: 'universalCreate',
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    return {
        fireCreateButtonClicked: fireCreateButtonClicked,
        fireNewNativeMenuItemClicked: fireNewNativeMenuItemClicked,
        fireNewSuggestionsMenuItemClicked: fireNewSuggestionsMenuItemClicked,
        fireNewMenuItemClicked: fireNewMenuItemClicked,
        fireNewNativeMenuViewed_old: fireNewNativeMenuViewed_old,
        fireNewNativeMenuViewed: fireNewNativeMenuViewed,
        fireNewSuggestionsMenuViewed_old: fireNewSuggestionsMenuViewed_old,
        fireNewSuggestionsMenuViewed: fireNewSuggestionsMenuViewed,
        fireNewMenuItemsViewed: fireNewMenuItemsViewed,
        fireMenuStateChanged: fireMenuStateChanged,
        fireFormControlAttributes: fireFormControlAttributes
    };
}
module.exports["useUniversalCreateAnalytics"] = $c3ddb99f3c87e2eb$export$eebe354ebe67c94c;

});

parcelRegister("9DI9J", function(module, exports) {
const $7387c4ee4c968c68$export$85183a312807388d = 'navigation';
const $7387c4ee4c968c68$export$1f0ede2864ffece6 = 'navigationExperiences';
const $7387c4ee4c968c68$export$40fae459cb78b698 = 'global';
const $7387c4ee4c968c68$export$2ee98aa1b18a8f41 = 'top';
const $7387c4ee4c968c68$export$b4ed8a331b8fd4cc = 4;
const $7387c4ee4c968c68$export$f7109619a5e9e0d6 = 'topNav';
const $7387c4ee4c968c68$export$c091fab9d8f83000 = {
    LOOM: 'ati:cloud:loom:video',
    GOAL: 'ati:cloud:townsquare:goal',
    TEAM: 'ati:cloud:townsquare:team',
    PROJECT: 'ati:cloud:townsquare:project'
};
const $7387c4ee4c968c68$export$9449803ae25a1ccd = $7387c4ee4c968c68$export$c091fab9d8f83000.LOOM;
module.exports["ANALYTICS_CHANNEL"] = $7387c4ee4c968c68$export$85183a312807388d;
module.exports["ANALYTICS_TAG"] = $7387c4ee4c968c68$export$1f0ede2864ffece6;
module.exports["NAV_LAYER"] = $7387c4ee4c968c68$export$40fae459cb78b698;
module.exports["NAV_CONTAINER"] = $7387c4ee4c968c68$export$2ee98aa1b18a8f41;
module.exports["NAV_VERSION"] = $7387c4ee4c968c68$export$b4ed8a331b8fd4cc;
module.exports["ANALYTICS_SOURCE"] = $7387c4ee4c968c68$export$f7109619a5e9e0d6;
module.exports["ATI_PRESETS"] = $7387c4ee4c968c68$export$c091fab9d8f83000;
module.exports["LOOM_ATI"] = $7387c4ee4c968c68$export$9449803ae25a1ccd;

});

parcelRegister("i2kCO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2e0f4708d02b569e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2e0f4708d02b569e$export$2e2bcd8739ae039 = {
    VzzYJk: 'Create',
    'goal-create-success-flag-action': 'Go to goal',
    'goal-create-success-flag-title': 'Goal has been created',
    'navigation.universal-create.menuItemLoading': 'Menu item is loading',
    'platform.navigation-experiences.universal-create.integrations.form-loading': 'Loading',
    'platform.navigation-experiences.universal-create.integrations.team.create-error-flag-title': 'Sorry, something went wrong',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-go-to-team': 'View team',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-title': 'Team has been created',
    'platform.navigation-experiences.universal-create.project.create-error-flag-description': 'There was an error while creating your project. Please try again.',
    'platform.navigation-experiences.universal-create.project.create-error-flag-title': "We couldn't create your project",
    'platform.navigation-experiences.universal-create.project.create-success-flag-content': 'Go to project',
    'platform.navigation-experiences.universal-create.project.create-success-flag-title': 'Project has been created',
    'platform.navigation-experiences.universal-create.remote-section-heading': 'Suggestions',
    'platform.navigation-experiences.universal-create.show-less': 'Less',
    'platform.navigation-experiences.universal-create.show-more': 'More',
    'platform.navigation-experiences.universal-create.suggestion.section-heading': '{count, plural, one {Suggestion} other {Suggestions}}',
    'universal-create.loom-video-menu-item.create-loom-video': 'Loom video',
    'universal-create.loom-video-menu-item.share-video': 'Share'
};

});

parcelRegister("4DBlL", function(module, exports) {

let $3607c6dd4bca7053$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3607c6dd4bca7053$var$load("46t5f").then(()=>parcelRequire('2nrO6'));

});

parcelRegister("QiHJH", function(module, exports) {

let $09d35dc07c3f53c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09d35dc07c3f53c0$var$load("1YqfS").then(()=>parcelRequire('cmlqi'));

});

parcelRegister("5fKfY", function(module, exports) {

let $3d323c0b9ff3507e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d323c0b9ff3507e$var$load("9DYyx").then(()=>parcelRequire('lbNO6'));

});

parcelRegister("bd60H", function(module, exports) {

let $829592226ac5d9b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $829592226ac5d9b4$var$load("42ZJx").then(()=>parcelRequire('egI7t'));

});

parcelRegister("lhFMp", function(module, exports) {

let $f7eb9814fa81261d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7eb9814fa81261d$var$load("jtt0C").then(()=>parcelRequire('gkIoe'));

});

parcelRegister("lkfj4", function(module, exports) {

let $f86756cad7363fec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f86756cad7363fec$var$load("3vk3N").then(()=>parcelRequire('B195q'));

});

parcelRegister("7i5RS", function(module, exports) {

let $54eec418d2bda09e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54eec418d2bda09e$var$load("hbGGN").then(()=>parcelRequire('j0Mtc'));

});

parcelRegister("k04cn", function(module, exports) {

let $e8f7107c0ef79cdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8f7107c0ef79cdb$var$load("dopc8").then(()=>parcelRequire('8fG30'));

});

parcelRegister("lkAKZ", function(module, exports) {

let $f877fa6788db847d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f877fa6788db847d$var$load("9RJgs").then(()=>parcelRequire('kh2Eq'));

});

parcelRegister("gGAak", function(module, exports) {

let $c25c9f54fb8c6898$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c25c9f54fb8c6898$var$load("jo6RJ").then(()=>parcelRequire('klvFQ'));

});

parcelRegister("4tZ4k", function(module, exports) {

let $34393ddc80962779$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34393ddc80962779$var$load("lKoae").then(()=>parcelRequire('fXwAq'));

});

parcelRegister("8pvft", function(module, exports) {

let $61f8e5d7d86bc7b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61f8e5d7d86bc7b4$var$load("1MIK8").then(()=>parcelRequire('8ZHVH'));

});

parcelRegister("hgimn", function(module, exports) {

let $c9122c2aaae4ba3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9122c2aaae4ba3b$var$load("jh74O").then(()=>parcelRequire('5kpn9'));

});

parcelRegister("lSter", function(module, exports) {

let $fed550f81f03cdfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fed550f81f03cdfd$var$load("alBoB").then(()=>parcelRequire('cql7z'));

});

parcelRegister("lqL92", function(module, exports) {

let $f9a098a6bb598d2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9a098a6bb598d2c$var$load("fwQyo").then(()=>parcelRequire('gYqMF'));

});

parcelRegister("4n76O", function(module, exports) {

let $32eed3125117c801$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32eed3125117c801$var$load("jnFv5").then(()=>parcelRequire('oyKRX'));

});

parcelRegister("4tj0T", function(module, exports) {

let $34189e868e18467b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34189e868e18467b$var$load("3wEVm").then(()=>parcelRequire('9FWL3'));

});

parcelRegister("kxm5g", function(module, exports) {

let $ef3805190066c0ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ef3805190066c0ae$var$load("1AYDD").then(()=>parcelRequire('5SliH'));

});

parcelRegister("gm7mX", function(module, exports) {

let $be846acecf57dbc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be846acecf57dbc9$var$load("503rY").then(()=>parcelRequire('ecW9b'));

});

parcelRegister("kuMWv", function(module, exports) {

let $eebc92fc4bed7c07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eebc92fc4bed7c07$var$load("h5gGf").then(()=>parcelRequire('lGdFo'));

});

parcelRegister("c9eij", function(module, exports) {

let $8d8169e24e713ab7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d8169e24e713ab7$var$load("kgjXg").then(()=>parcelRequire('jf2AA'));

});

parcelRegister("ejhdq", function(module, exports) {

let $a6b031af64134360$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a6b031af64134360$var$load("jvpmI").then(()=>parcelRequire('50EZL'));

});

parcelRegister("bazzC", function(module, exports) {

let $821c39039eb64b47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $821c39039eb64b47$var$load("8ajSg").then(()=>parcelRequire('dZU7K'));

});

parcelRegister("jg5rQ", function(module, exports) {

let $e053bcd6d21f570b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e053bcd6d21f570b$var$load("cz5Vg").then(()=>parcelRequire('7yjbB'));

});

parcelRegister("6lFYf", function(module, exports) {

var $4jETc = parcelRequire("4jETc");

const $4553d074abf99d69$var$packageName = "platform-pkg";
const $4553d074abf99d69$var$packageVersion = "0.0.0-use.local";
var $4553d074abf99d69$export$2e2bcd8739ae039 = {
    packageName: $4553d074abf99d69$var$packageName,
    packageVersion: $4553d074abf99d69$var$packageVersion
};


function $1d9cedda3a5081bf$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $1d9cedda3a5081bf$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $4553d074abf99d69$export$2e2bcd8739ae039).packageVersion,
                ...init?.headers
            }
        });
        const jsonResponse = await response.json();
        return {
            status: (0, $4jETc.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $4jETc.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}
module.exports["isLocalHost"] = $1d9cedda3a5081bf$export$f931afb2c5ecf7c7;
module.exports["fetchJSON"] = $1d9cedda3a5081bf$export$81bec6e38e8b706b;

});

parcelRegister("iAFAo", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

const $abc574e5bd82b638$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...text
    });
};
const $abc574e5bd82b638$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
const $abc574e5bd82b638$export$e57a6793604f15ac = (atiArray)=>{
    return atiArray && atiArray.length > 0 ? atiArray.join(',') : undefined;
};
module.exports["formatText"] = $abc574e5bd82b638$export$905fe28a7c283e1d;
module.exports["sortAlphabetically"] = $abc574e5bd82b638$export$60f5d4abb43a14b3;
module.exports["atiArrayToParams"] = $abc574e5bd82b638$export$e57a6793604f15ac;

});

parcelRegister("ik19A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4jETc = parcelRequire("4jETc");


var $caUKj = parcelRequire("caUKj");

function $745446d53837e3a6$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const isInitializing = (0, $42omo.useMemo)(()=>status === (0, $4jETc.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $42omo.useMemo)(()=>status === (0, $4jETc.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $42omo.useMemo)(()=>status === (0, $4jETc.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>status === (0, $4jETc.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $42omo.useMemo)(()=>status !== (0, $4jETc.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $42omo.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $4jETc.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $4jETc.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $4jETc.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $42omo.useCallback)((newStatus, integratingComponent)=>{
        if (newStatus === (0, $4jETc.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).LOADING);
        if (newStatus === (0, $4jETc.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $4jETc.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).ERROR);
        }
        // Don't allow the status to be marked as anything other than ERROR
        // if an error is pre-existing
        setValue((prev)=>{
            if (prev.status === (0, $4jETc.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: newStatus === (0, $4jETc.RequestStatus).ERROR ? (0, $4jETc.RequestStatus).ERROR : (0, $4jETc.RequestStatus).LOADING
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        status: status,
        isInitializing: isInitializing,
        isComplete: isComplete,
        isError: isError,
        isLoading: isLoading,
        isLoaded: isLoaded,
        setStatus: setStatus
    };
}
module.exports["useStatus"] = $745446d53837e3a6$export$53cc6abb6942ce72;

});

parcelRegister("cdX3N", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4jETc = parcelRequire("4jETc");


var $6lFYf = parcelRequire("6lFYf");


var $iAFAo = parcelRequire("iAFAo");


var $6Tx9o = parcelRequire("6Tx9o");





var $caUKj = parcelRequire("caUKj");

function $9c1427a12622d9c5$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $42omo.useContext)((0, $caUKj.BFFContext));
    return {
        consumer: consumer
    };
}






var $l998X = parcelRequire("l998X");




const $35a22a28e791828e$var$BFFOriginUrlContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $35a22a28e791828e$export$405f92d0950d3d4f = ({ children: children, url: url })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($35a22a28e791828e$var$BFFOriginUrlContext.Provider, {
        value: url,
        children: children
    });
};
const $35a22a28e791828e$export$13a55721f6e3a9e = ()=>{
    return (0, $42omo.useContext)($35a22a28e791828e$var$BFFOriginUrlContext);
};


/**
 * Hooks that returns the context of a forced origin url if FG is enabled and forceOriginUrl is provided to the context
 */ const $4478d364359c007a$var$useOriginUrl = ()=>{
    const context = (0, $35a22a28e791828e$export$13a55721f6e3a9e)();
    if (!(0, $dh538.fg)('navx-1147-support-global-shortcuts-locally')) return undefined;
    return context;
};
var $4478d364359c007a$export$2e2bcd8739ae039 = $4478d364359c007a$var$useOriginUrl;


var $e5af1279e152c705$export$92af951f33a9009c = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["SUGGESTIONS"] = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
    BFFEndpointsEnum["MENU_ITEMS_V2"] = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
    return BFFEndpointsEnum;
}({});
function $e5af1279e152c705$export$3748aab334e7d372({ cloudId: cloudId, userId: userId, product: product }) {
    const { consumer: consumer } = (0, $9c1427a12622d9c5$export$33062d550933de6f)();
    const { items: cachedItems } = (0, $6Tx9o.useCache)();
    const originUrl = (0, $4478d364359c007a$export$2e2bcd8739ae039)();
    const buildUCRecommendationURL = (0, $42omo.useCallback)(({ product: product, orgId: orgId, userId: userId, locale: locale, subProduct: subProduct, nativeAtis: nativeAtis, excludeAtis: excludeAtis, preferredAtis: preferredAtis })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
        const url = new URL(`${(0, $dh538.fg)('navx-1147-support-global-shortcuts-locally') ? getOriginUrl({
            originUrl: originUrl
        }) : getHomeUrl()}${baseUrl}`);
        const searchParams = new URLSearchParams();
        const queryParams = {
            tenantid: cloudId,
            product: product,
            orgid: orgId,
            userid: userId,
            source: consumer,
            locale: locale,
            subproduct: subProduct,
            nativeatis: (0, $iAFAo.atiArrayToParams)(nativeAtis),
            excludeatis: (0, $iAFAo.atiArrayToParams)(excludeAtis),
            preferredatis: (0, $iAFAo.atiArrayToParams)(preferredAtis)
        };
        Object.entries(queryParams).forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        consumer,
        cloudId,
        originUrl
    ]);
    const buildUCMenuItemsURL = (0, $42omo.useCallback)(({ product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
        const url = new URL(`${(0, $dh538.fg)('navx-1147-support-global-shortcuts-locally') ? getOriginUrl({
            originUrl: originUrl
        }) : getHomeUrl()}${baseUrl}`);
        const searchParams = new URLSearchParams();
        // Maintain specific order: tenantid, product, orgid, userid, source, then other params
        const queryParams = [
            [
                'tenantid',
                cloudId
            ],
            [
                'product',
                productParam || product
            ],
            [
                'orgid',
                orgId
            ],
            [
                'userid',
                userIdParam || userId
            ],
            [
                'source',
                consumer
            ],
            [
                'locale',
                locale
            ],
            [
                'subproduct',
                subProduct
            ],
            [
                'd',
                d
            ],
            [
                'ro',
                ro
            ],
            [
                'rt',
                rt
            ],
            [
                'ap',
                ap
            ]
        ];
        queryParams.forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        cloudId,
        product,
        userId,
        consumer,
        originUrl
    ]);
    const buildProductShortcutURL = (0, $42omo.useCallback)(({ baseUrl: baseUrl })=>{
        baseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (cachedItems.length > 0) return '';
        const queryValues = '';
        return `${(0, $dh538.fg)('navx-1147-support-global-shortcuts-locally') ? getOriginUrl({
            originUrl: originUrl
        }) : getHomeUrl()}${baseUrl}?${queryValues}`;
    }, [
        cachedItems,
        originUrl
    ]);
    const buildURL = (0, $42omo.useCallback)(({ baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${(0, $dh538.fg)('navx-1147-support-global-shortcuts-locally') ? getOriginUrl({
            originUrl: originUrl
        }) : getHomeUrl()}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $4jETc.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({});
                break;
            case (0, $4jETc.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url = buildProductShortcutURL({});
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        const formattedUrl = new URL(url);
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        if (userId) updatedParams.append('userid', userId);
        if (product) updatedParams.append('product', product);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId,
        userId,
        product,
        originUrl
    ]);
    const getHomeUrl = ()=>{
        if ((0, $6lFYf.isLocalHost)()) return 'https://home.stg.atlassian.com';
        return new URL(window.location.href).origin;
    };
    const getOriginUrl = ({ originUrl: originUrl } = {})=>originUrl || new URL(window.location.href).origin;
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCRecommendationURL: buildUCRecommendationURL,
        buildUCMenuItemsURL: buildUCMenuItemsURL
    };
}
module.exports["useURLBuilder"] = $e5af1279e152c705$export$3748aab334e7d372;

});

parcelRegister("6Tx9o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $caUKj = parcelRequire("caUKj");

function $a3b98e022000e430$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $42omo.useContext)((0, $caUKj.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $42omo.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $42omo.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $42omo.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $42omo.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        updateCacheKey: updateCacheKey,
        cacheKey: cacheKey,
        items: items
    };
}
module.exports["useCache"] = $a3b98e022000e430$export$c6e89b6bb9436bc0;

});

parcelRegister("80GhR", function(module, exports) {

let $5d4f20289b8a39de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d4f20289b8a39de$var$load("9eHZt"),
    $5d4f20289b8a39de$var$load("bXz3w"),
    $5d4f20289b8a39de$var$load("5cueC"),
    $5d4f20289b8a39de$var$load("aeEUI"),
    $5d4f20289b8a39de$var$load("awqCy"),
    $5d4f20289b8a39de$var$load("5465r"),
    $5d4f20289b8a39de$var$load("fkY2m"),
    $5d4f20289b8a39de$var$load("gwV0J"),
    $5d4f20289b8a39de$var$load("3t6fF"),
    $5d4f20289b8a39de$var$load("6wr18"),
    $5d4f20289b8a39de$var$load("59349"),
    $5d4f20289b8a39de$var$load("jtcRz"),
    $5d4f20289b8a39de$var$load("1Pok1"),
    $5d4f20289b8a39de$var$load("b2UJh"),
    $5d4f20289b8a39de$var$load("lkOIY"),
    $5d4f20289b8a39de$var$load("bduA7"),
    $5d4f20289b8a39de$var$load("l8LQp"),
    $5d4f20289b8a39de$var$load("iXzmH"),
    $5d4f20289b8a39de$var$load("65c4i"),
    $5d4f20289b8a39de$var$load("5fSdR"),
    $5d4f20289b8a39de$var$load("kHOMt"),
    $5d4f20289b8a39de$var$load("hhss7"),
    $5d4f20289b8a39de$var$load("ffEVr"),
    $5d4f20289b8a39de$var$load("Wowvf"),
    $5d4f20289b8a39de$var$load("6Yu8N"),
    $5d4f20289b8a39de$var$load("7EorR"),
    $5d4f20289b8a39de$var$load("eZu0L")
]).then(()=>parcelRequire('dwZXA'));

});

parcelRegister("jfkWB", function(module, exports) {

let $e02faa1b2b293398$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e02faa1b2b293398$var$load("bXz3w"),
    $e02faa1b2b293398$var$load("5cueC"),
    $e02faa1b2b293398$var$load("5465r"),
    $e02faa1b2b293398$var$load("fkY2m"),
    $e02faa1b2b293398$var$load("gwV0J"),
    $e02faa1b2b293398$var$load("3t6fF"),
    $e02faa1b2b293398$var$load("6wr18"),
    $e02faa1b2b293398$var$load("59349"),
    $e02faa1b2b293398$var$load("ggnY8"),
    $e02faa1b2b293398$var$load("jvHRs"),
    $e02faa1b2b293398$var$load("fkeSV"),
    $e02faa1b2b293398$var$load("9XYQ9"),
    $e02faa1b2b293398$var$load("iXzmH"),
    $e02faa1b2b293398$var$load("65c4i"),
    $e02faa1b2b293398$var$load("5fSdR"),
    $e02faa1b2b293398$var$load("7EorR"),
    $e02faa1b2b293398$var$load("kHOMt"),
    $e02faa1b2b293398$var$load("hhss7"),
    $e02faa1b2b293398$var$load("ffEVr"),
    $e02faa1b2b293398$var$load("Wowvf"),
    $e02faa1b2b293398$var$load("6Yu8N"),
    $e02faa1b2b293398$var$load("g55vn")
]).then(()=>parcelRequire('6mjFu'));

});

parcelRegister("ibcnC", function(module, exports) {

let $d3c2db7f6a344302$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3c2db7f6a344302$var$load("5465r"),
    $d3c2db7f6a344302$var$load("fkY2m"),
    $d3c2db7f6a344302$var$load("6wr18"),
    $d3c2db7f6a344302$var$load("59349"),
    $d3c2db7f6a344302$var$load("69G8x"),
    $d3c2db7f6a344302$var$load("7EorR"),
    $d3c2db7f6a344302$var$load("5fSdR"),
    $d3c2db7f6a344302$var$load("kHOMt"),
    $d3c2db7f6a344302$var$load("hhss7"),
    $d3c2db7f6a344302$var$load("Wowvf"),
    $d3c2db7f6a344302$var$load("ffEVr"),
    $d3c2db7f6a344302$var$load("6Yu8N"),
    $d3c2db7f6a344302$var$load("hjuEj")
]).then(()=>parcelRequire('lG4Ng'));

});

parcelRegister("53z01", function(module, exports) {

let $3ae861b2f6a8e7ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ae861b2f6a8e7ee$var$load("hLVzM").then(()=>parcelRequire('e2ZTm'));

});

parcelRegister("036Ie", function(module, exports) {

let $00957ce6b4fad64a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $00957ce6b4fad64a$var$load("lRtGG").then(()=>parcelRequire('4ayWZ'));

});

parcelRegister("k8V49", function(module, exports) {

let $eaa0d21f1803064b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eaa0d21f1803064b$var$load("adH3p").then(()=>parcelRequire('f6IRL'));

});

parcelRegister("fq08g", function(module, exports) {

let $b39962ff7045cd7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b39962ff7045cd7b$var$load("4Jbf1").then(()=>parcelRequire('1qW0V'));

});

parcelRegister("eNNHQ", function(module, exports) {

let $ac6c32e5c80c429d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac6c32e5c80c429d$var$load("k97iL").then(()=>parcelRequire('lFkSe'));

});

parcelRegister("ji6i4", function(module, exports) {

let $e0b493e7dacf4679$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0b493e7dacf4679$var$load("5BMnr").then(()=>parcelRequire('6uENn'));

});

parcelRegister("aWuvK", function(module, exports) {

let $7f76fd05798145a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f76fd05798145a7$var$load("lwKXH"),
    $7f76fd05798145a7$var$load("4byV5")
]).then(()=>parcelRequire('3f9PV'));

});

parcelRegister("11pmp", function(module, exports) {

let $0be98e8283cc61a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0be98e8283cc61a7$var$load("lkOIY"),
    $0be98e8283cc61a7$var$load("5465r"),
    $0be98e8283cc61a7$var$load("fkY2m"),
    $0be98e8283cc61a7$var$load("gwV0J"),
    $0be98e8283cc61a7$var$load("3t6fF"),
    $0be98e8283cc61a7$var$load("6wr18"),
    $0be98e8283cc61a7$var$load("a3Uq6"),
    $0be98e8283cc61a7$var$load("xvDzM"),
    $0be98e8283cc61a7$var$load("jle6Z"),
    $0be98e8283cc61a7$var$load("4drdS"),
    $0be98e8283cc61a7$var$load("lLK0D"),
    $0be98e8283cc61a7$var$load("9LQGG"),
    $0be98e8283cc61a7$var$load("wIOhQ"),
    $0be98e8283cc61a7$var$load("lwKXH"),
    $0be98e8283cc61a7$var$load("fisfU"),
    $0be98e8283cc61a7$var$load("ffEVr"),
    $0be98e8283cc61a7$var$load("7EorR"),
    $0be98e8283cc61a7$var$load("btYwu")
]).then(()=>parcelRequire('fIeud'));

});

parcelRegister("dv953", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $41db8bac43dc4cde$export$61de563e38fe014d() {
    const fetchUser = (0, $42omo.useCallback)(async ()=>{
        try {
            const response = await fetch('/gateway/api/me', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) return undefined;
            const userData = await response.json();
            return userData;
        } catch (err) {
            return undefined;
        }
    }, []);
    return {
        fetchUser: fetchUser
    };
}
module.exports["useFetchUser"] = $41db8bac43dc4cde$export$61de563e38fe014d;

});

parcelRegister("dcUvx", function(module, exports) {
module.exports = new URL("Racecar.f378b1ee.svg", import.meta.url).toString();

});


//# sourceMappingURL=CreateComponent.4925cf1a.js.map
